(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3558"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3558"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bTckq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8a7e64f151a1182a$export$2e2bcd8739ae039; });
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 
var $4O7eo = parcelRequire("4O7eo");

var $2pUbr = parcelRequire("2pUbr");

var $7rdwR = parcelRequire("7rdwR");

var $grkAU = parcelRequire("grkAU");

var $kYVXT = parcelRequire("kYVXT");

var $e9Ixt = parcelRequire("e9Ixt");

var $8rcLS = parcelRequire("8rcLS");

var $8IHbY = parcelRequire("8IHbY");
/**
 * Constants
 */ const $8a7e64f151a1182a$var$NAME = 'modal';
const $8a7e64f151a1182a$var$DATA_KEY = 'bs.modal';
const $8a7e64f151a1182a$var$EVENT_KEY = `.${$8a7e64f151a1182a$var$DATA_KEY}`;
const $8a7e64f151a1182a$var$DATA_API_KEY = '.data-api';
const $8a7e64f151a1182a$var$ESCAPE_KEY = 'Escape';
const $8a7e64f151a1182a$var$EVENT_HIDE = `hide${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_HIDE_PREVENTED = `hidePrevented${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_HIDDEN = `hidden${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_SHOW = `show${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_SHOWN = `shown${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_RESIZE = `resize${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_CLICK_DISMISS = `click.dismiss${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_CLICK_DATA_API = `click${$8a7e64f151a1182a$var$EVENT_KEY}${$8a7e64f151a1182a$var$DATA_API_KEY}`;
const $8a7e64f151a1182a$var$CLASS_NAME_OPEN = 'modal-open';
const $8a7e64f151a1182a$var$CLASS_NAME_FADE = 'fade';
const $8a7e64f151a1182a$var$CLASS_NAME_SHOW = 'show';
const $8a7e64f151a1182a$var$CLASS_NAME_STATIC = 'modal-static';
const $8a7e64f151a1182a$var$OPEN_SELECTOR = '.modal.show';
const $8a7e64f151a1182a$var$SELECTOR_DIALOG = '.modal-dialog';
const $8a7e64f151a1182a$var$SELECTOR_MODAL_BODY = '.modal-body';
const $8a7e64f151a1182a$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="modal"]';
const $8a7e64f151a1182a$var$Default = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $8a7e64f151a1182a$var$DefaultType = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $8a7e64f151a1182a$var$Modal extends (0, $4O7eo.default) {
    constructor(element, config){
        super(element, config);
        this._dialog = (0, $7rdwR.default).findOne($8a7e64f151a1182a$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new (0, $8IHbY.default)();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $8a7e64f151a1182a$var$Default;
    }
    static get DefaultType() {
        return $8a7e64f151a1182a$var$DefaultType;
    }
    static get NAME() {
        return $8a7e64f151a1182a$var$NAME;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = (0, $2pUbr.default).trigger(this._element, $8a7e64f151a1182a$var$EVENT_SHOW, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($8a7e64f151a1182a$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = (0, $2pUbr.default).trigger(this._element, $8a7e64f151a1182a$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($8a7e64f151a1182a$var$CLASS_NAME_SHOW);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        (0, $2pUbr.default).off(window, $8a7e64f151a1182a$var$EVENT_KEY);
        (0, $2pUbr.default).off(this._dialog, $8a7e64f151a1182a$var$EVENT_KEY);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new (0, $grkAU.default)({
            isVisible: Boolean(this._config.backdrop),
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new (0, $e9Ixt.default)({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = (0, $7rdwR.default).findOne($8a7e64f151a1182a$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        (0, $8rcLS.reflow)(this._element);
        this._element.classList.add($8a7e64f151a1182a$var$CLASS_NAME_SHOW);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            (0, $2pUbr.default).trigger(this._element, $8a7e64f151a1182a$var$EVENT_SHOWN, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        (0, $2pUbr.default).on(this._element, $8a7e64f151a1182a$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $8a7e64f151a1182a$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        (0, $2pUbr.default).on(window, $8a7e64f151a1182a$var$EVENT_RESIZE, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        (0, $2pUbr.default).on(this._element, $8a7e64f151a1182a$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            (0, $2pUbr.default).one(this._element, $8a7e64f151a1182a$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($8a7e64f151a1182a$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            (0, $2pUbr.default).trigger(this._element, $8a7e64f151a1182a$var$EVENT_HIDDEN);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($8a7e64f151a1182a$var$CLASS_NAME_FADE);
    }
    _triggerBackdropTransition() {
        const hideEvent = (0, $2pUbr.default).trigger(this._element, $8a7e64f151a1182a$var$EVENT_HIDE_PREVENTED);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($8a7e64f151a1182a$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($8a7e64f151a1182a$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($8a7e64f151a1182a$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = (0, $8rcLS.isRTL)() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = (0, $8rcLS.isRTL)() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $8a7e64f151a1182a$var$Modal.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ (0, $2pUbr.default).on(document, $8a7e64f151a1182a$var$EVENT_CLICK_DATA_API, $8a7e64f151a1182a$var$SELECTOR_DATA_TOGGLE, function(event) {
    const target = (0, $7rdwR.default).getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    (0, $2pUbr.default).one(target, $8a7e64f151a1182a$var$EVENT_SHOW, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        (0, $2pUbr.default).one(target, $8a7e64f151a1182a$var$EVENT_HIDDEN, ()=>{
            if ((0, $8rcLS.isVisible)(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = (0, $7rdwR.default).findOne($8a7e64f151a1182a$var$OPEN_SELECTOR);
    if (alreadyOpen) $8a7e64f151a1182a$var$Modal.getInstance(alreadyOpen).hide();
    const data = $8a7e64f151a1182a$var$Modal.getOrCreateInstance(target);
    data.toggle(this);
});
(0, $kYVXT.enableDismissTrigger)($8a7e64f151a1182a$var$Modal);
/**
 * jQuery
 */ (0, $8rcLS.defineJQueryPlugin)($8a7e64f151a1182a$var$Modal);
var $8a7e64f151a1182a$export$2e2bcd8739ae039 = $8a7e64f151a1182a$var$Modal;

});
parcelRegister("4O7eo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $380170e9fa23ab96$export$2e2bcd8739ae039; });
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 
var $1rNFH = parcelRequire("1rNFH");

var $2pUbr = parcelRequire("2pUbr");

var $aDC2i = parcelRequire("aDC2i");

var $8rcLS = parcelRequire("8rcLS");
/**
 * Constants
 */ const $380170e9fa23ab96$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $380170e9fa23ab96$var$BaseComponent extends (0, $aDC2i.default) {
    constructor(element, config){
        super();
        element = (0, $8rcLS.getElement)(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        (0, $1rNFH.default).set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        (0, $1rNFH.default).remove(this._element, this.constructor.DATA_KEY);
        (0, $2pUbr.default).off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        (0, $8rcLS.executeAfterTransition)(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return (0, $1rNFH.default).get((0, $8rcLS.getElement)(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $380170e9fa23ab96$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
var $380170e9fa23ab96$export$2e2bcd8739ae039 = $380170e9fa23ab96$var$BaseComponent;

});
parcelRegister("1rNFH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10ded7cf756b400f$export$2e2bcd8739ae039; });
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $10ded7cf756b400f$var$elementMap = new Map();
var $10ded7cf756b400f$export$2e2bcd8739ae039 = {
    set (element, key, instance) {
        if (!$10ded7cf756b400f$var$elementMap.has(element)) $10ded7cf756b400f$var$elementMap.set(element, new Map());
        const instanceMap = $10ded7cf756b400f$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($10ded7cf756b400f$var$elementMap.has(element)) return $10ded7cf756b400f$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$10ded7cf756b400f$var$elementMap.has(element)) return;
        const instanceMap = $10ded7cf756b400f$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $10ded7cf756b400f$var$elementMap.delete(element);
    }
};

});

parcelRegister("2pUbr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c297f733361d974$export$2e2bcd8739ae039; });
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 
var $8rcLS = parcelRequire("8rcLS");
/**
 * Constants
 */ const $1c297f733361d974$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $1c297f733361d974$var$stripNameRegex = /\..*/;
const $1c297f733361d974$var$stripUidRegex = /::\d+$/;
const $1c297f733361d974$var$eventRegistry = {} // Events storage
;
let $1c297f733361d974$var$uidEvent = 1;
const $1c297f733361d974$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $1c297f733361d974$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $1c297f733361d974$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$1c297f733361d974$var$uidEvent++}` || element.uidEvent || $1c297f733361d974$var$uidEvent++;
}
function $1c297f733361d974$var$getElementEvents(element) {
    const uid = $1c297f733361d974$var$makeEventUid(element);
    element.uidEvent = uid;
    $1c297f733361d974$var$eventRegistry[uid] = $1c297f733361d974$var$eventRegistry[uid] || {};
    return $1c297f733361d974$var$eventRegistry[uid];
}
function $1c297f733361d974$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $1c297f733361d974$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $1c297f733361d974$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $1c297f733361d974$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $1c297f733361d974$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $1c297f733361d974$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $1c297f733361d974$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $1c297f733361d974$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $1c297f733361d974$var$getTypeEvent(originalTypeEvent);
    if (!$1c297f733361d974$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $1c297f733361d974$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $1c297f733361d974$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $1c297f733361d974$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $1c297f733361d974$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $1c297f733361d974$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $1c297f733361d974$var$makeEventUid(callable, originalTypeEvent.replace($1c297f733361d974$var$namespaceRegex, ''));
    const fn = isDelegated ? $1c297f733361d974$var$bootstrapDelegationHandler(element, handler, callable) : $1c297f733361d974$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $1c297f733361d974$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $1c297f733361d974$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $1c297f733361d974$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $1c297f733361d974$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $1c297f733361d974$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($1c297f733361d974$var$stripNameRegex, '');
    return $1c297f733361d974$var$customEvents[event] || event;
}
const $1c297f733361d974$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $1c297f733361d974$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $1c297f733361d974$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $1c297f733361d974$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $1c297f733361d974$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $1c297f733361d974$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$1c297f733361d974$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($1c297f733361d974$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $1c297f733361d974$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = (0, $8rcLS.getjQuery)();
        const typeEvent = $1c297f733361d974$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $1c297f733361d974$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $1c297f733361d974$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch  {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
var $1c297f733361d974$export$2e2bcd8739ae039 = $1c297f733361d974$var$EventHandler;

});
parcelRegister("8rcLS", function(module, exports) {

$parcel$export(module.exports, "parseSelector", function () { return $624ac0747f128bc7$export$529769e360e2fa1b; });
$parcel$export(module.exports, "toType", function () { return $624ac0747f128bc7$export$2fe53163c7bc4eaf; });
$parcel$export(module.exports, "isElement", function () { return $624ac0747f128bc7$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "getElement", function () { return $624ac0747f128bc7$export$d16800b7e59a8051; });
$parcel$export(module.exports, "isVisible", function () { return $624ac0747f128bc7$export$795910f5f15a9633; });
$parcel$export(module.exports, "isDisabled", function () { return $624ac0747f128bc7$export$30e0dc115df457ed; });
$parcel$export(module.exports, "reflow", function () { return $624ac0747f128bc7$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getjQuery", function () { return $624ac0747f128bc7$export$74ab881f7fc208ab; });
$parcel$export(module.exports, "isRTL", function () { return $624ac0747f128bc7$export$702d680b21cbd764; });
$parcel$export(module.exports, "defineJQueryPlugin", function () { return $624ac0747f128bc7$export$6be86de4be20ff32; });
$parcel$export(module.exports, "execute", function () { return $624ac0747f128bc7$export$51396ec711da548b; });
$parcel$export(module.exports, "executeAfterTransition", function () { return $624ac0747f128bc7$export$d6cd5457cf4106ef; });
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $624ac0747f128bc7$var$MAX_UID = 1000000;
const $624ac0747f128bc7$var$MILLISECONDS_MULTIPLIER = 1000;
const $624ac0747f128bc7$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $624ac0747f128bc7$export$529769e360e2fa1b = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $624ac0747f128bc7$export$2fe53163c7bc4eaf = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $624ac0747f128bc7$export$6d2b3473b0986646 = (prefix)=>{
    do prefix += Math.floor(Math.random() * $624ac0747f128bc7$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $624ac0747f128bc7$export$530d045e570efb0f = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $624ac0747f128bc7$var$MILLISECONDS_MULTIPLIER;
};
const $624ac0747f128bc7$export$201d3c8336a47e6c = (element)=>{
    element.dispatchEvent(new Event($624ac0747f128bc7$var$TRANSITION_END));
};
const $624ac0747f128bc7$export$45a5e7f76e0caa8d = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $624ac0747f128bc7$export$d16800b7e59a8051 = (object)=>{
    // it's a jQuery object or a node element
    if ($624ac0747f128bc7$export$45a5e7f76e0caa8d(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($624ac0747f128bc7$export$529769e360e2fa1b(object));
    return null;
};
const $624ac0747f128bc7$export$795910f5f15a9633 = (element)=>{
    if (!$624ac0747f128bc7$export$45a5e7f76e0caa8d(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $624ac0747f128bc7$export$30e0dc115df457ed = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $624ac0747f128bc7$export$1a538cc28c24d2ec = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $624ac0747f128bc7$export$1a538cc28c24d2ec(element.parentNode);
};
const $624ac0747f128bc7$export$8793edee2d425525 = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $624ac0747f128bc7$export$b7a864e1eaef9de5 = (element)=>{
    element.offsetHeight // eslint-disable-line no-unused-expressions
    ;
};
const $624ac0747f128bc7$export$74ab881f7fc208ab = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $624ac0747f128bc7$var$DOMContentLoadedCallbacks = [];
const $624ac0747f128bc7$export$62028ff70825ead9 = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$624ac0747f128bc7$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $624ac0747f128bc7$var$DOMContentLoadedCallbacks)callback();
        });
        $624ac0747f128bc7$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $624ac0747f128bc7$export$702d680b21cbd764 = ()=>document.documentElement.dir === 'rtl';
const $624ac0747f128bc7$export$6be86de4be20ff32 = (plugin)=>{
    $624ac0747f128bc7$export$62028ff70825ead9(()=>{
        const $ = $624ac0747f128bc7$export$74ab881f7fc208ab();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $624ac0747f128bc7$export$51396ec711da548b = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $624ac0747f128bc7$export$d6cd5457cf4106ef = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $624ac0747f128bc7$export$51396ec711da548b(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $624ac0747f128bc7$export$530d045e570efb0f(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($624ac0747f128bc7$var$TRANSITION_END, handler);
        $624ac0747f128bc7$export$51396ec711da548b(callback);
    };
    transitionElement.addEventListener($624ac0747f128bc7$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $624ac0747f128bc7$export$201d3c8336a47e6c(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $624ac0747f128bc7$export$7bc25e2173fc3d1f = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};

});


parcelRegister("aDC2i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7beb0d0c06e1a235$export$2e2bcd8739ae039; });
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 
var $8p5k3 = parcelRequire("8p5k3");

var $8rcLS = parcelRequire("8rcLS");
/**
 * Class definition
 */ class $7beb0d0c06e1a235$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = (0, $8rcLS.isElement)(element) ? (0, $8p5k3.default).getDataAttribute(element, 'config') : {} // try to parse
        ;
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...(0, $8rcLS.isElement)(element) ? (0, $8p5k3.default).getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = (0, $8rcLS.isElement)(value) ? 'element' : (0, $8rcLS.toType)(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
var $7beb0d0c06e1a235$export$2e2bcd8739ae039 = $7beb0d0c06e1a235$var$Config;

});
parcelRegister("8p5k3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61e4c97070b47d88$export$2e2bcd8739ae039; });
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $61e4c97070b47d88$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch  {
        return value;
    }
}
function $61e4c97070b47d88$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $61e4c97070b47d88$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$61e4c97070b47d88$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$61e4c97070b47d88$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $61e4c97070b47d88$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $61e4c97070b47d88$var$normalizeData(element.getAttribute(`data-bs-${$61e4c97070b47d88$var$normalizeDataKey(key)}`));
    }
};
var $61e4c97070b47d88$export$2e2bcd8739ae039 = $61e4c97070b47d88$var$Manipulator;

});



parcelRegister("7rdwR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56a58c95834dffd7$export$2e2bcd8739ae039; });
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 
var $8rcLS = parcelRequire("8rcLS");
const $56a58c95834dffd7$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>(0, $8rcLS.parseSelector)(sel)).join(',') : null;
};
const $56a58c95834dffd7$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!(0, $8rcLS.isDisabled)(el) && (0, $8rcLS.isVisible)(el));
    },
    getSelectorFromElement (element) {
        const selector = $56a58c95834dffd7$var$getSelector(element);
        if (selector) return $56a58c95834dffd7$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $56a58c95834dffd7$var$getSelector(element);
        return selector ? $56a58c95834dffd7$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $56a58c95834dffd7$var$getSelector(element);
        return selector ? $56a58c95834dffd7$var$SelectorEngine.find(selector) : [];
    }
};
var $56a58c95834dffd7$export$2e2bcd8739ae039 = $56a58c95834dffd7$var$SelectorEngine;

});

parcelRegister("grkAU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf7f248d3696c78e$export$2e2bcd8739ae039; });
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 
var $2pUbr = parcelRequire("2pUbr");

var $aDC2i = parcelRequire("aDC2i");

var $8rcLS = parcelRequire("8rcLS");
/**
 * Constants
 */ const $bf7f248d3696c78e$var$NAME = 'backdrop';
const $bf7f248d3696c78e$var$CLASS_NAME_FADE = 'fade';
const $bf7f248d3696c78e$var$CLASS_NAME_SHOW = 'show';
const $bf7f248d3696c78e$var$EVENT_MOUSEDOWN = `mousedown.bs.${$bf7f248d3696c78e$var$NAME}`;
const $bf7f248d3696c78e$var$Default = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $bf7f248d3696c78e$var$DefaultType = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $bf7f248d3696c78e$var$Backdrop extends (0, $aDC2i.default) {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $bf7f248d3696c78e$var$Default;
    }
    static get DefaultType() {
        return $bf7f248d3696c78e$var$DefaultType;
    }
    static get NAME() {
        return $bf7f248d3696c78e$var$NAME;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            (0, $8rcLS.execute)(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) (0, $8rcLS.reflow)(element);
        element.classList.add($bf7f248d3696c78e$var$CLASS_NAME_SHOW);
        this._emulateAnimation(()=>{
            (0, $8rcLS.execute)(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            (0, $8rcLS.execute)(callback);
            return;
        }
        this._getElement().classList.remove($bf7f248d3696c78e$var$CLASS_NAME_SHOW);
        this._emulateAnimation(()=>{
            this.dispose();
            (0, $8rcLS.execute)(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        (0, $2pUbr.default).off(this._element, $bf7f248d3696c78e$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($bf7f248d3696c78e$var$CLASS_NAME_FADE);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = (0, $8rcLS.getElement)(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        (0, $2pUbr.default).on(element, $bf7f248d3696c78e$var$EVENT_MOUSEDOWN, ()=>{
            (0, $8rcLS.execute)(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        (0, $8rcLS.executeAfterTransition)(callback, this._getElement(), this._config.isAnimated);
    }
}
var $bf7f248d3696c78e$export$2e2bcd8739ae039 = $bf7f248d3696c78e$var$Backdrop;

});

parcelRegister("kYVXT", function(module, exports) {

$parcel$export(module.exports, "enableDismissTrigger", function () { return $f4665fe10f4cce58$export$a6d6a0122b3f26ee; });
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 
var $2pUbr = parcelRequire("2pUbr");

var $7rdwR = parcelRequire("7rdwR");

var $8rcLS = parcelRequire("8rcLS");
const $f4665fe10f4cce58$export$a6d6a0122b3f26ee = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    (0, $2pUbr.default).on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ((0, $8rcLS.isDisabled)(this)) return;
        const target = (0, $7rdwR.default).getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};

});

parcelRegister("e9Ixt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4e4747603202ebf$export$2e2bcd8739ae039; });
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 
var $2pUbr = parcelRequire("2pUbr");

var $7rdwR = parcelRequire("7rdwR");

var $aDC2i = parcelRequire("aDC2i");
/**
 * Constants
 */ const $a4e4747603202ebf$var$NAME = 'focustrap';
const $a4e4747603202ebf$var$DATA_KEY = 'bs.focustrap';
const $a4e4747603202ebf$var$EVENT_KEY = `.${$a4e4747603202ebf$var$DATA_KEY}`;
const $a4e4747603202ebf$var$EVENT_FOCUSIN = `focusin${$a4e4747603202ebf$var$EVENT_KEY}`;
const $a4e4747603202ebf$var$EVENT_KEYDOWN_TAB = `keydown.tab${$a4e4747603202ebf$var$EVENT_KEY}`;
const $a4e4747603202ebf$var$TAB_KEY = 'Tab';
const $a4e4747603202ebf$var$TAB_NAV_FORWARD = 'forward';
const $a4e4747603202ebf$var$TAB_NAV_BACKWARD = 'backward';
const $a4e4747603202ebf$var$Default = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $a4e4747603202ebf$var$DefaultType = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $a4e4747603202ebf$var$FocusTrap extends (0, $aDC2i.default) {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $a4e4747603202ebf$var$Default;
    }
    static get DefaultType() {
        return $a4e4747603202ebf$var$DefaultType;
    }
    static get NAME() {
        return $a4e4747603202ebf$var$NAME;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        (0, $2pUbr.default).off(document, $a4e4747603202ebf$var$EVENT_KEY) // guard against infinite focus loop
        ;
        (0, $2pUbr.default).on(document, $a4e4747603202ebf$var$EVENT_FOCUSIN, (event)=>this._handleFocusin(event));
        (0, $2pUbr.default).on(document, $a4e4747603202ebf$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        (0, $2pUbr.default).off(document, $a4e4747603202ebf$var$EVENT_KEY);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = (0, $7rdwR.default).focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $a4e4747603202ebf$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $a4e4747603202ebf$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $a4e4747603202ebf$var$TAB_NAV_BACKWARD : $a4e4747603202ebf$var$TAB_NAV_FORWARD;
    }
}
var $a4e4747603202ebf$export$2e2bcd8739ae039 = $a4e4747603202ebf$var$FocusTrap;

});

parcelRegister("8IHbY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6593efd307f387da$export$2e2bcd8739ae039; });
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 
var $8p5k3 = parcelRequire("8p5k3");

var $7rdwR = parcelRequire("7rdwR");

var $8rcLS = parcelRequire("8rcLS");
/**
 * Constants
 */ const $6593efd307f387da$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $6593efd307f387da$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $6593efd307f387da$var$PROPERTY_PADDING = 'padding-right';
const $6593efd307f387da$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $6593efd307f387da$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $6593efd307f387da$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($6593efd307f387da$var$SELECTOR_FIXED_CONTENT, $6593efd307f387da$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($6593efd307f387da$var$SELECTOR_STICKY_CONTENT, $6593efd307f387da$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $6593efd307f387da$var$PROPERTY_PADDING);
        this._resetElementAttributes($6593efd307f387da$var$SELECTOR_FIXED_CONTENT, $6593efd307f387da$var$PROPERTY_PADDING);
        this._resetElementAttributes($6593efd307f387da$var$SELECTOR_STICKY_CONTENT, $6593efd307f387da$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) (0, $8p5k3.default).setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = (0, $8p5k3.default).getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            (0, $8p5k3.default).removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ((0, $8rcLS.isElement)(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of (0, $7rdwR.default).find(selector, this._element))callBack(sel);
    }
}
var $6593efd307f387da$export$2e2bcd8739ae039 = $6593efd307f387da$var$ScrollBarHelper;

});


parcelRegister("17fZ7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0d02d824f0688efc$var$getTaxPostMarkupByTermId;

var $0d02d824f0688efc$var$_replaceWithMarkup = $0d02d824f0688efc$var$_interopRequireDefault((parcelRequire("l4PXi")));
function $0d02d824f0688efc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 *
 * Loads taxonomy posts on Load More button click ( such as category archive posts )
 *
 * @param morePostsTrigger          Query string for triggering the loading and markup of posts.
 * @param elToReplaceWithPosts      Query string for node that new posts will replace.
 * @param taxonomy                  Name of the taxonomy
 * @param taxonomyTerm              Taxonomy term.
 * @param page                      Pagination index.
 */ function $0d02d824f0688efc$var$getTaxPostMarkupByTermId(morePostsTrigger, elToReplaceWithPosts, taxonomy, taxonomyTerm, page, categoryName = null) {
    // Retry mechanism if button not found immediately (for deferred scripts)
    const tryInitialize = (attempt = 0)=>{
        const trigger = document.querySelector(morePostsTrigger);
        if (!trigger && attempt < 5) {
            setTimeout(()=>tryInitialize(attempt + 1), 100);
            return;
        }
        if (!trigger) {
            console.error(`Element not found for selector: ${morePostsTrigger} after ${attempt} attempts`);
            return;
        }
        // Find the anchor tag inside the trigger
        const anchor = trigger.querySelector('a');
        if (!anchor) {
            console.error('No anchor tag found in load more button');
            return;
        }
        // Check if listener is already attached to this specific anchor
        if (anchor.hasAttribute('data-listener-attached')) return; // Already initialized
        anchor.setAttribute('data-listener-attached', 'true');
        // Attach listener to the anchor to prevent navigation
        // Also set href to javascript:void(0) to prevent navigation as backup
        if (anchor.href === '#' || anchor.getAttribute('href') === '#') anchor.href = 'javascript:void(0)';
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const btnOriginalHtml = anchor.innerHTML;
            anchor.innerHTML = '<div class="la-ball-pulse la-dark la-sm"><div></div><div></div><div></div></div>';
            $0d02d824f0688efc$var$getTaxonomyPostMarkupApiCall(taxonomy, taxonomyTerm, page, categoryName).then((res)=>{
                anchor.innerHTML = btnOriginalHtml;
                if (!res || !Array.isArray(res.posts) || res.posts.length === 0) {
                    if (res?.is_last_page) trigger.remove();
                    return;
                }
                const isContributorPage = document.querySelector('.contributor-archive');
                const markup = isContributorPage ? res.posts.join('') : res.posts.reduce((preVal, currVal)=>`${preVal}<li class="list-group-item">${currVal}</li>`, '');
                (0, $0d02d824f0688efc$var$_replaceWithMarkup.default)(trigger, markup, elToReplaceWithPosts, !res.is_last_page);
                if (!res.is_last_page) setTimeout(()=>{
                    const newTrigger = document.querySelector(morePostsTrigger);
                    if (newTrigger) {
                        newTrigger.querySelector('a')?.removeAttribute('data-listener-attached');
                        $0d02d824f0688efc$var$getTaxPostMarkupByTermId(morePostsTrigger, elToReplaceWithPosts, taxonomy, taxonomyTerm, ++page, categoryName);
                    }
                }, 200);
                else trigger.remove();
                if (typeof awUpdateArticleTimeOnCategoryPage === 'function') awUpdateArticleTimeOnCategoryPage();
            }).catch((err)=>{
                console.error('Error loading more posts:', err);
                anchor.innerHTML = btnOriginalHtml;
            });
        }, {
            once: true
        });
    };
    // Start initialization
    tryInitialize();
}
/**
 *
 * @param taxonomy
 * @param taxonomyTerm
 * @param page
 * @return {Promise<any>}
 */ async function $0d02d824f0688efc$var$getTaxonomyPostMarkupApiCall(taxonomy, taxonomyTerm, page = 1, categoryName = null) {
    // Build URL based on taxonomy type
    let url;
    if (taxonomy === 'contributor') {
        url = `${window.location.origin}/wp-json/adw-post/v1/post-index-markup/contributor/${taxonomyTerm}?page=${page}`;
        if (categoryName) url += `&categoryName=${categoryName}`;
    } else {
        url = `${window.location.origin}/wp-json/adw-post/v1/post-index-markup/${taxonomy}/${taxonomyTerm}?page=${page}`;
        if (categoryName) url += `&categoryName=${categoryName}`;
    }
    const response = await fetch(url);
    if (response.status !== 200) return {
        posts: [],
        is_last_page: true
    };
    const data = await response.json();
    if (Array.isArray(data)) return {
        posts: data,
        is_last_page: false
    };
    if (!data || typeof data !== 'object') return {
        posts: [],
        is_last_page: true
    };
    if (!Array.isArray(data.posts)) data.posts = [];
    if (data.posts.length === 0) data.is_last_page = true;
    return data;
}

});
parcelRegister("l4PXi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f58245f58448b4d4$var$replaceWithMarkup;
/**
 *
 * @param {object} trigger                   HTML node that is the trigger for loading more markup
 * @param {string | string[]} markup         markup that will replace HTML node.
 * @param {string} replaceWithMarkup         Query string for node that new posts will replace.
 * @param {boolean} reinitialize             Add the trigger's markup onto the replacing markup
 */ function $f58245f58448b4d4$var$replaceWithMarkup(trigger, markup, replaceWithMarkup1, reinitialize = false) {
    if ('undefined' !== typeof window.adw.posts.postsPerPage && window.adw.posts.postsPerPage > markup.length) {
        const replaceEl = document.querySelector(replaceWithMarkup1);
        if (replaceEl) replaceEl.innerHTML = '';
    }
    if (Array.isArray(markup)) markup = markup.join('');
    let newMarkup = '';
    if (markup) {
        // Get trigger HTML before it gets removed from DOM
        const triggerHTML = reinitialize && trigger ? trigger.outerHTML : '';
        newMarkup = reinitialize ? markup + triggerHTML : markup;
    }
    // Use jQuery replaceWith but ensure we're targeting the right element
    const $replaceEl = $(replaceWithMarkup1);
    if ($replaceEl.length) $replaceEl.replaceWith(newMarkup);
    setTimeout(function() {
        if (typeof triggerIntegratePremiumLock === 'function') triggerIntegratePremiumLock();
    }, 100);
    $('[data-bs-toggle="tooltip"]').tooltip();
}

});


parcelRegister("8z4U5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $63c5655ee28814e8$var$getCustomPostTypePosts;

var $63c5655ee28814e8$var$_replaceWithMarkup = $63c5655ee28814e8$var$_interopRequireDefault((parcelRequire("l4PXi")));

var $kNwsr = parcelRequire("kNwsr");
function $63c5655ee28814e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 *
 * Loads custom post type posts on Load More button click (adweek.com/sponsored archive uses this )
 *
 * @param {string} morePostsTrigger          Query string for triggering the loading and markup of posts.
 * @param {string} replaceWithPosts          Query string for node that new posts will replace.
 * @param {string} post_type                 Name of the post_type
 * @param {number} page                      Pagination index.
 */ function $63c5655ee28814e8$var$getCustomPostTypePosts(morePostsTrigger, replaceWithPosts, post_type, page) {
    const trigger = document.querySelector(morePostsTrigger);
    const anchor = trigger?.querySelector('a') ?? null;
    if (!trigger || !anchor) {
        adw.ENVIRONMENT === 'dev' && console.log("No trigger or anchor found for selector: " + morePostsTrigger + "");
        return;
    }
    trigger.addEventListener('click', async function(e) {
        e.preventDefault();
        const originalWrapper = anchor.innerHTML;
        anchor.innerHTML = '<div class="la-ball-pulse la-dark la-sm"><div></div><div></div><div></div></div>';
        const markupType = post_type === 'event' ? 'teaser_partner_more_grid' : 'index_item';
        const nextContent = await (0, $kNwsr.getPostsMarkup)(post_type, page, 10, markupType);
        const reinitialize = nextContent !== '';
        anchor.innerHTML = originalWrapper;
        (0, $63c5655ee28814e8$var$_replaceWithMarkup.default)(trigger, nextContent, replaceWithPosts, reinitialize);
        reinitialize && $63c5655ee28814e8$var$getCustomPostTypePosts(morePostsTrigger, replaceWithPosts, post_type, ++page);
    }, {
        once: true
    });
}

});
parcelRegister("kNwsr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPostsMarkup = $f2418fac74c37a20$var$getPostsMarkup;
module.exports.getPostsMarkupByIDs = $f2418fac74c37a20$var$getPostsMarkupByIDs;

var $9YTZb = parcelRequire("9YTZb");
/**
 *
 * @param {array} post_slugs - array of post_slugs
 * @param {number} page - page number
 * @param {number} numPosts - number of posts
 * @param {'teaser_partner_more_grid' | 'index_item'} markupType - markup type to use
 * @return {Promise<*>}
 */ async function $f2418fac74c37a20$var$getPostsMarkup(post_slugs, page, numPosts, markupType) {
    const queryObj = {
        "is_logged_in": jQuery('body').hasClass('logged-in'),
        "orderby": "date",
        "order": "DESC",
        "post_type": post_slugs,
        "page": page,
        "offset": page * numPosts,
        "posts_per_page": numPosts
    };
    const queryParam = encodeURIComponent(JSON.stringify(queryObj));
    try {
        const res = await (0, $9YTZb.getQueryMarkup)(queryParam, markupType);
        const body = await res.json();
        return body.markup;
    } catch (e) {
        console.error('Developer message: Error in fetching markup with post data: ' + e);
        throw e;
    }
}
/**
 *
 * @param post_ids - array of post_ids
 * @param markup
 * @return {Promise<string>}
 */ async function $f2418fac74c37a20$var$getPostsMarkupByIDs(post_ids, markup) {
    const queryObj = {
        "post__in": post_ids
    };
    const queryParam = encodeURIComponent(JSON.stringify(queryObj));
    try {
        const res = await (0, $9YTZb.getQueryMarkup)(queryParam, markup);
        const body = await res.json();
        return body.markup;
    } catch (e) {
        console.error('Developer message: Error in fetching markup with post data: ' + e);
        throw e;
    }
}

});
parcelRegister("9YTZb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getQuery = $7445254878aa97da$var$getQuery;
module.exports.getQueryMarkup = $7445254878aa97da$var$getQueryMarkup;
module.exports.getQueryandPaginationMarkupForSearch = $7445254878aa97da$var$getQueryandPaginationMarkupForSearch;
/**
 *
 * @example```js
 *   const queryObj = {
 *     "post_type": "post",
 *     "tax_query": {
 *       "taxonomy": "vertical",
 *       "field": "term_id",
 *       "terms": "4"
 *      }
 *    };
 *    const queryParam = encodeURIComponent(JSON.stringify(queryObj));
 *
 *    getQuery(
 *      queryParam,
 *      'aw-text',
 *      'wide',
 *      true,
 *      'index_item'
 *    ).then( res => res.json() ).then( res => console.log(res) );
 *
 * ```
 * @param query
 * @param imageSize
 * @param premiumMarkupType
 * @param getPostData
 * @param getMarkup
 * @return {Promise<any>}
 */ async function $7445254878aa97da$var$getQuery(query, imageSize = '', premiumMarkupType = '', getPostData = true, getMarkup = '') {
    let url = `${window.location.origin}/wp-json/adw/v1/query/?query=${query}`;
    if (imageSize) url += `&image_size=${imageSize}`;
    if (premiumMarkupType) url += `&premium_markup_type=${premiumMarkupType}`;
    if (getPostData) url += `&get_post_data=${getPostData}`;
    if (getMarkup) url += `&get_markup=${getMarkup}`;
    try {
        const res = await fetch(url);
        return await res;
    } catch (e) {
        console.error('Developer message: Error in fetching query data: ' + e);
        throw e;
    }
}
/**
 *
 * @param query
 * @param getMarkup
 * @return {Promise<any>}
 */ async function $7445254878aa97da$var$getQueryMarkup(query, getMarkup) {
    const url = `${window.location.origin}/wp-json/adw/v1/query/?query=${query}&get_markup=${getMarkup}&get_post_data=false&taxonomy=${adw.posts.taxonomy}`;
    try {
        const res = await fetch(url);
        return await res;
    } catch (e) {
        console.error('Developer message: Error in fetching query markup data: ' + e);
        throw e;
    }
}
/**
 *
 * @param {string} query - encoded and stringified JSON object
 * @param {string} requestUri
 * @return {Promise<any>}
 */ async function $7445254878aa97da$var$getQueryandPaginationMarkupForSearch(query, requestUri) {
    const url = `${window.location.origin}/wp-json/adw/v1/query/?query=${query}&request_uri=${requestUri}&get_markup=index_item&get_post_data=false&pagination_markup=search_page_pagination`;
    try {
        const res = await fetch(url);
        return await res;
    } catch (e) {
        console.error('Developer message: Error in fetching query markup data: ' + e);
        throw e;
    }
}

});



parcelRegister("bIPzs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $888bcea91a61ec4f$var$getLatestNewsPostTypePosts;

var $888bcea91a61ec4f$var$_replaceWithMarkup = $888bcea91a61ec4f$var$_interopRequireDefault((parcelRequire("l4PXi")));

var $kNwsr = parcelRequire("kNwsr");
function $888bcea91a61ec4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 *
 * Loads custom post type posts on Load More button click ( adweek.com/sponsored/ archive uses this )
 *
 * @param {string} morePostsTrigger                             Query string for triggering the loading and markup of posts.
 * @param {string} replaceWithPosts                             Query string for node that new posts will replace.
 * @param {'teaser_partner_more_grid' | 'index_item'} post_type Name of the post_type
 * @param {number} page                                         Pagination index.
 * @param {number} postPerPage                                  Number of posts per page.
 */ function $888bcea91a61ec4f$var$getLatestNewsPostTypePosts(morePostsTrigger, replaceWithPosts, post_type, page, postPerPage) {
    const trigger = document.querySelector(morePostsTrigger);
    trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const btnOriginalHtml = trigger.querySelector('a').innerHTML;
        const loaderHtml = '<div class="la-ball-pulse la-dark la-sm"><div></div><div></div><div></div></div>';
        trigger.querySelector('a').innerHTML = loaderHtml;
        const markup = post_type === 'event' ? 'teaser_partner_more_grid' : 'index_item';
        (0, $kNwsr.getPostsMarkup)(post_type, page, postPerPage, markup).then((markup)=>{
            const reinitialize = markup !== '';
            trigger.querySelector('a').innerHTML = btnOriginalHtml;
            (0, $888bcea91a61ec4f$var$_replaceWithMarkup.default)(trigger, markup, replaceWithPosts, reinitialize);
            if (reinitialize) $888bcea91a61ec4f$var$getLatestNewsPostTypePosts(morePostsTrigger, replaceWithPosts, post_type, ++page, postPerPage);
        });
    }, {
        once: true
    });
}
/**
 * @deprecated
 *
 * @param taxonomy
 * @param taxonomyTerm
 * @param page
 * @return {Promise<any>}
 */ async function $888bcea91a61ec4f$var$apiCall(post_type, page = 1) {
    console.log('custom post type endpoint called');
    const url = `${window.location.origin}/wp-json/adw-post/v1/post-index-markup/custom_post_type/posts/?page=${page}`;
    const response = await fetch(url);
    if (response.status !== 200) {
        console.error(`No route is established to retrieve '${post_type}' posts`);
        return new Promise((resolve)=>resolve(''));
    } else return await response.json();
}

});

parcelRegister("FcAzH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $07bd98589b8e9eb0$var$initTabListeners;
/**
 * Initialize event handlers for tabs showing/hiding.
 *
 * @example
 * ```
 * <script>
 *     // Configuration for popular and recent tabs (show/hide capability).
 *     const tabLinks                  =       '.js-tab-links';
 *     const tabs                      =       '.js-tabs';
 *     initTabListeners( tabLinks, tabs);
 * </script>
 *
 * <body>
 *      <li>
 *          <a class="js-tab-links active" data-target-id="recent-posts" href="#recent-posts">Most Recent</a>
 *      </li>
 *      <li>
 *          <a class="js-tab-links" data-target-id="popular-posts" href="#popular-posts">Most Popular</a>
 *      </li>
 *
 *      <div id="recent-posts" class="js-tabs">
 *          <p>Foo</p>
 *      </div>
 *      <div id="popular-posts" class="js-tabs d-none">
 *          <p>Bar</p>
 *      </div>
 * </body>
 *
 * ```
 *
 *
 * @param {string} tabLinks  classname for querying all tabLinks.
 * @param {string} tabs      classname for querying all tabs.
 */ function $07bd98589b8e9eb0$var$initTabListeners(tabLinks, tabs) {
    const nodes = document.querySelectorAll(tabLinks);
    const tabNodes = document.querySelectorAll(tabs);
    for(let i = 0, len = nodes.length; i < len; i++)nodes[i].addEventListener('click', function(e) {
        triggerIntegratePremiumLock();
        for(let j = 0, len = nodes.length; j < len; ++j)if (e.currentTarget === nodes[j] && !nodes[j].classList.contains('active')) {
            nodes[j].classList.add('active');
            $07bd98589b8e9eb0$var$openTab(nodes[j].dataset.targetId, tabNodes);
        } else nodes[j].classList.remove('active');
    });
}
/**
 * Opens a target tab node and hides the others.
 *
 * @param {string}      openingTabId      Target tab ID that will be shown.
 * @param {NodeList}    tabNodes          All HTML nodes that are tabs to be shown/hidden.
 */ function $07bd98589b8e9eb0$var$openTab(openingTabId, tabNodes) {
    for(let i = 0, len = tabNodes.length; i < len; i++)if (openingTabId === tabNodes[i].id && tabNodes[i].classList.contains('d-none')) tabNodes[i].classList.toggle('d-none');
    else tabNodes[i].classList.add('d-none');
}

});

parcelRegister("4ALvx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $357f603ad6d59836$var$replaceUrls;
/**
 *  Normalizes media urls.
 *  Replaces any older assets that parsely gives back in response. The media library has  been added and change in many different places and environments.
 *  The folder structure however has not had changes. Only the domains changed. The files remained for the most part so we are replacing the urls.
 */ /**
 * Configuration array. Add URLs here to check.
 *
 * @type {string[]}  List of strings to look for and be replaced with the correct url.
 */ const $357f603ad6d59836$var$urlsToBeReplaced = [
    'dev.sb.adweek.com',
    'dev.adweek.com',
    'stage.sb.adweek.com',
    'stage.adweek.com'
];
/**
 *
 * @param {string} url
 * @returns {string}
 */ function $357f603ad6d59836$var$replaceUrls(url) {
    $357f603ad6d59836$var$urlsToBeReplaced.forEach(function(value) {
        url = url.replace(value, 'www.adweek.com');
    });
    return url;
}

});

parcelRegister("sP5AJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $056a3ee3197a6a51$var$getPopularPosts;
module.exports.fetchPosts = $056a3ee3197a6a51$var$fetchPosts;
// fast and easy helper
const $056a3ee3197a6a51$var$isMobile = (breakpoint = 556)=>window.innerWidth < breakpoint;
/**
 *
 * @param queryParam
 * @param pageIndex
 * @returns {Promise<any>}
 */ function $056a3ee3197a6a51$var$getPopularPosts(queryParam = '', pageIndex = 1) {
    const query = queryParam ? `&q=${queryParam}` : '';
    const requestURL = `https://api.parsely.com/v2/search?apikey=adweek.com&endpoint=/search${query}&sort=views&boost=views&limit=10&page=${pageIndex}`;
    return fetch(requestURL).then((response)=>response.json()).catch((err)=>{
        console.error('Developer message: Error in fetching parsley popular posts data: ' + err);
    });
}
/** Async helper for getting posts from Parsely from the WP server. */ function $056a3ee3197a6a51$var$fetchPosts(query, callback) {
    return new Promise((resolve, reject)=>{
        const options = {
            data: {
                action: 'parsely_get_posts',
                ...query
            }
        };
        /** Makes controlled Ajax request with hooks to set request status. */ const ajax = (options)=>{
            let settings = Object.assign({
                url: adw.ajaxurl,
                beforeSend: (_)=>console.log('FINDERR'.repeat(10)),
                success: (response)=>{
                    const { message: message, data: data, error: error } = response.data;
                    if (error) {
                        console.warn(message);
                        throw error;
                    }
                    if (typeof callback == 'function') callback(data);
                    resolve(data);
                },
                error: (err)=>{
                    console.warn("In AJAX request for parsely");
                    console.warn(err);
                    if (typeof callback == 'function') callback(err);
                    reject(err);
                }
            }, options);
            jQuery.post(settings);
        };
        return ajax(options);
    });
}
/**
 * Generic getter for fetching posts via Parsely
 *
 * @param Object query API Settings applied to Parsely
 * @return Promise Promise resolving to the queried values or a rejection on error.
 */ function $056a3ee3197a6a51$var$_deprecated_getPosts(query = {}) {
    // Allow common names for `q` parameter
    const q = query.s || query.search || query.keyword || query.query || '';
    const baseURL = 'https://api.parsely.com/v2/search?apikey=adweek.com';
    const params = Object.assign({
        endpoint: 'search',
        q: '',
        boost: $056a3ee3197a6a51$var$isMobile() ? 'mobile_views' : 'views',
        sort: 'score',
        tag: '',
        author: '',
        page: 1,
        limit: 10
    }, query, {
        q: q
    });
    if (params.boost.length > 0 && params.sort !== 'score') // This option is only valid when `sort=score`
    delete params.boost;
    const requestURL = Object.entries(params).reduce($056a3ee3197a6a51$var$addParam, baseURL);
    return fetch(requestURL).then((response)=>response.json()).catch((err)=>{
        console.error('Developer message: Error in fetching parsley popular posts data: ' + err);
    });
}
/** Reducer for adding query parameters or skip if not defined */ function $056a3ee3197a6a51$var$addParam(queryString, [key, value]) {
    if (!value) return queryString;
    const v = typeof value == 'string' ? value : typeof value.toString == 'function' ? value.toString() : JSON.stringify(value);
    return `${queryString}&${key}=${v}`;
}

});

parcelRegister("fanpF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b0a9f383b063d0ba$var$getPopularCategoryPosts;
/**
 *
 * @param queryParam
 * @param pageIndex
 * @returns {Promise<any>}
 */ function $b0a9f383b063d0ba$var$getPopularCategoryPosts(queryParam = '', pageIndex = 1) {
    const query = queryParam ? `&tag=${queryParam}` : '';
    const requestURL = `https://api.parsely.com/v2/top/posts?apikey=adweek.com&days=30${query}`;
    return fetch(requestURL).then((response)=>response.json()).catch((err)=>{
        console.error('Developer message: Error in fetching parsley popular posts data: ' + err);
    });
}

});

parcelRegister("hk6fp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9c926909677e80d$var$getTaxPostsByTermID;
const $c9c926909677e80d$var$jquery = window.jquery;
const $c9c926909677e80d$var$adw = window.adw;
/**
 * Load Taxonomy data
 *
 * @param taxonomy
 * @param term
 * @param currentPage
 * @returns {*}
 */ function $c9c926909677e80d$var$getTaxPostsByTermID(taxonomy, term, currentPage) {
    const options = {
        type: 'POST',
        url: $c9c926909677e80d$var$adw.ajaxurl,
        dataType: "json",
        data: {
            action: 'tax_ajax_query',
            current_page: currentPage,
            taxonomy: taxonomy,
            taxonomy_term: term,
            offset: 10,
            posts_per_page: 10
        }
    };
    // console.log(options);
    return new Promise(function(resolve, reject) {
        $c9c926909677e80d$var$jquery.ajax(options).done(resolve).fail(reject);
    });
}

});

parcelRegister("lQefa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fe6980d012a53b60$var$initializeRecentPostsTrigger;
const $fe6980d012a53b60$var$adw = window.adw;
/**
 * Add an event listener to the JS trigger for getting popular posts from Parsely.
 *
 * @example
 *
 * <div id="recent-posts" class="js-tabs">
 *     <div class="posts">
 *         //some code, maybe a wordpress loop
 *     </div>
 * <div class="col-12 align-center js-replace-with-posts js-load-more-btn"><a href="javascript:void(0)" class="btn">Read More</a></div
 *
 * <?php $Queried_WP_Term_Obj = get_queried_object(); ?>
 *
 * <script>
 *   // Configuration for recent posts
 *   const startingIndexRecent       =       1;
 *   const recentPostsTrigger        =       '#recent-posts .js-load-more-btn a';
 *   const replaceWithRecentPosts    =       '#recent-posts .js-replace-with-posts';
 *   // Initialize everything.
 *   adw.parsely.initializeRecentPostsTrigger( recentPostsTrigger, replaceWithRecentPosts, '<?= $Queried_WP_Term_Obj->taxonomy ?>', '<?= $Queried_WP_Term_Obj->slug ?>', startingIndexRecent );
 *
 * </script>
 *
 * @param {string}  popularPostsTrigger   Query string for triggering the loading and markup of posts.
 * @param {string}  replaceWithPosts      Query string for node that new posts will replace.
 * @param {string}  taxonomy              Name of the taxonomy
 * @param {string}  taxonomyTerm          Taxonomy term.
 * @param {int}     index                 Pagination index.
 */ function $fe6980d012a53b60$var$initializeRecentPostsTrigger(popularPostsTrigger, replaceWithPosts, taxonomy, taxonomyTerm, index) {
    const trigger = document.querySelector(popularPostsTrigger);
    trigger.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('FROM PARCEL BUILD'); // stops page jumps.
        $fe6980d012a53b60$var$adw.parsely.getTaxPostsByTermID(taxonomy, taxonomyTerm, index).then((response)=>{
            return $fe6980d012a53b60$var$renderPosts(replaceWithPosts, response); // return is to execute the next .then after renderPosts();
        }).then(()=>{
            $fe6980d012a53b60$var$initializeRecentPostsTrigger(popularPostsTrigger, replaceWithPosts, taxonomy, taxonomyTerm, ++index); // Reinitialize the trigger on new content.
        }).catch((error)=>{
            console.log('Error in getting Parsley Data', error); // if error log it
            trigger.parentNode.removeChild(trigger); // delete the Read More button
        });
    });
}
/**
 *
 * @param replaceWithPosts  Node that new posts will replace.
 * @param data              Post data.
 */ async function $fe6980d012a53b60$var$renderPosts(replaceWithPosts, data) {
    const markup = await $fe6980d012a53b60$var$getPostMarkup(data);
    const postMarkupWithMoreButton = await markup + '<div class="col-12 align-center js-replace-with-posts js-load-more-btn"><a href="javascript:void(0)" class="btn">Read More</a></div>';
    data ? $(replaceWithPosts).replaceWith(postMarkupWithMoreButton) : $(replaceWithPosts).replaceWith(markup);
}
async function $fe6980d012a53b60$var$getPostMarkup(data) {
    return data.reduce(async function(markup, dataItem) {
        return await markup + await $fe6980d012a53b60$var$buildPost(dataItem.ID);
    }, Promise.resolve(''));
}
/**
 * todo: setup some try/catch blocks. Also there should be an endpoint for processing an array and returning the markup rather then pinging the api for each post ID.
 * @param id
 * @returns {string}
 */ async function $fe6980d012a53b60$var$buildPost(id) {
    const response = await fetch(`${window.location.origin}/wp-json/adw-contributor/v1/contributor-markup/${id}`);
    const data = await response.json();
    return data.markup;
}

});

parcelRegister("9uhuM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e847c9b77f17369$var$indexItemMarkup;
function $6e847c9b77f17369$var$indexItemMarkup(props) {
    const { url: url, imageUrl: imageUrl, title: title, author: author, pubDate: pubDate, label: label } = props;
    const imageFallback = `${window.location.origin}/wp-content/themes/adweek-next/src/images/adweek-placeholder.png`;
    const imageMarkup = imageUrl ? imageUrl : imageFallback;
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    const dateObj = new Date(pubDate);
    let premiumLabel = '';
    return `<section id="" class="section section--index-item ">
      <div class="section--index-item_avatar">
        <!-- BEGIN: atom-base -->
        <a href="${url}"><img loading="lazy" src="${imageMarkup}" alt="" class="image image-partner" data-lazy-src="${imageMarkup}"></a>
        <!-- END: atom-base -->
      </div>
      <div class="section--index-item_info">
        <a href="${url}" class="link-reset"> <p class="section__title"> ${title} </p> </a>
        <p class="section__byline"> By ${author} </p>
        ${premiumLabel}
        <p class="section__byline">  ${dateObj.toLocaleDateString('en-US', options)} </p>
        <p class="section__body"></p>
      </div>
    </section>`;
}

});

parcelRegister("7PxgL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b371a719248dc11$var$loadMorePopularPosts;

var $5b371a719248dc11$var$_replaceWithMarkup = $5b371a719248dc11$var$_interopRequireDefault((parcelRequire("l4PXi")));

var $5b371a719248dc11$var$_getPopularPosts = $5b371a719248dc11$var$_interopRequireDefault((parcelRequire("sP5AJ")));

var $5b371a719248dc11$var$_indexItemMarkup = $5b371a719248dc11$var$_interopRequireDefault((parcelRequire("9uhuM")));
function $5b371a719248dc11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 *
 * @param morePostsTrigger          Query string for triggering the loading and markup of posts.
 * @param replaceWithPosts          Query string for node that new posts will replace.
 * @param queryParam                API query param for Parsley
 * @param page                      Pagination index.
 */ function $5b371a719248dc11$var$loadMorePopularPosts(morePostsTrigger, replaceWithPosts, queryParam, page) {
    const trigger = document.querySelector(morePostsTrigger);
    trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const btnOriginalHtml = trigger.querySelector('a').innerHTML;
        const loaderHtml = '<div class="la-ball-pulse la-dark la-sm"><div></div><div></div><div></div></div>';
        trigger.querySelector('a').innerHTML = loaderHtml;
        (0, $5b371a719248dc11$var$_getPopularPosts.default)(queryParam, page).then((response)=>{
            const postList = response.data.map(function(dataItem) {
                const { url: url, image_url: image_url, title: title, author: author, pub_date: pub_date, section: section } = dataItem;
                const options = {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                };
                const dateObj = new Date(pub_date);
                let post_id = '';
                let postUrl = '';
                if (url.includes('http://www.adweek.com')) postUrl = url.replace('http://www.adweek.com', window.location.origin);
                if (url.includes('https://www.adweek.com')) postUrl = url.replace('https://www.adweek.com', window.location.origin);
                jQuery.ajax({
                    type: "post",
                    dataType: "json",
                    url: adw.ajaxurl,
                    async: false,
                    data: {
                        action: "aw_url_to_postid",
                        post_url: postUrl
                    },
                    complete: function(response) {
                        if (response && response.status == 200) {
                            const responseData = response.responseJSON;
                            if (response !== 0) post_id = responseData;
                        } else console.log('Could not get post data from Wordpress');
                    }
                });
                return {
                    post_id: post_id,
                    url: url,
                    title: title,
                    author: author,
                    label: section,
                    pubDate: dateObj.toLocaleDateString('en-US', options),
                    imageUrl: !image_url.includes("apple-touch-icon.png") ? adw.utils.replaceUrls(image_url) : ''
                };
            });
            // .reduce(
            //     function ( markup, dataItem ) {
            //         return markup + indexItemMarkup( dataItem );
            //     }, '');
            let postIdList = postList.map((post)=>post.post_id);
            let postIdListFiltered = postIdList.filter((post_id)=>post_id !== 0);
            let postsMarkup = '';
            adw.posts.getPostsMarkupByIDs(postIdListFiltered, 'index_item').then((markupList)=>{
                postsMarkup = markupList.reduce((markup, item)=>markup + item);
                const reinitialize = postsMarkup !== '';
                trigger.querySelector('a').innerHTML = btnOriginalHtml;
                (0, $5b371a719248dc11$var$_replaceWithMarkup.default)(trigger, postsMarkup, replaceWithPosts, reinitialize);
                if (reinitialize) $5b371a719248dc11$var$loadMorePopularPosts(morePostsTrigger, replaceWithPosts, queryParam, ++page);
            });
        });
    }, {
        once: true
    });
}

});

parcelRegister("datGA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $99633c853e716172$var$is_probably_googlebot;
function $99633c853e716172$var$is_probably_googlebot() {
    const ua = navigator.userAgent;
    return /googlebot/i.test(ua) || /Google-Structured-Data-Testing-Tool/i.test(ua);
}

});

"use strict";

var $658a109eb070f880$var$_modal = $658a109eb070f880$var$_interopRequireDefault((parcelRequire("bTckq")));
var $12e621ea8ca12514$exports = {};
/**
 * Simple, lightweight, usable local autocomplete library for modern browsers
 * Because there weren’t enough autocomplete scripts in the world? Because I’m completely insane and have NIH syndrome? Probably both. :P
 * @author Lea Verou http://leaverou.github.io/awesomplete
 * MIT license
 */ (function() {
    var _ = function(input, o) {
        var me = this;
        // Keep track of number of instances for unique IDs
        _.count = (_.count || 0) + 1;
        this.count = _.count;
        // Setup
        this.isOpened = false;
        this.input = $(input);
        this.input.setAttribute("autocomplete", "off");
        this.input.setAttribute("aria-autocomplete", "list");
        this.input.setAttribute("aria-expanded", "false");
        this.input.setAttribute("aria-controls", "awesomplete_list_" + this.count);
        this.input.setAttribute("aria-owns", "awesomplete_list_" + this.count);
        this.input.setAttribute("role", "combobox");
        // store constructor options in case we need to distinguish
        // between default and customized behavior later on
        this.options = o = o || {};
        configure(this, {
            minChars: 2,
            maxItems: 10,
            autoFirst: false,
            data: _.DATA,
            filter: _.FILTER_CONTAINS,
            sort: o.sort === false ? false : _.SORT_BYLENGTH,
            container: _.CONTAINER,
            item: _.ITEM,
            replace: _.REPLACE,
            tabSelect: false,
            listLabel: "Results List",
            statusNoResults: "No results found",
            statusXResults: "{0} results found",
            statusTypeXChar: "Type {0} or more characters for results"
        }, o);
        this.index = -1;
        // Create necessary elements
        this.container = this.container(input);
        this.ul = $.create("ul", {
            hidden: "hidden",
            role: "listbox",
            id: "awesomplete_list_" + this.count,
            inside: this.container,
            "aria-label": this.listLabel
        });
        this.status = $.create("span", {
            className: "visually-hidden",
            role: "status",
            "aria-live": "assertive",
            "aria-atomic": true,
            inside: this.container,
            textContent: "" // live region should start empty. Only when the text is changed it will be read by the screen reader.
        });
        // Bind events
        this._events = {
            input: {
                "input": this.evaluate.bind(this),
                "blur": this.close.bind(this, {
                    reason: "blur"
                }),
                "keydown": function(evt) {
                    var c = evt.keyCode;
                    // If the dropdown `ul` is in view, then act on keydown for the following keys:
                    // Enter / Esc / Up / Down
                    if (me.opened) {
                        if (c === 13 && me.selected) {
                            evt.preventDefault();
                            me.select(undefined, undefined, evt);
                        } else if (c === 9 && me.selected && me.tabSelect) {
                            evt.preventDefault();
                            me.select(undefined, undefined, evt);
                        } else if (c === 27) me.close({
                            reason: "esc"
                        });
                        else if (c === 38 || c === 40) {
                            evt.preventDefault();
                            me[c === 38 ? "previous" : "next"]();
                        }
                    }
                }
            },
            form: {
                "submit": this.close.bind(this, {
                    reason: "submit"
                })
            },
            ul: {
                // Prevent the default mousedowm, which ensures the input is not blurred.
                // The actual selection will happen on click. This also ensures dragging the
                // cursor away from the list item will cancel the selection
                "mousedown": function(evt) {
                    evt.preventDefault();
                },
                // The click event is fired even if the corresponding mousedown event has called preventDefault
                "click": function(evt) {
                    var li = evt.target;
                    if (li !== this) {
                        while(li && !/li/i.test(li.nodeName))li = li.parentNode;
                        if (li && evt.button === 0) {
                            evt.preventDefault();
                            me.select(li, evt.target, evt);
                        }
                    }
                }
            }
        };
        $.bind(this.input, this._events.input);
        $.bind(this.input.form, this._events.form);
        $.bind(this.ul, this._events.ul);
        if (this.input.hasAttribute("list")) {
            this.list = "#" + this.input.getAttribute("list");
            this.input.removeAttribute("list");
        } else this.list = this.input.getAttribute("data-list") || o.list || [];
        _.all.push(this);
    };
    _.prototype = {
        set list (list){
            if (Array.isArray(list)) this._list = list;
            else if (typeof list === "string" && list.indexOf(",") > -1) this._list = list.split(/\s*,\s*/);
            else {
                list = $(list);
                if (list && list.children) {
                    var items = [];
                    slice.apply(list.children).forEach(function(el) {
                        if (!el.disabled) {
                            var text = el.textContent.trim();
                            var value = el.value || text;
                            var label = el.label || text;
                            if (value !== "") items.push({
                                label: label,
                                value: value
                            });
                        }
                    });
                    this._list = items;
                }
            }
            if (document.activeElement === this.input) this.evaluate();
        },
        get selected () {
            return this.index > -1;
        },
        get opened () {
            return this.isOpened;
        },
        close: function(o) {
            if (!this.opened) return;
            this.input.setAttribute("aria-expanded", "false");
            this.ul.setAttribute("hidden", "");
            this.isOpened = false;
            this.index = -1;
            this.status.setAttribute("hidden", "");
            this.input.setAttribute("aria-activedescendant", "");
            $.fire(this.input, "awesomplete-close", o || {});
        },
        open: function() {
            this.input.setAttribute("aria-expanded", "true");
            this.ul.removeAttribute("hidden");
            this.isOpened = true;
            this.status.removeAttribute("hidden");
            if (this.autoFirst && this.index === -1) this.goto(0);
            $.fire(this.input, "awesomplete-open");
        },
        destroy: function() {
            //remove events from the input and its form
            $.unbind(this.input, this._events.input);
            $.unbind(this.input.form, this._events.form);
            // cleanup container if it was created by Awesomplete but leave it alone otherwise
            if (!this.options.container) {
                //move the input out of the awesomplete container and remove the container and its children
                var parentNode = this.container.parentNode;
                parentNode.insertBefore(this.input, this.container);
                parentNode.removeChild(this.container);
            }
            // remove autocomplete and aria attributes
            this.input.removeAttribute("autocomplete");
            this.input.removeAttribute("aria-autocomplete");
            this.input.removeAttribute("aria-expanded");
            this.input.removeAttribute("aria-controls");
            this.input.removeAttribute("aria-owns");
            this.input.removeAttribute("role");
            //remove this awesomeplete instance from the global array of instances
            var indexOfAwesomplete = _.all.indexOf(this);
            if (indexOfAwesomplete !== -1) _.all.splice(indexOfAwesomplete, 1);
        },
        next: function() {
            var count = this.ul.children.length;
            this.goto(this.index < count - 1 ? this.index + 1 : count ? 0 : -1);
        },
        previous: function() {
            var count = this.ul.children.length;
            var pos = this.index - 1;
            this.goto(this.selected && pos !== -1 ? pos : count - 1);
        },
        // Should not be used, highlights specific item without any checks!
        goto: function(i) {
            var lis = this.ul.children;
            if (this.selected) lis[this.index].setAttribute("aria-selected", "false");
            this.index = i;
            if (i > -1 && lis.length > 0) {
                lis[i].setAttribute("aria-selected", "true");
                // fix: Turned off this status update.
                //		Screen readers Voiceover and Talkback won't read this status change.
                //		Narrator and NVDA do, but they already tell: 'X of Y (selected)'
                // this.status.textContent = lis[i].textContent + ", list item " + (i + 1) + " of " + lis.length;
                this.input.setAttribute("aria-activedescendant", this.ul.id + "_item_" + this.index);
                // scroll to highlighted element in case parent's height is fixed
                this.ul.scrollTop = lis[i].offsetTop - this.ul.clientHeight + lis[i].clientHeight;
                $.fire(this.input, "awesomplete-highlight", {
                    text: this.suggestions[this.index]
                });
            }
        },
        select: function(selected, origin, originalEvent) {
            if (selected) this.index = $.siblingIndex(selected);
            else selected = this.ul.children[this.index];
            if (selected) {
                var suggestion = this.suggestions[this.index];
                var allowed = $.fire(this.input, "awesomplete-select", {
                    text: suggestion,
                    origin: origin || selected,
                    originalEvent: originalEvent
                });
                if (allowed) {
                    this.replace(suggestion);
                    this.close({
                        reason: "select"
                    });
                    $.fire(this.input, "awesomplete-selectcomplete", {
                        text: suggestion,
                        originalEvent: originalEvent
                    });
                }
            }
        },
        evaluate: function() {
            var me = this;
            var value = this.input.value;
            if (value.length >= this.minChars && this._list && this._list.length > 0) {
                this.index = -1;
                // Populate list with options that match
                this.ul.innerHTML = "";
                this.suggestions = this._list.map(function(item) {
                    return new Suggestion(me.data(item, value));
                }).filter(function(item) {
                    return me.filter(item, value);
                });
                if (this.sort !== false) this.suggestions = this.suggestions.sort(this.sort);
                this.suggestions = this.suggestions.slice(0, this.maxItems);
                this.suggestions.forEach(function(text, index) {
                    me.ul.appendChild(me.item(text, value, index));
                });
                if (this.ul.children.length === 0) {
                    this.status.textContent = this.statusNoResults;
                    this.close({
                        reason: "nomatches"
                    });
                } else {
                    this.input.setAttribute("aria-activedescendant", ""); // none of the list items currently has aria-selected="true"
                    this.open();
                    this.status.textContent = this.statusXResults.replaceAll('{0}', this.ul.children.length); // N results found;
                }
            } else {
                this.close({
                    reason: "nomatches"
                });
                if (this.minChar <= 1 || value.length >= this.minChars) this.status.textContent = this.statusNoResults;
                else this.status.textContent = this.statusTypeXChar.replaceAll('{0}', this.minChars); // Type N or more characters for results
            }
        }
    };
    // Static methods/properties
    _.all = [];
    _.FILTER_CONTAINS = function(text, input) {
        return RegExp($.regExpEscape(input.trim()), "i").test(text);
    };
    _.FILTER_STARTSWITH = function(text, input) {
        return RegExp("^" + $.regExpEscape(input.trim()), "i").test(text);
    };
    _.SORT_BYLENGTH = function(a, b) {
        if (a.length !== b.length) return a.length - b.length;
        return a < b ? -1 : 1;
    };
    _.CONTAINER = function(input) {
        return $.create("div", {
            className: "awesomplete",
            around: input
        });
    };
    _.ITEM = function(text, input, item_id) {
        var html = input.trim() === "" ? text : text.replace(RegExp($.regExpEscape(input.trim()), "gi"), "<mark>$&</mark>");
        return $.create("li", {
            innerHTML: html,
            "role": "option",
            "aria-selected": "false",
            "tabindex": "-1",
            "id": "awesomplete_list_" + this.count + "_item_" + item_id
        });
    };
    _.REPLACE = function(text) {
        this.input.value = text.value;
    };
    _.DATA = function(item /*, input*/ ) {
        return item;
    };
    // Private functions
    function Suggestion(data) {
        var o = Array.isArray(data) ? {
            label: data[0],
            value: data[1]
        } : typeof data === "object" && "label" in data && "value" in data ? data : {
            label: data,
            value: data
        };
        this.label = o.label || o.value;
        this.value = o.value;
    }
    Object.defineProperty(Suggestion.prototype = Object.create(String.prototype), "length", {
        get: function() {
            return this.label.length;
        }
    });
    Suggestion.prototype.toString = Suggestion.prototype.valueOf = function() {
        return "" + this.label;
    };
    function configure(instance, properties, o) {
        for(var i in properties){
            var initial = properties[i], attrValue = instance.input.getAttribute("data-" + i.toLowerCase());
            if (typeof initial === "number") instance[i] = parseInt(attrValue);
            else if (initial === false) instance[i] = attrValue !== null;
            else if (initial instanceof Function) instance[i] = null;
            else instance[i] = attrValue;
            if (!instance[i] && instance[i] !== 0) instance[i] = i in o ? o[i] : initial;
        }
    }
    // Helpers
    var slice = Array.prototype.slice;
    function $(expr, con) {
        return typeof expr === "string" ? (con || document).querySelector(expr) : expr || null;
    }
    function $$(expr, con) {
        return slice.call((con || document).querySelectorAll(expr));
    }
    $.create = function(tag, o) {
        var element = document.createElement(tag);
        for(var i in o){
            var val = o[i];
            if (i === "inside") $(val).appendChild(element);
            else if (i === "around") {
                var ref = $(val);
                ref.parentNode.insertBefore(element, ref);
                element.appendChild(ref);
                if (ref.getAttribute("autofocus") != null) ref.focus();
            } else if (i in element) element[i] = val;
            else element.setAttribute(i, val);
        }
        return element;
    };
    $.bind = function(element, o) {
        if (element) for(var event in o){
            var callback = o[event];
            event.split(/\s+/).forEach(function(event) {
                element.addEventListener(event, callback);
            });
        }
    };
    $.unbind = function(element, o) {
        if (element) for(var event in o){
            var callback = o[event];
            event.split(/\s+/).forEach(function(event) {
                element.removeEventListener(event, callback);
            });
        }
    };
    $.fire = function(target, type, properties) {
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent(type, true, true);
        for(var j in properties)evt[j] = properties[j];
        return target.dispatchEvent(evt);
    };
    $.regExpEscape = function(s) {
        return s.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
    };
    $.siblingIndex = function(el) {
        /* eslint-disable no-cond-assign */ for(var i = 0; el = el.previousElementSibling; i++);
        return i;
    };
    // Initialization
    function init() {
        $$("input.awesomplete").forEach(function(input) {
            new _(input);
        });
    }
    // Make sure to export Awesomplete on self when in a browser
    if (typeof self !== "undefined") self.Awesomplete = _;
    // Are we in a browser? Check for Document constructor
    if (typeof Document !== "undefined") {
        // DOM already loaded?
        if (document.readyState !== "loading") init();
        else // Wait for it
        document.addEventListener("DOMContentLoaded", init);
    }
    _.$ = $;
    _.$$ = $$;
    // Expose Awesomplete as a CJS module
    if ($12e621ea8ca12514$exports) $12e621ea8ca12514$exports = _;
    return _;
})();


var $4163020a6cee9b13$exports = {};
"use strict";
!function(e) {
    var n;
    if ("function" == typeof define && define.amd && (define(e), n = !0), $4163020a6cee9b13$exports = e(), n = !0, !n) {
        var t = window.Cookies, o = window.Cookies = e();
        o.noConflict = function() {
            return window.Cookies = t, o;
        };
    }
}(function() {
    function f() {
        for(var e = 0, n = {}; e < arguments.length; e++){
            var t = arguments[e];
            for(var o in t)n[o] = t[o];
        }
        return n;
    }
    function a(e) {
        return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    return function e(u) {
        function c() {}
        function t(e, n, t) {
            if ("undefined" != typeof document) {
                "number" == typeof (t = f({
                    path: "/"
                }, c.defaults, t)).expires && (t.expires = new Date(1 * new Date() + 864e5 * t.expires)), t.expires = t.expires ? t.expires.toUTCString() : "";
                try {
                    var o = JSON.stringify(n);
                    /^[\{\[]/.test(o) && (n = o);
                } catch (e) {}
                n = u.write ? u.write(n, e) : encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), e = encodeURIComponent(String(e)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
                var r = "";
                for(var i in t)t[i] && (r += "; " + i, !0 !== t[i] && (r += "=" + t[i].split(";")[0]));
                return document.cookie = e + "=" + n + r;
            }
        }
        function n(e, n) {
            if ("undefined" != typeof document) {
                for(var t = {}, o = document.cookie ? document.cookie.split("; ") : [], r = 0; r < o.length; r++){
                    var i = o[r].split("="), c = i.slice(1).join("=");
                    n || '"' !== c.charAt(0) || (c = c.slice(1, -1));
                    try {
                        var f = a(i[0]);
                        if (c = (u.read || u)(c, f) || a(c), n) try {
                            c = JSON.parse(c);
                        } catch (e) {}
                        if (t[f] = c, e === f) break;
                    } catch (e) {}
                }
                return e ? t[e] : t;
            }
        }
        return c.set = t, c.get = function(e) {
            return n(e, !1);
        }, c.getJSON = function(e) {
            return n(e, !0);
        }, c.remove = function(e, n) {
            t(e, "", f(n, {
                expires: -1
            }));
        }, c.defaults = {}, c.withConverter = e, c;
    }(function() {});
});


"use strict";
"use strict";
/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2008 George McGinley Smith
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
*/ // t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];
jQuery.extend(jQuery.easing, {
    def: 'easeOutQuad',
    swing: function(x, t, b, c, d) {
        //alert(jQuery.easing.default);
        return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
    },
    easeInQuad: function(x, t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    easeOutQuad: function(x, t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    easeInOutQuad: function(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    easeInCubic: function(x, t, b, c, d) {
        return c * (t /= d) * t * t + b;
    },
    easeOutCubic: function(x, t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    },
    easeInOutCubic: function(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t + 2) + b;
    },
    easeInQuart: function(x, t, b, c, d) {
        return c * (t /= d) * t * t * t + b;
    },
    easeOutQuart: function(x, t, b, c, d) {
        return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    },
    easeInOutQuart: function(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
        return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    },
    easeInQuint: function(x, t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    easeOutQuint: function(x, t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    easeInOutQuint: function(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    easeInSine: function(x, t, b, c, d) {
        return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    },
    easeOutSine: function(x, t, b, c, d) {
        return c * Math.sin(t / d * (Math.PI / 2)) + b;
    },
    easeInOutSine: function(x, t, b, c, d) {
        return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
    },
    easeInExpo: function(x, t, b, c, d) {
        return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
    },
    easeOutExpo: function(x, t, b, c, d) {
        return t == d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    },
    easeInOutExpo: function(x, t, b, c, d) {
        if (t == 0) return b;
        if (t == d) return b + c;
        if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
        return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    },
    easeInCirc: function(x, t, b, c, d) {
        return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
    },
    easeOutCirc: function(x, t, b, c, d) {
        return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
    },
    easeInOutCirc: function(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
        return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
    },
    easeInElastic: function(x, t, b, c, d) {
        var s = 1.70158;
        var p = 0;
        var a = c;
        if (t == 0) return b;
        if ((t /= d) == 1) return b + c;
        if (!p) p = d * .3;
        if (a < Math.abs(c)) {
            a = c;
            var s = p / 4;
        } else var s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    easeOutElastic: function(x, t, b, c, d) {
        var s = 1.70158;
        var p = 0;
        var a = c;
        if (t == 0) return b;
        if ((t /= d) == 1) return b + c;
        if (!p) p = d * .3;
        if (a < Math.abs(c)) {
            a = c;
            var s = p / 4;
        } else var s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    easeInOutElastic: function(x, t, b, c, d) {
        var s = 1.70158;
        var p = 0;
        var a = c;
        if (t == 0) return b;
        if ((t /= d / 2) == 2) return b + c;
        if (!p) p = d * (.3 * 1.5);
        if (a < Math.abs(c)) {
            a = c;
            var s = p / 4;
        } else var s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
    },
    easeInBack: function(x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    easeOutBack: function(x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    easeInOutBack: function(x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    easeInBounce: function(x, t, b, c, d) {
        return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b;
    },
    easeOutBounce: function(x, t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
    },
    easeInOutBounce: function(x, t, b, c, d) {
        if (t < d / 2) return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * .5 + b;
        return jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
    }
}); /*
 *
 * TERMS OF USE - EASING EQUATIONS
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2001 Robert Penner
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
 */ 




"use strict";
(function($, window1, document1, undefined) {
    // undefined is used here as the undefined global
    // variable in ECMAScript 3 and is mutable (i.e. it can
    // be changed by someone else). undefined isn't really
    // being passed in so we can ensure that its value is
    // truly undefined. In ES5, undefined can no longer be
    // modified.
    // window and document are passed through as local
    // variables rather than as globals, because this (slightly)
    // quickens the resolution process and can be more
    // efficiently minified (especially when both are
    // regularly referenced in your plugin).
    // Create the defaults once
    var pluginName = "galleryMockup", defaults = {
        propertyName: "value"
    };
    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        // jQuery has an extend method that merges the
        // contents of two or more objects, storing the
        // result in the first object. The first object
        // is generally empty because we don't want to alter
        // the default options for future instances of the plugin
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }
    Plugin.prototype = {
        init: function() {
            // Place initialization logic here
            // You already have access to the DOM element and
            // the options via the instance, e.g. this.element
            // and this.options
            // you can add more functions like the one below and
            // call them like so: this.yourOtherFunction(this.element, this.options).
            $(this.element).on('click.galleryThumbnail', '.gallery-thumbnail', function(e) {
                var $this = $(this);
                var $target = $('#' + $this.data('target'));
                $this.siblings().removeClass('active');
                $this.addClass('active');
                function scrollTo(element, to = 0, duration = 1000, scrollToDone = null) {
                    const start = element.scrollLeft;
                    const change = to - start;
                    const increment = 20;
                    let currentTime = 0;
                    const animateScroll = ()=>{
                        currentTime += increment;
                        const val = Math.easeInOutQuad(currentTime, start, change, duration);
                        element.scrollLeft = val;
                        if (currentTime < duration) setTimeout(animateScroll, increment);
                        else if (scrollToDone) scrollToDone();
                    };
                    animateScroll();
                }
                Math.easeInOutQuad = function(t, b, c, d) {
                    t /= d / 2;
                    if (t < 1) return c / 2 * t * t + b;
                    t--;
                    return -c / 2 * (t * (t - 2) - 1) + b;
                };
                var scrollAmount = $this[0].offsetLeft - $this.parent()[0].offsetLeft - $this.closest('.grid-gallery-thumbnails')[0].clientWidth / 2 + $this[0].clientWidth / 2 || 0;
                scrollTo($this.closest('.grid-gallery-thumbnails')[0], scrollAmount, 250, ()=>{
                    $target.closest('.gallery-photo').animate({
                        'opacity': 0
                    }, 250, 'swing', function() {
                        $target.find('img.image').attr('src', $this.data('src'));
                        $target.find('.card-text').html($this.data('caption'));
                        $target.find('.card-byline').html($this.data('byline'));
                        $target.find('img.image').each(function(ndx) {
                            this.onload = function(e) {
                                $target.closest('.gallery-photo').animate({
                                    'opacity': 1
                                }, 250);
                            };
                        });
                    });
                    $this.closest('.gallery-footer').find('.gallery-footer__subnav .count').html('<strong>' + ($this.index() + 1) + '</strong>/' + ($this.siblings().length + 1) + '');
                });
            //$this.closest('.grid-gallery-thumbnails').animate( { scrollLeft: '-=' + $this[0].offsetLeft - $this.parent()[0].offsetLeft }, 1000, 'easeInOutQuad');
            // $this.closest('.grid-gallery-thumbnails').scrollLeft($this[0].offsetLeft - $this.parent()[0].offsetLeft - 23);
            // $this.closest('.grid-gallery-thumbnails').animate( { scrollLeft: '($this[0].offsetLeft - $this.parent()[0].offsetLeft - 23 '});
            });
            $(this.element).on('click.galleryThumbnail.prev', '.gallery-prev', function(e) {
                var $this = $(this);
                $this.closest('.gallery-footer').find('.gallery-thumbnail.active').prev().trigger('click.galleryThumbnail');
            });
            $(this.element).on('click.galleryThumbnail.next', '.gallery-next', function(e) {
                var $this = $(this);
                $this.closest('.gallery-footer').find('.gallery-thumbnail.active').next().trigger('click.galleryThumbnail');
            });
            $(document1).off('keydown.galleryThumbnail.keyboard').on('keydown.galleryThumbnail.keyboard', function(e) {
                switch(e.key){
                    case 'ArrowRight':
                        $('.gallery-next').trigger('click.galleryThumbnail.next');
                        break;
                    case 'ArrowLeft':
                        $('.gallery-prev').trigger('click.galleryThumbnail.prev');
                        break;
                }
            });
            $(this.element).find('.gallery-thumbnail.active').trigger('click.galleryThumbnail');
        },
        yourOtherFunction: function(el, options) {
        // some logic
        }
    };
    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) $.data(this, "plugin_" + pluginName, new Plugin(this, options));
        });
    };
})(jQuery, window, document);


"use strict";
// Vindicati Scroller
(function($1) {
    function initVindicatiScroller() {
        $1(document).on('click.scrollVW', '.gallery-footer__subnav a.disable', function(e) {
            //Quick and Dirty horizontal scroller. Moves offset of last visible item in viewport.
            e.preventDefault();
            function isElementInViewport(el) {
                if (typeof jQuery === "function" && el instanceof jQuery) el = el[0];
                var rect = el.getBoundingClientRect();
                return rect.top >= 0 && rect.left >= 0 && rect.right <= (window.innerWidth || document.documentElement.clientWidth /*or $(window).width() */ );
            }
            var $target = $1('.grid-gallery-thumbnails');
            var $this = $1(this);
            var direction = $this.attr('href').toLowerCase() == '#prev' ? '-' : '+';
            var pos = '';
            var $galleryItems = $target.find('.gallery-thumbnail').filter(function() {
                return isElementInViewport(this);
            });
            console.log('i', $galleryItems);
            if (direction == '+') //$target.find('.active').next().addClass('.active').siblings().removeClass('.active');
            {
                if ($galleryItems.last().next().length) pos = '+=' + $galleryItems.last().next()[0].getBoundingClientRect().x + 'px';
            } else if (direction == '-') {
                if ($galleryItems.first().prev().length) pos = '-=' + (document.documentElement.clientWidth + $galleryItems.first().prev()[0].getBoundingClientRect().x + $galleryItems.first().prev()[0].getBoundingClientRect().width) + 'px';
            } else pos = direction + '=' + document.documentElement.clientWidth + 'px';
            if (pos.length > 0) $target.animate({
                scrollLeft: pos
            }, 1000, 'easeInOutQuad');
        });
    }
    if ($1('body').hasClass('single')) {
        if ($1('body').hasClass('article-content-loaded')) {
            initVindicatiScroller();
            console.log('scrollers called after .article-content-loaded in body tag');
        } else $1(document).on('aw_article_content_loaded', function() {
            initVindicatiScroller();
            console.log('scrollers called after aw_article_content_loaded');
        });
    } else {
        initVindicatiScroller();
        console.log('scrollers called without aw_article_content_loaded');
    }
})(jQuery);
//Galleries
(function() {
    // "Original Video" Page selectors
    const teaserGalleryWrapper = '.section--teaser_gallery';
    const teaserGalleryContainer = teaserGalleryWrapper + ' .grid-gallery';
    const teaserGalleryArrows = teaserGalleryWrapper + ' nav a';
    // "Partner Experts" page selectors
    const gridScrollerWrapper = '.grid-scroller';
    const gridScrollerContainer = gridScrollerWrapper + ' .grid-scroller__container';
    const gridScrollerArrows = gridScrollerWrapper + ' nav a';
    const galleryWrapper = teaserGalleryWrapper + ',' + gridScrollerWrapper, galleryContainer = teaserGalleryContainer + ',' + gridScrollerContainer, galleryArrows = teaserGalleryArrows + ',' + gridScrollerArrows;
    // A handler of clicks on the control arrows
    (()=>{
        // A gallery item is considered visible even if a specified part of the element is hidden from the viewport
        const allowedScrollOffset = 0.1;
        // Visible items in the current viewport
        const getCurrentlyVisibleItems = (container)=>{
            const containerDOMRect = container[0].getBoundingClientRect();
            return container.children().filter(function() {
                const itemDOMRect = this.getBoundingClientRect();
                // Applying the offset
                return itemDOMRect.left > containerDOMRect.left - itemDOMRect.width * allowedScrollOffset && itemDOMRect.right < containerDOMRect.right + itemDOMRect.width * allowedScrollOffset;
            });
        };
        const scrollLeft = (container)=>{
            const items = container.children();
            // Default value to scroll (the first item in the gallery)
            let scrollTo = items[0].scrollLeft;
            const containerWidth = container.width(), galleryItemWidth = items.outerWidth();
            // Calculate how many items fit in the viewport by default (if the page just loaded)
            const defaultAmountOfItemsInViewport = Math.trunc((containerWidth + galleryItemWidth * allowedScrollOffset) / galleryItemWidth);
            // Get visible items in the current state...
            const currentlyVisibleItems = getCurrentlyVisibleItems(container);
            // ... and set an index of the item to scroll to
            const targetElementIndex = currentlyVisibleItems.first().index() - defaultAmountOfItemsInViewport;
            // If it is a valid index, get its position
            if (targetElementIndex > 0) //Respect of possible offset of the first item since it is not always zero
            scrollTo = items[targetElementIndex].offsetLeft - items[0].offsetLeft;
            return scrollTo;
        };
        const scrollRight = (container)=>{
            const items = container.children();
            // Default value to scroll (the last item in the gallery)
            let scrollTo = container[0].scrollWidth - container[0].offsetWidth;
            // Get visible items in the current state...
            const currentlyVisibleItems = getCurrentlyVisibleItems(container);
            // ... and get the item to scroll to
            const targetElement = currentlyVisibleItems.last().next();
            // Get its position
            if (targetElement.length) // Respect of possible offset of the first item
            scrollTo = targetElement[0].offsetLeft - items[0].offsetLeft;
            return scrollTo;
        };
        const scrollHandler = (element)=>{
            const button = $(element);
            const container = button.closest(galleryWrapper).children(galleryContainer);
            let scrollTo;
            if ('Previous' === button.attr('aria-label')) scrollTo = scrollLeft(container);
            else scrollTo = scrollRight(container);
            container.animate({
                scrollLeft: scrollTo
            }, 1000, 'easeInOutQuad');
        };
        $(document).on('click', galleryArrows, function(event) {
            event.preventDefault();
            scrollHandler(this);
        });
    })();
    // A handler of visibility of the control arrows
    (()=>{
        const showArrowClassName = 'show-arrow-button', prevStatePropName = 'awGalleryPrevState';
        let leftOffset, rightOffset;
        const setOffset = ()=>{
            const defaultOffset = 170;
            // 'Partner Experts' page
            if (0 === $(teaserGalleryContainer).length) {
                leftOffset = rightOffset = defaultOffset;
                return;
            }
            // 'Original video' page
            const items = $(teaserGalleryContainer).children();
            const itemWidth = parseInt(items.css('width'), 10), itemMaxWidth = parseInt(items.css('maxWidth'), 10);
            leftOffset = itemWidth / 2;
            // The difference between sizes due to the hover effect
            rightOffset = itemMaxWidth - itemWidth;
        };
        const visibilityHandler = (container)=>{
            const $container = $(container);
            const nav = $container.siblings('nav');
            const left = container.scrollLeft, right = container.scrollWidth - container.scrollLeft - container.offsetWidth;
            let leftButton, rightButton, showLeft = left > leftOffset, showRight = right > rightOffset;
            // When a gallery doesn't have scroll we hide control elements
            if (container.scrollWidth === container.offsetWidth) {
                showRight = false;
                showLeft = false;
            }
            // Since we are mainly listening to the scrolling events and they are fired at a high rate,
            // it makes sense to save the previous state and make changes to DOM only if something has been changed
            if (undefined === $container.data(prevStatePropName)) $container.data(prevStatePropName, {
                left: undefined,
                right: undefined
            });
            if (showLeft !== $container.data(prevStatePropName).left) {
                leftButton = nav.find('.page-link[aria-label="Previous"]')[0];
                leftButton.classList.toggle(showArrowClassName, showLeft);
                $container.data(prevStatePropName).left = showLeft;
            }
            if (showRight !== $container.data(prevStatePropName).right) {
                rightButton = nav.find('.page-link[aria-label="Next"]')[0];
                rightButton.classList.toggle(showArrowClassName, showRight);
                $container.data(prevStatePropName).right = showRight;
            }
        };
        window.visibilityHandler = visibilityHandler;
        // When all galleries has been loaded
        $(window).on('load aw_video_galleries_built resize', function() {
            setOffset();
            $(galleryContainer).each(function() {
                visibilityHandler(this);
            });
        });
        // Capturing scroll event
        document.addEventListener('scroll', function(event) {
            if ($(event.target).is(galleryContainer)) visibilityHandler(event.target);
        }, true);
        document.addEventListener('aw_infinite_loading.complete', function(event) {
            visibilityHandler(event.target);
        });
    })();
    // A handler that removes lazy image loading in the galleries
    (()=>{
        const gridScrollerImage = '.grid-scroller__item-container picture img.image';
        const handleImages = (container)=>{
            $(container).find(gridScrollerImage).attr('loading', 'eager');
        };
        $(window).on('load', function() {
            $(galleryContainer).each(function() {
                handleImages(this);
            });
        });
        document.addEventListener('aw_infinite_loading.complete', function(event) {
            handleImages(event.target);
        });
    })();
})(jQuery);


"use strict";
/*
 * Initializing bootstrap tooltips
 */ $(function() {
    $(window).on('load', function() {
        if ($('document').tooltip) $('[data-toggle="tooltip"]').tooltip();
    });
});


"use strict";
/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $1e278783c7067372$exports = {};

$parcel$export($1e278783c7067372$exports, "popperGenerator", function () { return $1839837374f95732$export$ed5e13716264f202; });
$parcel$export($1e278783c7067372$exports, "detectOverflow", function () { return $70321b611e132ecc$export$2e2bcd8739ae039; });
$parcel$export($1e278783c7067372$exports, "createPopperBase", function () { return $1839837374f95732$export$8f7491d57c8f97a9; });
$parcel$export($1e278783c7067372$exports, "createPopper", function () { return $98a9ef6d31ff03cd$export$8f7491d57c8f97a9; });
$parcel$export($1e278783c7067372$exports, "createPopperLite", function () { return $0468327f9101fb67$export$8f7491d57c8f97a9; });
var $935c50c8659545b7$exports = {};

$parcel$export($935c50c8659545b7$exports, "top", function () { return $935c50c8659545b7$export$1e95b668f3b82d; });
$parcel$export($935c50c8659545b7$exports, "bottom", function () { return $935c50c8659545b7$export$40e543e69a8b3fbb; });
$parcel$export($935c50c8659545b7$exports, "right", function () { return $935c50c8659545b7$export$79ffe56a765070d2; });
$parcel$export($935c50c8659545b7$exports, "left", function () { return $935c50c8659545b7$export$eabcd2c8791e7bf4; });
$parcel$export($935c50c8659545b7$exports, "auto", function () { return $935c50c8659545b7$export$dfb5619354ba860; });
$parcel$export($935c50c8659545b7$exports, "basePlacements", function () { return $935c50c8659545b7$export$aec2ce47c367b8c3; });
$parcel$export($935c50c8659545b7$exports, "start", function () { return $935c50c8659545b7$export$b3571188c770cc5a; });
$parcel$export($935c50c8659545b7$exports, "end", function () { return $935c50c8659545b7$export$bd5df0f255a350f8; });
$parcel$export($935c50c8659545b7$exports, "clippingParents", function () { return $935c50c8659545b7$export$390fd549c5303b4d; });
$parcel$export($935c50c8659545b7$exports, "viewport", function () { return $935c50c8659545b7$export$d7b7311ec04a3e8f; });
$parcel$export($935c50c8659545b7$exports, "popper", function () { return $935c50c8659545b7$export$ae5ab1c730825774; });
$parcel$export($935c50c8659545b7$exports, "reference", function () { return $935c50c8659545b7$export$ca50aac9f3ba507f; });
$parcel$export($935c50c8659545b7$exports, "variationPlacements", function () { return $935c50c8659545b7$export$368f9a87e87fa4e1; });
$parcel$export($935c50c8659545b7$exports, "placements", function () { return $935c50c8659545b7$export$803cd8101b6c182b; });
$parcel$export($935c50c8659545b7$exports, "beforeRead", function () { return $935c50c8659545b7$export$421679a7c3d56e; });
$parcel$export($935c50c8659545b7$exports, "read", function () { return $935c50c8659545b7$export$aafa59e2e03f2942; });
$parcel$export($935c50c8659545b7$exports, "afterRead", function () { return $935c50c8659545b7$export$6964f6c886723980; });
$parcel$export($935c50c8659545b7$exports, "beforeMain", function () { return $935c50c8659545b7$export$c65e99957a05207c; });
$parcel$export($935c50c8659545b7$exports, "main", function () { return $935c50c8659545b7$export$f22da7240b7add18; });
$parcel$export($935c50c8659545b7$exports, "afterMain", function () { return $935c50c8659545b7$export$bab79516f2d662fe; });
$parcel$export($935c50c8659545b7$exports, "beforeWrite", function () { return $935c50c8659545b7$export$8d4d2d70e7d46032; });
$parcel$export($935c50c8659545b7$exports, "write", function () { return $935c50c8659545b7$export$68d8715fc104d294; });
$parcel$export($935c50c8659545b7$exports, "afterWrite", function () { return $935c50c8659545b7$export$70a6e5159acce2e6; });
$parcel$export($935c50c8659545b7$exports, "modifierPhases", function () { return $935c50c8659545b7$export$d087d3878fdf71d5; });
var $935c50c8659545b7$export$1e95b668f3b82d = 'top';
var $935c50c8659545b7$export$40e543e69a8b3fbb = 'bottom';
var $935c50c8659545b7$export$79ffe56a765070d2 = 'right';
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = 'left';
var $935c50c8659545b7$export$dfb5619354ba860 = 'auto';
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = 'start';
var $935c50c8659545b7$export$bd5df0f255a350f8 = 'end';
var $935c50c8659545b7$export$390fd549c5303b4d = 'clippingParents';
var $935c50c8659545b7$export$d7b7311ec04a3e8f = 'viewport';
var $935c50c8659545b7$export$ae5ab1c730825774 = 'popper';
var $935c50c8659545b7$export$ca50aac9f3ba507f = 'reference';
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = 'beforeRead';
var $935c50c8659545b7$export$aafa59e2e03f2942 = 'read';
var $935c50c8659545b7$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = 'beforeMain';
var $935c50c8659545b7$export$f22da7240b7add18 = 'main';
var $935c50c8659545b7$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = 'beforeWrite';
var $935c50c8659545b7$export$68d8715fc104d294 = 'write';
var $935c50c8659545b7$export$70a6e5159acce2e6 = 'afterWrite';
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];


var $133f6f38ce92f501$exports = {};

$parcel$export($133f6f38ce92f501$exports, "applyStyles", function () { return $312913fa2edc14b2$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "arrow", function () { return $20e743289f291887$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "computeStyles", function () { return $063d2297888fea12$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "eventListeners", function () { return $fa02e10eb4995658$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "flip", function () { return $dabd09962ff7b702$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "hide", function () { return $7d3d400f3b7c97f3$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "offset", function () { return $8d644778f0e020f0$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "popperOffsets", function () { return $ee48a1861d343976$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "preventOverflow", function () { return $4804c92787f86449$export$2e2bcd8739ae039; });
function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;



function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
}


function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? (0, $2835f189066da699$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b49248e188a52b8b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $6be351e83d6bf643$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $2835f189066da699$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) >= 0;
}




function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    if (isIE && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element);
    if ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $27c48183f07ddbe8$export$2e2bcd8739ae039)(offsetParent) && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}


function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(min, (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)(), paddingObject);
}


function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $063d2297888fea12$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var sideY = (0, $935c50c8659545b7$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(popper);
            if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || placement === (0, $935c50c8659545b7$export$79ffe56a765070d2)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideY = (0, $935c50c8659545b7$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || placement === (0, $935c50c8659545b7$export$40e543e69a8b3fbb)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideX = (0, $935c50c8659545b7$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};



var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};


var $d79ddf39683d3f91$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}



var $5887002dcefa0743$var$hash = {
    start: 'end',
    end: 'start'
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}








function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)).left + (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b49248e188a52b8b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node) && (0, $9873d63ab8539814$export$2e2bcd8739ae039)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(node));
}





function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c48b941fd834c962$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9873d63ab8539814$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(target)));
}










function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) ? (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $7da9d5689cacb0a6$export$2e2bcd8739ae039)(element, strategy)) : (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $ab4ea6dd03061fae$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) ? (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) && (0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $935c50c8659545b7$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $935c50c8659545b7$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $935c50c8659545b7$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $935c50c8659545b7$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $935c50c8659545b7$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $935c50c8659545b7$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $935c50c8659545b7$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $935c50c8659545b7$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? (0, $935c50c8659545b7$export$ca50aac9f3ba507f) : (0, $935c50c8659545b7$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $93ee5964b4e9d426$export$2e2bcd8739ae039)((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $1cd357ee33805adc$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $935c50c8659545b7$export$79ffe56a765070d2),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $935c50c8659545b7$export$1e95b668f3b82d),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $935c50c8659545b7$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $935c50c8659545b7$export$368f9a87e87fa4e1) : (0, $935c50c8659545b7$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $935c50c8659545b7$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860) ? (0, $bec6b628c79c2a3d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$b3571188c770cc5a);
        var isVertical = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $935c50c8659545b7$export$79ffe56a765070d2) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $935c50c8659545b7$export$1e95b668f3b82d),
        (0, $935c50c8659545b7$export$79ffe56a765070d2),
        (0, $935c50c8659545b7$export$40e543e69a8b3fbb),
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};




function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $935c50c8659545b7$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8d644778f0e020f0$var$offset
};



function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};





function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e82c9e5baaa8e9af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4faf3481d1df2f95$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $2835f189066da699$export$2e2bcd8739ae039)(node) || !(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node)) return (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(node);
    else return (0, $c829ab0279467772$export$2e2bcd8739ae039)(node);
}








function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9873d63ab8539814$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b71097fc0b0e5f5c$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e951d80a0194865c$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $935c50c8659545b7$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(reference) ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $455dca0e08f2a815$export$2e2bcd8739ae039)((0, $81912adbd60ec5c0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $b01cf64433a5b37b$export$2e2bcd8739ae039)(reference, (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $ad01075005a54bff$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6d2b77c34ff005f5$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $fa02e10eb4995658$export$2e2bcd8739ae039),
    (0, $ee48a1861d343976$export$2e2bcd8739ae039),
    (0, $063d2297888fea12$export$2e2bcd8739ae039),
    (0, $312913fa2edc14b2$export$2e2bcd8739ae039),
    (0, $8d644778f0e020f0$export$2e2bcd8739ae039),
    (0, $dabd09962ff7b702$export$2e2bcd8739ae039),
    (0, $4804c92787f86449$export$2e2bcd8739ae039),
    (0, $20e743289f291887$export$2e2bcd8739ae039),
    (0, $7d3d400f3b7c97f3$export$2e2bcd8739ae039)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1839837374f95732$export$ed5e13716264f202)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $0468327f9101fb67$export$d34966752335dd47 = [
    (0, $fa02e10eb4995658$export$2e2bcd8739ae039),
    (0, $ee48a1861d343976$export$2e2bcd8739ae039),
    (0, $063d2297888fea12$export$2e2bcd8739ae039),
    (0, $312913fa2edc14b2$export$2e2bcd8739ae039)
];
var $0468327f9101fb67$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1839837374f95732$export$ed5e13716264f202)({
    defaultModifiers: $0468327f9101fb67$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($1e278783c7067372$exports, $935c50c8659545b7$exports);
$parcel$exportWildcard($1e278783c7067372$exports, $133f6f38ce92f501$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$elementMap = new Map();
const $e59c07196a2b1f1e$var$Data = {
    set (element, key, instance) {
        if (!$e59c07196a2b1f1e$var$elementMap.has(element)) $e59c07196a2b1f1e$var$elementMap.set(element, new Map());
        const instanceMap = $e59c07196a2b1f1e$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($e59c07196a2b1f1e$var$elementMap.has(element)) return $e59c07196a2b1f1e$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$e59c07196a2b1f1e$var$elementMap.has(element)) return;
        const instanceMap = $e59c07196a2b1f1e$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $e59c07196a2b1f1e$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e59c07196a2b1f1e$var$MAX_UID = 1000000;
const $e59c07196a2b1f1e$var$MILLISECONDS_MULTIPLIER = 1000;
const $e59c07196a2b1f1e$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $e59c07196a2b1f1e$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $e59c07196a2b1f1e$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $e59c07196a2b1f1e$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $e59c07196a2b1f1e$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $e59c07196a2b1f1e$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $e59c07196a2b1f1e$var$MILLISECONDS_MULTIPLIER;
};
const $e59c07196a2b1f1e$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($e59c07196a2b1f1e$var$TRANSITION_END));
};
const $e59c07196a2b1f1e$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $e59c07196a2b1f1e$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($e59c07196a2b1f1e$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($e59c07196a2b1f1e$var$parseSelector(object));
    return null;
};
const $e59c07196a2b1f1e$var$isVisible = (element)=>{
    if (!$e59c07196a2b1f1e$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $e59c07196a2b1f1e$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $e59c07196a2b1f1e$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $e59c07196a2b1f1e$var$findShadowRoot(element.parentNode);
};
const $e59c07196a2b1f1e$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $e59c07196a2b1f1e$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $e59c07196a2b1f1e$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $e59c07196a2b1f1e$var$DOMContentLoadedCallbacks = [];
const $e59c07196a2b1f1e$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$e59c07196a2b1f1e$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $e59c07196a2b1f1e$var$DOMContentLoadedCallbacks)callback();
        });
        $e59c07196a2b1f1e$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $e59c07196a2b1f1e$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $e59c07196a2b1f1e$var$defineJQueryPlugin = (plugin)=>{
    $e59c07196a2b1f1e$var$onDOMContentLoaded(()=>{
        const $ = $e59c07196a2b1f1e$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $e59c07196a2b1f1e$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $e59c07196a2b1f1e$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $e59c07196a2b1f1e$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $e59c07196a2b1f1e$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($e59c07196a2b1f1e$var$TRANSITION_END, handler);
        $e59c07196a2b1f1e$var$execute(callback);
    };
    transitionElement.addEventListener($e59c07196a2b1f1e$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $e59c07196a2b1f1e$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $e59c07196a2b1f1e$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $e59c07196a2b1f1e$var$stripNameRegex = /\..*/;
const $e59c07196a2b1f1e$var$stripUidRegex = /::\d+$/;
const $e59c07196a2b1f1e$var$eventRegistry = {}; // Events storage
let $e59c07196a2b1f1e$var$uidEvent = 1;
const $e59c07196a2b1f1e$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $e59c07196a2b1f1e$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $e59c07196a2b1f1e$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$e59c07196a2b1f1e$var$uidEvent++}` || element.uidEvent || $e59c07196a2b1f1e$var$uidEvent++;
}
function $e59c07196a2b1f1e$var$getElementEvents(element) {
    const uid = $e59c07196a2b1f1e$var$makeEventUid(element);
    element.uidEvent = uid;
    $e59c07196a2b1f1e$var$eventRegistry[uid] = $e59c07196a2b1f1e$var$eventRegistry[uid] || {};
    return $e59c07196a2b1f1e$var$eventRegistry[uid];
}
function $e59c07196a2b1f1e$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $e59c07196a2b1f1e$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $e59c07196a2b1f1e$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $e59c07196a2b1f1e$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $e59c07196a2b1f1e$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $e59c07196a2b1f1e$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $e59c07196a2b1f1e$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $e59c07196a2b1f1e$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $e59c07196a2b1f1e$var$getTypeEvent(originalTypeEvent);
    if (!$e59c07196a2b1f1e$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $e59c07196a2b1f1e$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $e59c07196a2b1f1e$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $e59c07196a2b1f1e$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $e59c07196a2b1f1e$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $e59c07196a2b1f1e$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $e59c07196a2b1f1e$var$makeEventUid(callable, originalTypeEvent.replace($e59c07196a2b1f1e$var$namespaceRegex, ''));
    const fn = isDelegated ? $e59c07196a2b1f1e$var$bootstrapDelegationHandler(element, handler, callable) : $e59c07196a2b1f1e$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $e59c07196a2b1f1e$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $e59c07196a2b1f1e$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $e59c07196a2b1f1e$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $e59c07196a2b1f1e$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $e59c07196a2b1f1e$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($e59c07196a2b1f1e$var$stripNameRegex, '');
    return $e59c07196a2b1f1e$var$customEvents[event] || event;
}
const $e59c07196a2b1f1e$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $e59c07196a2b1f1e$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $e59c07196a2b1f1e$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $e59c07196a2b1f1e$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $e59c07196a2b1f1e$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $e59c07196a2b1f1e$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$e59c07196a2b1f1e$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($e59c07196a2b1f1e$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $e59c07196a2b1f1e$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $e59c07196a2b1f1e$var$getjQuery();
        const typeEvent = $e59c07196a2b1f1e$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $e59c07196a2b1f1e$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $e59c07196a2b1f1e$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $e59c07196a2b1f1e$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $e59c07196a2b1f1e$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $e59c07196a2b1f1e$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$e59c07196a2b1f1e$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$e59c07196a2b1f1e$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $e59c07196a2b1f1e$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $e59c07196a2b1f1e$var$normalizeData(element.getAttribute(`data-bs-${$e59c07196a2b1f1e$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $e59c07196a2b1f1e$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $e59c07196a2b1f1e$var$isElement(element) ? $e59c07196a2b1f1e$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$e59c07196a2b1f1e$var$isElement(element) ? $e59c07196a2b1f1e$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $e59c07196a2b1f1e$var$isElement(value) ? 'element' : $e59c07196a2b1f1e$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $e59c07196a2b1f1e$var$BaseComponent extends $e59c07196a2b1f1e$var$Config {
    constructor(element, config){
        super();
        element = $e59c07196a2b1f1e$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $e59c07196a2b1f1e$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $e59c07196a2b1f1e$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $e59c07196a2b1f1e$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $e59c07196a2b1f1e$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $e59c07196a2b1f1e$var$Data.get($e59c07196a2b1f1e$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $e59c07196a2b1f1e$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e59c07196a2b1f1e$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$e59c07196a2b1f1e$var$parseSelector(sel)).join(',') : null;
};
const $e59c07196a2b1f1e$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$e59c07196a2b1f1e$var$isDisabled(el) && $e59c07196a2b1f1e$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $e59c07196a2b1f1e$var$getSelector(element);
        if (selector) return $e59c07196a2b1f1e$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $e59c07196a2b1f1e$var$getSelector(element);
        return selector ? $e59c07196a2b1f1e$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $e59c07196a2b1f1e$var$getSelector(element);
        return selector ? $e59c07196a2b1f1e$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e59c07196a2b1f1e$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $e59c07196a2b1f1e$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($e59c07196a2b1f1e$var$isDisabled(this)) return;
        const target = $e59c07196a2b1f1e$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$f = 'alert';
const $e59c07196a2b1f1e$var$DATA_KEY$a = 'bs.alert';
const $e59c07196a2b1f1e$var$EVENT_KEY$b = `.${$e59c07196a2b1f1e$var$DATA_KEY$a}`;
const $e59c07196a2b1f1e$var$EVENT_CLOSE = `close${$e59c07196a2b1f1e$var$EVENT_KEY$b}`;
const $e59c07196a2b1f1e$var$EVENT_CLOSED = `closed${$e59c07196a2b1f1e$var$EVENT_KEY$b}`;
const $e59c07196a2b1f1e$var$CLASS_NAME_FADE$5 = 'fade';
const $e59c07196a2b1f1e$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $e59c07196a2b1f1e$export$caec2af78bcc877f extends $e59c07196a2b1f1e$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e59c07196a2b1f1e$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e59c07196a2b1f1e$var$enableDismissTrigger($e59c07196a2b1f1e$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $e59c07196a2b1f1e$var$defineJQueryPlugin($e59c07196a2b1f1e$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$e = 'button';
const $e59c07196a2b1f1e$var$DATA_KEY$9 = 'bs.button';
const $e59c07196a2b1f1e$var$EVENT_KEY$a = `.${$e59c07196a2b1f1e$var$DATA_KEY$9}`;
const $e59c07196a2b1f1e$var$DATA_API_KEY$6 = '.data-api';
const $e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$3 = 'active';
const $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$6 = `click${$e59c07196a2b1f1e$var$EVENT_KEY$a}${$e59c07196a2b1f1e$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $e59c07196a2b1f1e$export$353f5b6fc5456de1 extends $e59c07196a2b1f1e$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e59c07196a2b1f1e$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$6, $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$5);
    const data = $e59c07196a2b1f1e$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $e59c07196a2b1f1e$var$defineJQueryPlugin($e59c07196a2b1f1e$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$d = 'swipe';
const $e59c07196a2b1f1e$var$EVENT_KEY$9 = '.bs.swipe';
const $e59c07196a2b1f1e$var$EVENT_TOUCHSTART = `touchstart${$e59c07196a2b1f1e$var$EVENT_KEY$9}`;
const $e59c07196a2b1f1e$var$EVENT_TOUCHMOVE = `touchmove${$e59c07196a2b1f1e$var$EVENT_KEY$9}`;
const $e59c07196a2b1f1e$var$EVENT_TOUCHEND = `touchend${$e59c07196a2b1f1e$var$EVENT_KEY$9}`;
const $e59c07196a2b1f1e$var$EVENT_POINTERDOWN = `pointerdown${$e59c07196a2b1f1e$var$EVENT_KEY$9}`;
const $e59c07196a2b1f1e$var$EVENT_POINTERUP = `pointerup${$e59c07196a2b1f1e$var$EVENT_KEY$9}`;
const $e59c07196a2b1f1e$var$POINTER_TYPE_TOUCH = 'touch';
const $e59c07196a2b1f1e$var$POINTER_TYPE_PEN = 'pen';
const $e59c07196a2b1f1e$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $e59c07196a2b1f1e$var$SWIPE_THRESHOLD = 40;
const $e59c07196a2b1f1e$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $e59c07196a2b1f1e$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$var$Swipe extends $e59c07196a2b1f1e$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$e59c07196a2b1f1e$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default$c;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType$c;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$d;
    }
    // Public
    dispose() {
        $e59c07196a2b1f1e$var$EventHandler.off(this._element, $e59c07196a2b1f1e$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $e59c07196a2b1f1e$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $e59c07196a2b1f1e$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $e59c07196a2b1f1e$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $e59c07196a2b1f1e$var$POINTER_TYPE_PEN || event.pointerType === $e59c07196a2b1f1e$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$c = 'carousel';
const $e59c07196a2b1f1e$var$DATA_KEY$8 = 'bs.carousel';
const $e59c07196a2b1f1e$var$EVENT_KEY$8 = `.${$e59c07196a2b1f1e$var$DATA_KEY$8}`;
const $e59c07196a2b1f1e$var$DATA_API_KEY$5 = '.data-api';
const $e59c07196a2b1f1e$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $e59c07196a2b1f1e$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $e59c07196a2b1f1e$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $e59c07196a2b1f1e$var$ORDER_NEXT = 'next';
const $e59c07196a2b1f1e$var$ORDER_PREV = 'prev';
const $e59c07196a2b1f1e$var$DIRECTION_LEFT = 'left';
const $e59c07196a2b1f1e$var$DIRECTION_RIGHT = 'right';
const $e59c07196a2b1f1e$var$EVENT_SLIDE = `slide${$e59c07196a2b1f1e$var$EVENT_KEY$8}`;
const $e59c07196a2b1f1e$var$EVENT_SLID = `slid${$e59c07196a2b1f1e$var$EVENT_KEY$8}`;
const $e59c07196a2b1f1e$var$EVENT_KEYDOWN$1 = `keydown${$e59c07196a2b1f1e$var$EVENT_KEY$8}`;
const $e59c07196a2b1f1e$var$EVENT_MOUSEENTER$1 = `mouseenter${$e59c07196a2b1f1e$var$EVENT_KEY$8}`;
const $e59c07196a2b1f1e$var$EVENT_MOUSELEAVE$1 = `mouseleave${$e59c07196a2b1f1e$var$EVENT_KEY$8}`;
const $e59c07196a2b1f1e$var$EVENT_DRAG_START = `dragstart${$e59c07196a2b1f1e$var$EVENT_KEY$8}`;
const $e59c07196a2b1f1e$var$EVENT_LOAD_DATA_API$3 = `load${$e59c07196a2b1f1e$var$EVENT_KEY$8}${$e59c07196a2b1f1e$var$DATA_API_KEY$5}`;
const $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$5 = `click${$e59c07196a2b1f1e$var$EVENT_KEY$8}${$e59c07196a2b1f1e$var$DATA_API_KEY$5}`;
const $e59c07196a2b1f1e$var$CLASS_NAME_CAROUSEL = 'carousel';
const $e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$2 = 'active';
const $e59c07196a2b1f1e$var$CLASS_NAME_SLIDE = 'slide';
const $e59c07196a2b1f1e$var$CLASS_NAME_END = 'carousel-item-end';
const $e59c07196a2b1f1e$var$CLASS_NAME_START = 'carousel-item-start';
const $e59c07196a2b1f1e$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $e59c07196a2b1f1e$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $e59c07196a2b1f1e$var$SELECTOR_ACTIVE = '.active';
const $e59c07196a2b1f1e$var$SELECTOR_ITEM = '.carousel-item';
const $e59c07196a2b1f1e$var$SELECTOR_ACTIVE_ITEM = $e59c07196a2b1f1e$var$SELECTOR_ACTIVE + $e59c07196a2b1f1e$var$SELECTOR_ITEM;
const $e59c07196a2b1f1e$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $e59c07196a2b1f1e$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $e59c07196a2b1f1e$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $e59c07196a2b1f1e$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $e59c07196a2b1f1e$var$KEY_TO_DIRECTION = {
    [$e59c07196a2b1f1e$var$ARROW_LEFT_KEY$1]: $e59c07196a2b1f1e$var$DIRECTION_RIGHT,
    [$e59c07196a2b1f1e$var$ARROW_RIGHT_KEY$1]: $e59c07196a2b1f1e$var$DIRECTION_LEFT
};
const $e59c07196a2b1f1e$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $e59c07196a2b1f1e$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$export$144901db2ea8e967 extends $e59c07196a2b1f1e$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $e59c07196a2b1f1e$var$SelectorEngine.findOne($e59c07196a2b1f1e$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $e59c07196a2b1f1e$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default$b;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType$b;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$c;
    }
    // Public
    next() {
        this._slide($e59c07196a2b1f1e$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $e59c07196a2b1f1e$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($e59c07196a2b1f1e$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $e59c07196a2b1f1e$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $e59c07196a2b1f1e$var$EventHandler.one(this._element, $e59c07196a2b1f1e$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $e59c07196a2b1f1e$var$EventHandler.one(this._element, $e59c07196a2b1f1e$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $e59c07196a2b1f1e$var$ORDER_NEXT : $e59c07196a2b1f1e$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $e59c07196a2b1f1e$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $e59c07196a2b1f1e$var$SelectorEngine.find($e59c07196a2b1f1e$var$SELECTOR_ITEM_IMG, this._element))$e59c07196a2b1f1e$var$EventHandler.on(img, $e59c07196a2b1f1e$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $e59c07196a2b1f1e$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($e59c07196a2b1f1e$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($e59c07196a2b1f1e$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $e59c07196a2b1f1e$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $e59c07196a2b1f1e$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $e59c07196a2b1f1e$var$SelectorEngine.findOne($e59c07196a2b1f1e$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $e59c07196a2b1f1e$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $e59c07196a2b1f1e$var$ORDER_NEXT;
        const nextElement = element || $e59c07196a2b1f1e$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($e59c07196a2b1f1e$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $e59c07196a2b1f1e$var$CLASS_NAME_START : $e59c07196a2b1f1e$var$CLASS_NAME_END;
        const orderClassName = isNext ? $e59c07196a2b1f1e$var$CLASS_NAME_NEXT : $e59c07196a2b1f1e$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $e59c07196a2b1f1e$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($e59c07196a2b1f1e$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $e59c07196a2b1f1e$var$SelectorEngine.findOne($e59c07196a2b1f1e$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $e59c07196a2b1f1e$var$SelectorEngine.find($e59c07196a2b1f1e$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($e59c07196a2b1f1e$var$isRTL()) return direction === $e59c07196a2b1f1e$var$DIRECTION_LEFT ? $e59c07196a2b1f1e$var$ORDER_PREV : $e59c07196a2b1f1e$var$ORDER_NEXT;
        return direction === $e59c07196a2b1f1e$var$DIRECTION_LEFT ? $e59c07196a2b1f1e$var$ORDER_NEXT : $e59c07196a2b1f1e$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($e59c07196a2b1f1e$var$isRTL()) return order === $e59c07196a2b1f1e$var$ORDER_PREV ? $e59c07196a2b1f1e$var$DIRECTION_LEFT : $e59c07196a2b1f1e$var$DIRECTION_RIGHT;
        return order === $e59c07196a2b1f1e$var$ORDER_PREV ? $e59c07196a2b1f1e$var$DIRECTION_RIGHT : $e59c07196a2b1f1e$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e59c07196a2b1f1e$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$5, $e59c07196a2b1f1e$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $e59c07196a2b1f1e$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $e59c07196a2b1f1e$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($e59c07196a2b1f1e$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$e59c07196a2b1f1e$var$EventHandler.on(window, $e59c07196a2b1f1e$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $e59c07196a2b1f1e$var$SelectorEngine.find($e59c07196a2b1f1e$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$e59c07196a2b1f1e$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $e59c07196a2b1f1e$var$defineJQueryPlugin($e59c07196a2b1f1e$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$b = 'collapse';
const $e59c07196a2b1f1e$var$DATA_KEY$7 = 'bs.collapse';
const $e59c07196a2b1f1e$var$EVENT_KEY$7 = `.${$e59c07196a2b1f1e$var$DATA_KEY$7}`;
const $e59c07196a2b1f1e$var$DATA_API_KEY$4 = '.data-api';
const $e59c07196a2b1f1e$var$EVENT_SHOW$6 = `show${$e59c07196a2b1f1e$var$EVENT_KEY$7}`;
const $e59c07196a2b1f1e$var$EVENT_SHOWN$6 = `shown${$e59c07196a2b1f1e$var$EVENT_KEY$7}`;
const $e59c07196a2b1f1e$var$EVENT_HIDE$6 = `hide${$e59c07196a2b1f1e$var$EVENT_KEY$7}`;
const $e59c07196a2b1f1e$var$EVENT_HIDDEN$6 = `hidden${$e59c07196a2b1f1e$var$EVENT_KEY$7}`;
const $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$4 = `click${$e59c07196a2b1f1e$var$EVENT_KEY$7}${$e59c07196a2b1f1e$var$DATA_API_KEY$4}`;
const $e59c07196a2b1f1e$var$CLASS_NAME_SHOW$7 = 'show';
const $e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSE = 'collapse';
const $e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $e59c07196a2b1f1e$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSE} .${$e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSE}`;
const $e59c07196a2b1f1e$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $e59c07196a2b1f1e$var$WIDTH = 'width';
const $e59c07196a2b1f1e$var$HEIGHT = 'height';
const $e59c07196a2b1f1e$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $e59c07196a2b1f1e$var$Default$a = {
    parent: null,
    toggle: true
};
const $e59c07196a2b1f1e$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$export$78768a9af065a7b extends $e59c07196a2b1f1e$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $e59c07196a2b1f1e$var$SelectorEngine.find($e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $e59c07196a2b1f1e$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $e59c07196a2b1f1e$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default$a;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType$a;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($e59c07196a2b1f1e$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$e59c07196a2b1f1e$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSE, $e59c07196a2b1f1e$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $e59c07196a2b1f1e$var$reflow(this._element);
        this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSE, $e59c07196a2b1f1e$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $e59c07196a2b1f1e$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSE);
            $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $e59c07196a2b1f1e$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_HORIZONTAL) ? $e59c07196a2b1f1e$var$WIDTH : $e59c07196a2b1f1e$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $e59c07196a2b1f1e$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $e59c07196a2b1f1e$var$SelectorEngine.find($e59c07196a2b1f1e$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $e59c07196a2b1f1e$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($e59c07196a2b1f1e$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $e59c07196a2b1f1e$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$4, $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $e59c07196a2b1f1e$var$SelectorEngine.getMultipleElementsFromSelector(this))$e59c07196a2b1f1e$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $e59c07196a2b1f1e$var$defineJQueryPlugin($e59c07196a2b1f1e$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$a = 'dropdown';
const $e59c07196a2b1f1e$var$DATA_KEY$6 = 'bs.dropdown';
const $e59c07196a2b1f1e$var$EVENT_KEY$6 = `.${$e59c07196a2b1f1e$var$DATA_KEY$6}`;
const $e59c07196a2b1f1e$var$DATA_API_KEY$3 = '.data-api';
const $e59c07196a2b1f1e$var$ESCAPE_KEY$2 = 'Escape';
const $e59c07196a2b1f1e$var$TAB_KEY$1 = 'Tab';
const $e59c07196a2b1f1e$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $e59c07196a2b1f1e$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $e59c07196a2b1f1e$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $e59c07196a2b1f1e$var$EVENT_HIDE$5 = `hide${$e59c07196a2b1f1e$var$EVENT_KEY$6}`;
const $e59c07196a2b1f1e$var$EVENT_HIDDEN$5 = `hidden${$e59c07196a2b1f1e$var$EVENT_KEY$6}`;
const $e59c07196a2b1f1e$var$EVENT_SHOW$5 = `show${$e59c07196a2b1f1e$var$EVENT_KEY$6}`;
const $e59c07196a2b1f1e$var$EVENT_SHOWN$5 = `shown${$e59c07196a2b1f1e$var$EVENT_KEY$6}`;
const $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$3 = `click${$e59c07196a2b1f1e$var$EVENT_KEY$6}${$e59c07196a2b1f1e$var$DATA_API_KEY$3}`;
const $e59c07196a2b1f1e$var$EVENT_KEYDOWN_DATA_API = `keydown${$e59c07196a2b1f1e$var$EVENT_KEY$6}${$e59c07196a2b1f1e$var$DATA_API_KEY$3}`;
const $e59c07196a2b1f1e$var$EVENT_KEYUP_DATA_API = `keyup${$e59c07196a2b1f1e$var$EVENT_KEY$6}${$e59c07196a2b1f1e$var$DATA_API_KEY$3}`;
const $e59c07196a2b1f1e$var$CLASS_NAME_SHOW$6 = 'show';
const $e59c07196a2b1f1e$var$CLASS_NAME_DROPUP = 'dropup';
const $e59c07196a2b1f1e$var$CLASS_NAME_DROPEND = 'dropend';
const $e59c07196a2b1f1e$var$CLASS_NAME_DROPSTART = 'dropstart';
const $e59c07196a2b1f1e$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $e59c07196a2b1f1e$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$3}.${$e59c07196a2b1f1e$var$CLASS_NAME_SHOW$6}`;
const $e59c07196a2b1f1e$var$SELECTOR_MENU = '.dropdown-menu';
const $e59c07196a2b1f1e$var$SELECTOR_NAVBAR = '.navbar';
const $e59c07196a2b1f1e$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $e59c07196a2b1f1e$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $e59c07196a2b1f1e$var$PLACEMENT_TOP = $e59c07196a2b1f1e$var$isRTL() ? 'top-end' : 'top-start';
const $e59c07196a2b1f1e$var$PLACEMENT_TOPEND = $e59c07196a2b1f1e$var$isRTL() ? 'top-start' : 'top-end';
const $e59c07196a2b1f1e$var$PLACEMENT_BOTTOM = $e59c07196a2b1f1e$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $e59c07196a2b1f1e$var$PLACEMENT_BOTTOMEND = $e59c07196a2b1f1e$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $e59c07196a2b1f1e$var$PLACEMENT_RIGHT = $e59c07196a2b1f1e$var$isRTL() ? 'left-start' : 'right-start';
const $e59c07196a2b1f1e$var$PLACEMENT_LEFT = $e59c07196a2b1f1e$var$isRTL() ? 'right-start' : 'left-start';
const $e59c07196a2b1f1e$var$PLACEMENT_TOPCENTER = 'top';
const $e59c07196a2b1f1e$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $e59c07196a2b1f1e$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $e59c07196a2b1f1e$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$export$931cbfb6bfb85fc extends $e59c07196a2b1f1e$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $e59c07196a2b1f1e$var$SelectorEngine.next(this._element, $e59c07196a2b1f1e$var$SELECTOR_MENU)[0] || $e59c07196a2b1f1e$var$SelectorEngine.prev(this._element, $e59c07196a2b1f1e$var$SELECTOR_MENU)[0] || $e59c07196a2b1f1e$var$SelectorEngine.findOne($e59c07196a2b1f1e$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default$9;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType$9;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($e59c07196a2b1f1e$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($e59c07196a2b1f1e$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$e59c07196a2b1f1e$var$EventHandler.on(element, 'mouseover', $e59c07196a2b1f1e$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$6);
        $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($e59c07196a2b1f1e$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e59c07196a2b1f1e$var$EventHandler.off(element, 'mouseover', $e59c07196a2b1f1e$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $e59c07196a2b1f1e$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$e59c07196a2b1f1e$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$e59c07196a2b1f1e$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $1e278783c7067372$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($e59c07196a2b1f1e$var$isElement(this._config.reference)) referenceElement = $e59c07196a2b1f1e$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $1e278783c7067372$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_DROPEND)) return $e59c07196a2b1f1e$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_DROPSTART)) return $e59c07196a2b1f1e$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_DROPUP_CENTER)) return $e59c07196a2b1f1e$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_DROPDOWN_CENTER)) return $e59c07196a2b1f1e$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_DROPUP)) return isEnd ? $e59c07196a2b1f1e$var$PLACEMENT_TOPEND : $e59c07196a2b1f1e$var$PLACEMENT_TOP;
        return isEnd ? $e59c07196a2b1f1e$var$PLACEMENT_BOTTOMEND : $e59c07196a2b1f1e$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($e59c07196a2b1f1e$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $e59c07196a2b1f1e$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$e59c07196a2b1f1e$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $e59c07196a2b1f1e$var$SelectorEngine.find($e59c07196a2b1f1e$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$e59c07196a2b1f1e$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $e59c07196a2b1f1e$var$getNextActiveElement(items, target, key === $e59c07196a2b1f1e$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e59c07196a2b1f1e$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $e59c07196a2b1f1e$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $e59c07196a2b1f1e$var$TAB_KEY$1) return;
        const openToggles = $e59c07196a2b1f1e$var$SelectorEngine.find($e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $e59c07196a2b1f1e$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $e59c07196a2b1f1e$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $e59c07196a2b1f1e$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $e59c07196a2b1f1e$var$ARROW_UP_KEY$1,
            $e59c07196a2b1f1e$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$3) ? this : $e59c07196a2b1f1e$var$SelectorEngine.prev(this, $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$3)[0] || $e59c07196a2b1f1e$var$SelectorEngine.next(this, $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$3)[0] || $e59c07196a2b1f1e$var$SelectorEngine.findOne($e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $e59c07196a2b1f1e$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_KEYDOWN_DATA_API, $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$3, $e59c07196a2b1f1e$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_KEYDOWN_DATA_API, $e59c07196a2b1f1e$var$SELECTOR_MENU, $e59c07196a2b1f1e$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$3, $e59c07196a2b1f1e$export$931cbfb6bfb85fc.clearMenus);
$e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_KEYUP_DATA_API, $e59c07196a2b1f1e$export$931cbfb6bfb85fc.clearMenus);
$e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$3, $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $e59c07196a2b1f1e$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $e59c07196a2b1f1e$var$defineJQueryPlugin($e59c07196a2b1f1e$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$9 = 'backdrop';
const $e59c07196a2b1f1e$var$CLASS_NAME_FADE$4 = 'fade';
const $e59c07196a2b1f1e$var$CLASS_NAME_SHOW$5 = 'show';
const $e59c07196a2b1f1e$var$EVENT_MOUSEDOWN = `mousedown.bs.${$e59c07196a2b1f1e$var$NAME$9}`;
const $e59c07196a2b1f1e$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $e59c07196a2b1f1e$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$var$Backdrop extends $e59c07196a2b1f1e$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default$8;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType$8;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $e59c07196a2b1f1e$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $e59c07196a2b1f1e$var$reflow(element);
        element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $e59c07196a2b1f1e$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $e59c07196a2b1f1e$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $e59c07196a2b1f1e$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $e59c07196a2b1f1e$var$EventHandler.off(this._element, $e59c07196a2b1f1e$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $e59c07196a2b1f1e$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $e59c07196a2b1f1e$var$EventHandler.on(element, $e59c07196a2b1f1e$var$EVENT_MOUSEDOWN, ()=>{
            $e59c07196a2b1f1e$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $e59c07196a2b1f1e$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$8 = 'focustrap';
const $e59c07196a2b1f1e$var$DATA_KEY$5 = 'bs.focustrap';
const $e59c07196a2b1f1e$var$EVENT_KEY$5 = `.${$e59c07196a2b1f1e$var$DATA_KEY$5}`;
const $e59c07196a2b1f1e$var$EVENT_FOCUSIN$2 = `focusin${$e59c07196a2b1f1e$var$EVENT_KEY$5}`;
const $e59c07196a2b1f1e$var$EVENT_KEYDOWN_TAB = `keydown.tab${$e59c07196a2b1f1e$var$EVENT_KEY$5}`;
const $e59c07196a2b1f1e$var$TAB_KEY = 'Tab';
const $e59c07196a2b1f1e$var$TAB_NAV_FORWARD = 'forward';
const $e59c07196a2b1f1e$var$TAB_NAV_BACKWARD = 'backward';
const $e59c07196a2b1f1e$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $e59c07196a2b1f1e$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$var$FocusTrap extends $e59c07196a2b1f1e$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default$7;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType$7;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $e59c07196a2b1f1e$var$EventHandler.off(document, $e59c07196a2b1f1e$var$EVENT_KEY$5); // guard against infinite focus loop
        $e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $e59c07196a2b1f1e$var$EventHandler.off(document, $e59c07196a2b1f1e$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $e59c07196a2b1f1e$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $e59c07196a2b1f1e$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $e59c07196a2b1f1e$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $e59c07196a2b1f1e$var$TAB_NAV_BACKWARD : $e59c07196a2b1f1e$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $e59c07196a2b1f1e$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $e59c07196a2b1f1e$var$PROPERTY_PADDING = 'padding-right';
const $e59c07196a2b1f1e$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $e59c07196a2b1f1e$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $e59c07196a2b1f1e$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($e59c07196a2b1f1e$var$SELECTOR_FIXED_CONTENT, $e59c07196a2b1f1e$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($e59c07196a2b1f1e$var$SELECTOR_STICKY_CONTENT, $e59c07196a2b1f1e$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $e59c07196a2b1f1e$var$PROPERTY_PADDING);
        this._resetElementAttributes($e59c07196a2b1f1e$var$SELECTOR_FIXED_CONTENT, $e59c07196a2b1f1e$var$PROPERTY_PADDING);
        this._resetElementAttributes($e59c07196a2b1f1e$var$SELECTOR_STICKY_CONTENT, $e59c07196a2b1f1e$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $e59c07196a2b1f1e$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $e59c07196a2b1f1e$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $e59c07196a2b1f1e$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($e59c07196a2b1f1e$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $e59c07196a2b1f1e$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$7 = 'modal';
const $e59c07196a2b1f1e$var$DATA_KEY$4 = 'bs.modal';
const $e59c07196a2b1f1e$var$EVENT_KEY$4 = `.${$e59c07196a2b1f1e$var$DATA_KEY$4}`;
const $e59c07196a2b1f1e$var$DATA_API_KEY$2 = '.data-api';
const $e59c07196a2b1f1e$var$ESCAPE_KEY$1 = 'Escape';
const $e59c07196a2b1f1e$var$EVENT_HIDE$4 = `hide${$e59c07196a2b1f1e$var$EVENT_KEY$4}`;
const $e59c07196a2b1f1e$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$e59c07196a2b1f1e$var$EVENT_KEY$4}`;
const $e59c07196a2b1f1e$var$EVENT_HIDDEN$4 = `hidden${$e59c07196a2b1f1e$var$EVENT_KEY$4}`;
const $e59c07196a2b1f1e$var$EVENT_SHOW$4 = `show${$e59c07196a2b1f1e$var$EVENT_KEY$4}`;
const $e59c07196a2b1f1e$var$EVENT_SHOWN$4 = `shown${$e59c07196a2b1f1e$var$EVENT_KEY$4}`;
const $e59c07196a2b1f1e$var$EVENT_RESIZE$1 = `resize${$e59c07196a2b1f1e$var$EVENT_KEY$4}`;
const $e59c07196a2b1f1e$var$EVENT_CLICK_DISMISS = `click.dismiss${$e59c07196a2b1f1e$var$EVENT_KEY$4}`;
const $e59c07196a2b1f1e$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$e59c07196a2b1f1e$var$EVENT_KEY$4}`;
const $e59c07196a2b1f1e$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$e59c07196a2b1f1e$var$EVENT_KEY$4}`;
const $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$2 = `click${$e59c07196a2b1f1e$var$EVENT_KEY$4}${$e59c07196a2b1f1e$var$DATA_API_KEY$2}`;
const $e59c07196a2b1f1e$var$CLASS_NAME_OPEN = 'modal-open';
const $e59c07196a2b1f1e$var$CLASS_NAME_FADE$3 = 'fade';
const $e59c07196a2b1f1e$var$CLASS_NAME_SHOW$4 = 'show';
const $e59c07196a2b1f1e$var$CLASS_NAME_STATIC = 'modal-static';
const $e59c07196a2b1f1e$var$OPEN_SELECTOR$1 = '.modal.show';
const $e59c07196a2b1f1e$var$SELECTOR_DIALOG = '.modal-dialog';
const $e59c07196a2b1f1e$var$SELECTOR_MODAL_BODY = '.modal-body';
const $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $e59c07196a2b1f1e$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $e59c07196a2b1f1e$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$export$2b77a92f1a5ad772 extends $e59c07196a2b1f1e$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $e59c07196a2b1f1e$var$SelectorEngine.findOne($e59c07196a2b1f1e$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $e59c07196a2b1f1e$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default$6;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType$6;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $e59c07196a2b1f1e$var$EventHandler.off(window, $e59c07196a2b1f1e$var$EVENT_KEY$4);
        $e59c07196a2b1f1e$var$EventHandler.off(this._dialog, $e59c07196a2b1f1e$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $e59c07196a2b1f1e$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $e59c07196a2b1f1e$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $e59c07196a2b1f1e$var$SelectorEngine.findOne($e59c07196a2b1f1e$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $e59c07196a2b1f1e$var$reflow(this._element);
        this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $e59c07196a2b1f1e$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $e59c07196a2b1f1e$var$EventHandler.on(window, $e59c07196a2b1f1e$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $e59c07196a2b1f1e$var$EventHandler.one(this._element, $e59c07196a2b1f1e$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $e59c07196a2b1f1e$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $e59c07196a2b1f1e$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $e59c07196a2b1f1e$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$2, $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $e59c07196a2b1f1e$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $e59c07196a2b1f1e$var$EventHandler.one(target, $e59c07196a2b1f1e$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $e59c07196a2b1f1e$var$EventHandler.one(target, $e59c07196a2b1f1e$var$EVENT_HIDDEN$4, ()=>{
            if ($e59c07196a2b1f1e$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $e59c07196a2b1f1e$var$SelectorEngine.findOne($e59c07196a2b1f1e$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $e59c07196a2b1f1e$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $e59c07196a2b1f1e$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$e59c07196a2b1f1e$var$enableDismissTrigger($e59c07196a2b1f1e$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $e59c07196a2b1f1e$var$defineJQueryPlugin($e59c07196a2b1f1e$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$6 = 'offcanvas';
const $e59c07196a2b1f1e$var$DATA_KEY$3 = 'bs.offcanvas';
const $e59c07196a2b1f1e$var$EVENT_KEY$3 = `.${$e59c07196a2b1f1e$var$DATA_KEY$3}`;
const $e59c07196a2b1f1e$var$DATA_API_KEY$1 = '.data-api';
const $e59c07196a2b1f1e$var$EVENT_LOAD_DATA_API$2 = `load${$e59c07196a2b1f1e$var$EVENT_KEY$3}${$e59c07196a2b1f1e$var$DATA_API_KEY$1}`;
const $e59c07196a2b1f1e$var$ESCAPE_KEY = 'Escape';
const $e59c07196a2b1f1e$var$CLASS_NAME_SHOW$3 = 'show';
const $e59c07196a2b1f1e$var$CLASS_NAME_SHOWING$1 = 'showing';
const $e59c07196a2b1f1e$var$CLASS_NAME_HIDING = 'hiding';
const $e59c07196a2b1f1e$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $e59c07196a2b1f1e$var$OPEN_SELECTOR = '.offcanvas.show';
const $e59c07196a2b1f1e$var$EVENT_SHOW$3 = `show${$e59c07196a2b1f1e$var$EVENT_KEY$3}`;
const $e59c07196a2b1f1e$var$EVENT_SHOWN$3 = `shown${$e59c07196a2b1f1e$var$EVENT_KEY$3}`;
const $e59c07196a2b1f1e$var$EVENT_HIDE$3 = `hide${$e59c07196a2b1f1e$var$EVENT_KEY$3}`;
const $e59c07196a2b1f1e$var$EVENT_HIDE_PREVENTED = `hidePrevented${$e59c07196a2b1f1e$var$EVENT_KEY$3}`;
const $e59c07196a2b1f1e$var$EVENT_HIDDEN$3 = `hidden${$e59c07196a2b1f1e$var$EVENT_KEY$3}`;
const $e59c07196a2b1f1e$var$EVENT_RESIZE = `resize${$e59c07196a2b1f1e$var$EVENT_KEY$3}`;
const $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$1 = `click${$e59c07196a2b1f1e$var$EVENT_KEY$3}${$e59c07196a2b1f1e$var$DATA_API_KEY$1}`;
const $e59c07196a2b1f1e$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$e59c07196a2b1f1e$var$EVENT_KEY$3}`;
const $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $e59c07196a2b1f1e$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $e59c07196a2b1f1e$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$export$591ca0244c9dfcd4 extends $e59c07196a2b1f1e$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default$5;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType$5;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $e59c07196a2b1f1e$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_SHOWING$1);
            $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$3, $e59c07196a2b1f1e$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $e59c07196a2b1f1e$var$ScrollBarHelper().reset();
            $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $e59c07196a2b1f1e$var$Backdrop({
            className: $e59c07196a2b1f1e$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $e59c07196a2b1f1e$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $e59c07196a2b1f1e$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e59c07196a2b1f1e$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API$1, $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $e59c07196a2b1f1e$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($e59c07196a2b1f1e$var$isDisabled(this)) return;
    $e59c07196a2b1f1e$var$EventHandler.one(target, $e59c07196a2b1f1e$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($e59c07196a2b1f1e$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $e59c07196a2b1f1e$var$SelectorEngine.findOne($e59c07196a2b1f1e$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $e59c07196a2b1f1e$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $e59c07196a2b1f1e$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$e59c07196a2b1f1e$var$EventHandler.on(window, $e59c07196a2b1f1e$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $e59c07196a2b1f1e$var$SelectorEngine.find($e59c07196a2b1f1e$var$OPEN_SELECTOR))$e59c07196a2b1f1e$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$e59c07196a2b1f1e$var$EventHandler.on(window, $e59c07196a2b1f1e$var$EVENT_RESIZE, ()=>{
    for (const element of $e59c07196a2b1f1e$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $e59c07196a2b1f1e$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$e59c07196a2b1f1e$var$enableDismissTrigger($e59c07196a2b1f1e$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $e59c07196a2b1f1e$var$defineJQueryPlugin($e59c07196a2b1f1e$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $e59c07196a2b1f1e$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $e59c07196a2b1f1e$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $e59c07196a2b1f1e$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $e59c07196a2b1f1e$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $e59c07196a2b1f1e$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $e59c07196a2b1f1e$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($e59c07196a2b1f1e$var$uriAttributes.has(attributeName)) return Boolean($e59c07196a2b1f1e$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $e59c07196a2b1f1e$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$e59c07196a2b1f1e$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$5 = 'TemplateFactory';
const $e59c07196a2b1f1e$var$Default$4 = {
    allowList: $e59c07196a2b1f1e$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $e59c07196a2b1f1e$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $e59c07196a2b1f1e$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$var$TemplateFactory extends $e59c07196a2b1f1e$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default$4;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType$4;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $e59c07196a2b1f1e$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $e59c07196a2b1f1e$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($e59c07196a2b1f1e$var$isElement(content)) {
            this._putElementInTemplate($e59c07196a2b1f1e$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $e59c07196a2b1f1e$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $e59c07196a2b1f1e$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$4 = 'tooltip';
const $e59c07196a2b1f1e$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $e59c07196a2b1f1e$var$CLASS_NAME_FADE$2 = 'fade';
const $e59c07196a2b1f1e$var$CLASS_NAME_MODAL = 'modal';
const $e59c07196a2b1f1e$var$CLASS_NAME_SHOW$2 = 'show';
const $e59c07196a2b1f1e$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $e59c07196a2b1f1e$var$SELECTOR_MODAL = `.${$e59c07196a2b1f1e$var$CLASS_NAME_MODAL}`;
const $e59c07196a2b1f1e$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $e59c07196a2b1f1e$var$TRIGGER_HOVER = 'hover';
const $e59c07196a2b1f1e$var$TRIGGER_FOCUS = 'focus';
const $e59c07196a2b1f1e$var$TRIGGER_CLICK = 'click';
const $e59c07196a2b1f1e$var$TRIGGER_MANUAL = 'manual';
const $e59c07196a2b1f1e$var$EVENT_HIDE$2 = 'hide';
const $e59c07196a2b1f1e$var$EVENT_HIDDEN$2 = 'hidden';
const $e59c07196a2b1f1e$var$EVENT_SHOW$2 = 'show';
const $e59c07196a2b1f1e$var$EVENT_SHOWN$2 = 'shown';
const $e59c07196a2b1f1e$var$EVENT_INSERTED = 'inserted';
const $e59c07196a2b1f1e$var$EVENT_CLICK$1 = 'click';
const $e59c07196a2b1f1e$var$EVENT_FOCUSIN$1 = 'focusin';
const $e59c07196a2b1f1e$var$EVENT_FOCUSOUT$1 = 'focusout';
const $e59c07196a2b1f1e$var$EVENT_MOUSEENTER = 'mouseenter';
const $e59c07196a2b1f1e$var$EVENT_MOUSELEAVE = 'mouseleave';
const $e59c07196a2b1f1e$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $e59c07196a2b1f1e$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $e59c07196a2b1f1e$var$isRTL() ? 'right' : 'left'
};
const $e59c07196a2b1f1e$var$Default$3 = {
    allowList: $e59c07196a2b1f1e$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $e59c07196a2b1f1e$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$export$28c660c63b792dea extends $e59c07196a2b1f1e$var$BaseComponent {
    constructor(element, config){
        if (typeof $1e278783c7067372$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default$3;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType$3;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $e59c07196a2b1f1e$var$EventHandler.off(this._element.closest($e59c07196a2b1f1e$var$SELECTOR_MODAL), $e59c07196a2b1f1e$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, this.constructor.eventName($e59c07196a2b1f1e$var$EVENT_SHOW$2));
        const shadowRoot = $e59c07196a2b1f1e$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, this.constructor.eventName($e59c07196a2b1f1e$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e59c07196a2b1f1e$var$EventHandler.on(element, 'mouseover', $e59c07196a2b1f1e$var$noop);
        const complete = ()=>{
            $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, this.constructor.eventName($e59c07196a2b1f1e$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, this.constructor.eventName($e59c07196a2b1f1e$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$e59c07196a2b1f1e$var$EventHandler.off(element, 'mouseover', $e59c07196a2b1f1e$var$noop);
        this._activeTrigger[$e59c07196a2b1f1e$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$e59c07196a2b1f1e$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$e59c07196a2b1f1e$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, this.constructor.eventName($e59c07196a2b1f1e$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_FADE$2, $e59c07196a2b1f1e$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $e59c07196a2b1f1e$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $e59c07196a2b1f1e$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$e59c07196a2b1f1e$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $e59c07196a2b1f1e$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $e59c07196a2b1f1e$var$AttachmentMap[placement.toUpperCase()];
        return $1e278783c7067372$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $e59c07196a2b1f1e$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$e59c07196a2b1f1e$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $e59c07196a2b1f1e$var$EventHandler.on(this._element, this.constructor.eventName($e59c07196a2b1f1e$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$e59c07196a2b1f1e$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$e59c07196a2b1f1e$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $e59c07196a2b1f1e$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $e59c07196a2b1f1e$var$TRIGGER_HOVER ? this.constructor.eventName($e59c07196a2b1f1e$var$EVENT_MOUSEENTER) : this.constructor.eventName($e59c07196a2b1f1e$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $e59c07196a2b1f1e$var$TRIGGER_HOVER ? this.constructor.eventName($e59c07196a2b1f1e$var$EVENT_MOUSELEAVE) : this.constructor.eventName($e59c07196a2b1f1e$var$EVENT_FOCUSOUT$1);
                $e59c07196a2b1f1e$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $e59c07196a2b1f1e$var$TRIGGER_FOCUS : $e59c07196a2b1f1e$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $e59c07196a2b1f1e$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $e59c07196a2b1f1e$var$TRIGGER_FOCUS : $e59c07196a2b1f1e$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $e59c07196a2b1f1e$var$EventHandler.on(this._element.closest($e59c07196a2b1f1e$var$SELECTOR_MODAL), $e59c07196a2b1f1e$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $e59c07196a2b1f1e$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($e59c07196a2b1f1e$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $e59c07196a2b1f1e$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e59c07196a2b1f1e$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e59c07196a2b1f1e$var$defineJQueryPlugin($e59c07196a2b1f1e$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$3 = 'popover';
const $e59c07196a2b1f1e$var$SELECTOR_TITLE = '.popover-header';
const $e59c07196a2b1f1e$var$SELECTOR_CONTENT = '.popover-body';
const $e59c07196a2b1f1e$var$Default$2 = {
    ...$e59c07196a2b1f1e$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $e59c07196a2b1f1e$var$DefaultType$2 = {
    ...$e59c07196a2b1f1e$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$export$5b6b19405a83ff9d extends $e59c07196a2b1f1e$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default$2;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType$2;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$e59c07196a2b1f1e$var$SELECTOR_TITLE]: this._getTitle(),
            [$e59c07196a2b1f1e$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e59c07196a2b1f1e$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e59c07196a2b1f1e$var$defineJQueryPlugin($e59c07196a2b1f1e$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$2 = 'scrollspy';
const $e59c07196a2b1f1e$var$DATA_KEY$2 = 'bs.scrollspy';
const $e59c07196a2b1f1e$var$EVENT_KEY$2 = `.${$e59c07196a2b1f1e$var$DATA_KEY$2}`;
const $e59c07196a2b1f1e$var$DATA_API_KEY = '.data-api';
const $e59c07196a2b1f1e$var$EVENT_ACTIVATE = `activate${$e59c07196a2b1f1e$var$EVENT_KEY$2}`;
const $e59c07196a2b1f1e$var$EVENT_CLICK = `click${$e59c07196a2b1f1e$var$EVENT_KEY$2}`;
const $e59c07196a2b1f1e$var$EVENT_LOAD_DATA_API$1 = `load${$e59c07196a2b1f1e$var$EVENT_KEY$2}${$e59c07196a2b1f1e$var$DATA_API_KEY}`;
const $e59c07196a2b1f1e$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$1 = 'active';
const $e59c07196a2b1f1e$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $e59c07196a2b1f1e$var$SELECTOR_TARGET_LINKS = '[href]';
const $e59c07196a2b1f1e$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $e59c07196a2b1f1e$var$SELECTOR_NAV_LINKS = '.nav-link';
const $e59c07196a2b1f1e$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $e59c07196a2b1f1e$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $e59c07196a2b1f1e$var$SELECTOR_LINK_ITEMS = `${$e59c07196a2b1f1e$var$SELECTOR_NAV_LINKS}, ${$e59c07196a2b1f1e$var$SELECTOR_NAV_ITEMS} > ${$e59c07196a2b1f1e$var$SELECTOR_NAV_LINKS}, ${$e59c07196a2b1f1e$var$SELECTOR_LIST_ITEMS}`;
const $e59c07196a2b1f1e$var$SELECTOR_DROPDOWN = '.dropdown';
const $e59c07196a2b1f1e$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $e59c07196a2b1f1e$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $e59c07196a2b1f1e$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$export$a6472a5298a374be extends $e59c07196a2b1f1e$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default$1;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType$1;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $e59c07196a2b1f1e$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $e59c07196a2b1f1e$var$EventHandler.off(this._config.target, $e59c07196a2b1f1e$var$EVENT_CLICK);
        $e59c07196a2b1f1e$var$EventHandler.on(this._config.target, $e59c07196a2b1f1e$var$EVENT_CLICK, $e59c07196a2b1f1e$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $e59c07196a2b1f1e$var$SelectorEngine.find($e59c07196a2b1f1e$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $e59c07196a2b1f1e$var$isDisabled(anchor)) continue;
            const observableSection = $e59c07196a2b1f1e$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($e59c07196a2b1f1e$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $e59c07196a2b1f1e$var$SelectorEngine.findOne($e59c07196a2b1f1e$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($e59c07196a2b1f1e$var$SELECTOR_DROPDOWN)).classList.add($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $e59c07196a2b1f1e$var$SelectorEngine.parents(target, $e59c07196a2b1f1e$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $e59c07196a2b1f1e$var$SelectorEngine.prev(listGroup, $e59c07196a2b1f1e$var$SELECTOR_LINK_ITEMS))item.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $e59c07196a2b1f1e$var$SelectorEngine.find(`${$e59c07196a2b1f1e$var$SELECTOR_TARGET_LINKS}.${$e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e59c07196a2b1f1e$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e59c07196a2b1f1e$var$EventHandler.on(window, $e59c07196a2b1f1e$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $e59c07196a2b1f1e$var$SelectorEngine.find($e59c07196a2b1f1e$var$SELECTOR_DATA_SPY))$e59c07196a2b1f1e$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $e59c07196a2b1f1e$var$defineJQueryPlugin($e59c07196a2b1f1e$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME$1 = 'tab';
const $e59c07196a2b1f1e$var$DATA_KEY$1 = 'bs.tab';
const $e59c07196a2b1f1e$var$EVENT_KEY$1 = `.${$e59c07196a2b1f1e$var$DATA_KEY$1}`;
const $e59c07196a2b1f1e$var$EVENT_HIDE$1 = `hide${$e59c07196a2b1f1e$var$EVENT_KEY$1}`;
const $e59c07196a2b1f1e$var$EVENT_HIDDEN$1 = `hidden${$e59c07196a2b1f1e$var$EVENT_KEY$1}`;
const $e59c07196a2b1f1e$var$EVENT_SHOW$1 = `show${$e59c07196a2b1f1e$var$EVENT_KEY$1}`;
const $e59c07196a2b1f1e$var$EVENT_SHOWN$1 = `shown${$e59c07196a2b1f1e$var$EVENT_KEY$1}`;
const $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API = `click${$e59c07196a2b1f1e$var$EVENT_KEY$1}`;
const $e59c07196a2b1f1e$var$EVENT_KEYDOWN = `keydown${$e59c07196a2b1f1e$var$EVENT_KEY$1}`;
const $e59c07196a2b1f1e$var$EVENT_LOAD_DATA_API = `load${$e59c07196a2b1f1e$var$EVENT_KEY$1}`;
const $e59c07196a2b1f1e$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $e59c07196a2b1f1e$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $e59c07196a2b1f1e$var$ARROW_UP_KEY = 'ArrowUp';
const $e59c07196a2b1f1e$var$ARROW_DOWN_KEY = 'ArrowDown';
const $e59c07196a2b1f1e$var$HOME_KEY = 'Home';
const $e59c07196a2b1f1e$var$END_KEY = 'End';
const $e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE = 'active';
const $e59c07196a2b1f1e$var$CLASS_NAME_FADE$1 = 'fade';
const $e59c07196a2b1f1e$var$CLASS_NAME_SHOW$1 = 'show';
const $e59c07196a2b1f1e$var$CLASS_DROPDOWN = 'dropdown';
const $e59c07196a2b1f1e$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $e59c07196a2b1f1e$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $e59c07196a2b1f1e$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$e59c07196a2b1f1e$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $e59c07196a2b1f1e$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $e59c07196a2b1f1e$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $e59c07196a2b1f1e$var$SELECTOR_INNER = `.nav-link${$e59c07196a2b1f1e$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$e59c07196a2b1f1e$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$e59c07196a2b1f1e$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $e59c07196a2b1f1e$var$SELECTOR_INNER_ELEM = `${$e59c07196a2b1f1e$var$SELECTOR_INNER}, ${$e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE}`;
const $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $e59c07196a2b1f1e$export$3e41faf802a29e71 extends $e59c07196a2b1f1e$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($e59c07196a2b1f1e$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $e59c07196a2b1f1e$var$EventHandler.trigger(active, $e59c07196a2b1f1e$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(innerElem, $e59c07196a2b1f1e$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE);
        this._activate($e59c07196a2b1f1e$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $e59c07196a2b1f1e$var$EventHandler.trigger(element, $e59c07196a2b1f1e$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($e59c07196a2b1f1e$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $e59c07196a2b1f1e$var$EventHandler.trigger(element, $e59c07196a2b1f1e$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $e59c07196a2b1f1e$var$ARROW_LEFT_KEY,
            $e59c07196a2b1f1e$var$ARROW_RIGHT_KEY,
            $e59c07196a2b1f1e$var$ARROW_UP_KEY,
            $e59c07196a2b1f1e$var$ARROW_DOWN_KEY,
            $e59c07196a2b1f1e$var$HOME_KEY,
            $e59c07196a2b1f1e$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$e59c07196a2b1f1e$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $e59c07196a2b1f1e$var$HOME_KEY,
            $e59c07196a2b1f1e$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $e59c07196a2b1f1e$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $e59c07196a2b1f1e$var$ARROW_RIGHT_KEY,
                $e59c07196a2b1f1e$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $e59c07196a2b1f1e$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $e59c07196a2b1f1e$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $e59c07196a2b1f1e$var$SelectorEngine.find($e59c07196a2b1f1e$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $e59c07196a2b1f1e$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($e59c07196a2b1f1e$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $e59c07196a2b1f1e$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($e59c07196a2b1f1e$var$SELECTOR_DROPDOWN_TOGGLE, $e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE);
        toggle($e59c07196a2b1f1e$var$SELECTOR_DROPDOWN_MENU, $e59c07196a2b1f1e$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($e59c07196a2b1f1e$var$SELECTOR_INNER_ELEM) ? elem : $e59c07196a2b1f1e$var$SelectorEngine.findOne($e59c07196a2b1f1e$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($e59c07196a2b1f1e$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e59c07196a2b1f1e$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e59c07196a2b1f1e$var$EventHandler.on(document, $e59c07196a2b1f1e$var$EVENT_CLICK_DATA_API, $e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($e59c07196a2b1f1e$var$isDisabled(this)) return;
    $e59c07196a2b1f1e$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $e59c07196a2b1f1e$var$EventHandler.on(window, $e59c07196a2b1f1e$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $e59c07196a2b1f1e$var$SelectorEngine.find($e59c07196a2b1f1e$var$SELECTOR_DATA_TOGGLE_ACTIVE))$e59c07196a2b1f1e$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $e59c07196a2b1f1e$var$defineJQueryPlugin($e59c07196a2b1f1e$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e59c07196a2b1f1e$var$NAME = 'toast';
const $e59c07196a2b1f1e$var$DATA_KEY = 'bs.toast';
const $e59c07196a2b1f1e$var$EVENT_KEY = `.${$e59c07196a2b1f1e$var$DATA_KEY}`;
const $e59c07196a2b1f1e$var$EVENT_MOUSEOVER = `mouseover${$e59c07196a2b1f1e$var$EVENT_KEY}`;
const $e59c07196a2b1f1e$var$EVENT_MOUSEOUT = `mouseout${$e59c07196a2b1f1e$var$EVENT_KEY}`;
const $e59c07196a2b1f1e$var$EVENT_FOCUSIN = `focusin${$e59c07196a2b1f1e$var$EVENT_KEY}`;
const $e59c07196a2b1f1e$var$EVENT_FOCUSOUT = `focusout${$e59c07196a2b1f1e$var$EVENT_KEY}`;
const $e59c07196a2b1f1e$var$EVENT_HIDE = `hide${$e59c07196a2b1f1e$var$EVENT_KEY}`;
const $e59c07196a2b1f1e$var$EVENT_HIDDEN = `hidden${$e59c07196a2b1f1e$var$EVENT_KEY}`;
const $e59c07196a2b1f1e$var$EVENT_SHOW = `show${$e59c07196a2b1f1e$var$EVENT_KEY}`;
const $e59c07196a2b1f1e$var$EVENT_SHOWN = `shown${$e59c07196a2b1f1e$var$EVENT_KEY}`;
const $e59c07196a2b1f1e$var$CLASS_NAME_FADE = 'fade';
const $e59c07196a2b1f1e$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $e59c07196a2b1f1e$var$CLASS_NAME_SHOW = 'show';
const $e59c07196a2b1f1e$var$CLASS_NAME_SHOWING = 'showing';
const $e59c07196a2b1f1e$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $e59c07196a2b1f1e$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $e59c07196a2b1f1e$export$8d8dc7d5f743331b extends $e59c07196a2b1f1e$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $e59c07196a2b1f1e$var$Default;
    }
    static get DefaultType() {
        return $e59c07196a2b1f1e$var$DefaultType;
    }
    static get NAME() {
        return $e59c07196a2b1f1e$var$NAME;
    }
    // Public
    show() {
        const showEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_SHOWING);
            $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_HIDE); // @deprecated
        $e59c07196a2b1f1e$var$reflow(this._element);
        this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_SHOW, $e59c07196a2b1f1e$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_SHOWING, $e59c07196a2b1f1e$var$CLASS_NAME_SHOW);
            $e59c07196a2b1f1e$var$EventHandler.trigger(this._element, $e59c07196a2b1f1e$var$EVENT_HIDDEN);
        };
        this._element.classList.add($e59c07196a2b1f1e$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($e59c07196a2b1f1e$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($e59c07196a2b1f1e$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $e59c07196a2b1f1e$var$EventHandler.on(this._element, $e59c07196a2b1f1e$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e59c07196a2b1f1e$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $e59c07196a2b1f1e$var$enableDismissTrigger($e59c07196a2b1f1e$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $e59c07196a2b1f1e$var$defineJQueryPlugin($e59c07196a2b1f1e$export$8d8dc7d5f743331b);


(document.querySelectorAll('[data-bs-toggle="tooltip"]') || []).forEach((tooltipTriggerEl)=>new $e59c07196a2b1f1e$export$28c660c63b792dea(tooltipTriggerEl));


"use strict";
/* jshint unused: false */ // -------------------------------------------------------
// Helper Functions
// -------------------------------------------------------
// Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function $ca25f02f047c9e4f$var$awUserLoggedInEvent() {
    const userLoggedInEvent = new CustomEvent('userLoggedIn', {
        bubbles: true,
        cancelable: false
    });
    let userData = $ca25f02f047c9e4f$var$awGetUserData();
    if (userData) document.dispatchEvent(userLoggedInEvent);
}
window.awUserLoggedInEvent = $ca25f02f047c9e4f$var$awUserLoggedInEvent;
function $ca25f02f047c9e4f$var$debounce(func, wait, immediate) {
    var timeout;
    return function executedFunction() {
        var context = this;
        var args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
window.debounce = $ca25f02f047c9e4f$var$debounce;
function $ca25f02f047c9e4f$var$isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}
window.isEmail = $ca25f02f047c9e4f$var$isEmail;
/**
 * Parse the query string.
 * @param {string} name - The name of the query string parameter to retrieve
 * @param {string} url - The URL to parse. Defaults to window.location.href
 * @see https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
 */ function $ca25f02f047c9e4f$var$getParameterByName(name, url = window.location.href) {
    try {
        const params = new URL(url, window.location.href).searchParams;
        return params.has(name) ? params.get(name) : null;
    } catch (err) {
        return null;
    }
}
window.getParameterByName = $ca25f02f047c9e4f$var$getParameterByName;
// Remove query string by name
function $ca25f02f047c9e4f$var$removeParam(url, param) {
    if (url && param && url.indexOf('?') !== -1) {
        var urlBase = url.substring(0, url.indexOf('?')), params = url.split(/&|\?/), keepParams = [];
        params.shift();
        for(var i = 0; i < params.length; i++){
            var paramKeyNamePair = params[i].split('=');
            if (paramKeyNamePair.length) {
                var paramName = paramKeyNamePair[0];
                if (params[i].indexOf(param) === 0 && param.length === paramName.length) ;
                else keepParams.push(params[i]);
            }
        }
        url = urlBase + '?' + keepParams.join('&');
    }
    return url;
}
window.removeParam = $ca25f02f047c9e4f$var$removeParam;
// Add query string to URL, or update if it already exists
function $ca25f02f047c9e4f$var$addUrlParam(url, key, value) {
    var key = encodeURIComponent(key), value = encodeURIComponent(value);
    var baseUrl = url.split('?')[0], newParam = key + '=' + value, params = '?' + newParam, urlQueryString;
    if (url.split('?')[1] === undefined) // if there are no query strings, make urlQueryString empty
    urlQueryString = '';
    else urlQueryString = '?' + url.split('?')[1];
    // If the "search" string exists, then build params from it
    if (urlQueryString) {
        var updateRegex = new RegExp('([\?&])' + key + '=[^&]*');
        var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');
        if (value === undefined || value === null || value === '') {
            // Remove param if value is empty
            params = urlQueryString.replace(removeRegex, "$1");
            params = params.replace(/[&;]$/, "");
        } else if (urlQueryString.match(updateRegex) !== null) // If param exists already, update it
        params = urlQueryString.replace(updateRegex, "$1" + newParam);
        else if (urlQueryString == '') // If there are no query strings
        params = '?' + newParam;
        else // Otherwise, add it to end of query string
        params = urlQueryString + '&' + newParam;
    }
    // no parameter was set so we don't need the question mark
    params = params === '?' ? '' : params;
    return baseUrl + params;
}
window.addUrlParam = $ca25f02f047c9e4f$var$addUrlParam;
// Wait for a global variable to be defined.
// https://github.com/OwenMelbz/whendefined
/*
    Example: waiting for a variable helloWorld

    whenDefined(window, 'helloWorld', function() {
        alert( 'hello!' );
    });
*/ function $ca25f02f047c9e4f$var$whenDefined(context, variable, callback) {
    if (context[variable]) callback();
    else Object.defineProperty(context, variable, {
        configurable: true,
        enumerable: true,
        writeable: true,
        get: function() {
            return this['_' + variable];
        },
        set: function(val) {
            this['_' + variable] = val;
            callback();
        }
    });
}
window.whenDefined = $ca25f02f047c9e4f$var$whenDefined;
function $ca25f02f047c9e4f$var$awIsOnScreen(elem) {
    // https://gist.github.com/EvanHerman/a1045c19e115edc18b12
    if (elem.length == 0) return;
    var $window = jQuery(window);
    var viewport_top = $window.scrollTop();
    var viewport_height = $window.height();
    var viewport_bottom = viewport_top + viewport_height;
    var $elem = jQuery(elem);
    var top = $elem.offset().top;
    var height = $elem.height();
    var bottom = top + height;
    return top >= viewport_top && top < viewport_bottom || bottom > viewport_top && bottom <= viewport_bottom || height > viewport_height && top <= viewport_top && bottom >= viewport_bottom;
}
window.awIsOnScreen = $ca25f02f047c9e4f$var$awIsOnScreen;
function $ca25f02f047c9e4f$var$awRedirectWithParameters(params) {
    console.log('awRedirectWithParameters called');
    let url = window.location.href;
    for(var key in params){
        if (url.indexOf('?') === -1) url += '?';
        else url += '&';
        if (params.hasOwnProperty(key)) url += key + '=' + params[key];
    }
    window.location = url;
}
window.awRedirectWithParameters = $ca25f02f047c9e4f$var$awRedirectWithParameters;
function $ca25f02f047c9e4f$var$getBlaizeData() {
    return $.ajax({
        url: '/blaize/account',
        type: 'GET'
    });
}
function $ca25f02f047c9e4f$var$awGetUserData() {
    let userData = localStorage.getItem("aw_udata");
    try {
        if (userData) {
            userData = JSON.parse(atob(userData));
            if (typeof userData === 'object') userData = JSON.parse(atob(userData.user_data));
            else userData = {};
        } else userData = {};
    } catch (err) {}
    return userData;
}
window.awGetUserData = $ca25f02f047c9e4f$var$awGetUserData;
function $ca25f02f047c9e4f$var$awUpdateUserData(fields) {
    let userData = $ca25f02f047c9e4f$var$awGetUserData();
    if (userData) {
        for(var key in fields)if (fields.hasOwnProperty(key)) userData[key] = fields[key];
    }
    localStorage.setItem('aw_udata', window.btoa(JSON.stringify(userData)));
    return userData;
}
window.awUpdateUserData = $ca25f02f047c9e4f$var$awUpdateUserData;
function $ca25f02f047c9e4f$var$awGetShadowUserData() {
    let userData = {};
    try {
        userData = JSON.parse(atob(localStorage.getItem('aw_udata_s')));
    } catch (err) {}
    return userData;
}
window.awGetShadowUserData = $ca25f02f047c9e4f$var$awGetShadowUserData;
function $ca25f02f047c9e4f$var$awUpdateShadowUserData(fields) {
    let userData = {};
    if (!window.awIsUserLoggedIn()) {
        userData = $ca25f02f047c9e4f$var$awGetShadowUserData();
        if (userData) {
            for(var key in fields)if (fields.hasOwnProperty(key)) userData[key] = fields[key];
        }
        localStorage.setItem('aw_udata', window.btoa(JSON.stringify(userData)));
    }
    return userData;
}
window.awUpdateShadowUserData = $ca25f02f047c9e4f$var$awUpdateShadowUserData;
function $ca25f02f047c9e4f$var$awGetUserCookie() {
    let userData = {};
    try {
        const localStorageData = JSON.parse(atob(localStorage.getItem("aw_udata")));
        if (typeof localStorageData === 'object') userData = JSON.parse(atob(localStorageData.user_cookie));
        else userData = {};
    // userData = JSON.parse( atob( zephr_user_object.user_cookie ) );
    } catch (err) {}
    return userData;
}
window.awGetUserCookie = $ca25f02f047c9e4f$var$awGetUserCookie;
function $ca25f02f047c9e4f$var$awDeleteUserData() {
    localStorage.removeItem('aw_udata');
}
window.awDeleteUserData = $ca25f02f047c9e4f$var$awDeleteUserData;
function $ca25f02f047c9e4f$var$awDeleteUserCookie(reloadPage) {
    try {
        Cookies.remove(aw.user_cookie_name);
        if (reloadPage) location.reload();
    } catch (err) {}
}
window.awDeleteUserCookie = $ca25f02f047c9e4f$var$awDeleteUserCookie;
function $ca25f02f047c9e4f$var$awIsUserLoggedIn() {
    let isLoggedIn = false;
    // Remove cookie handle for Blogs
    let zephr_login_cookie = Cookies.get('zephr_login');
    if (typeof Zephr !== 'undefined') {
        isLoggedIn = Zephr.accessDetails.isAuthenticated;
        if (zephr_login_cookie) Cookies.remove('zephr_login');
    }
    /* const userData = awGetUserData();
  const userCookie = awGetUserCookie();
     if ( !userData || !userCookie || jQuery.isEmptyObject( userData ) || jQuery.isEmptyObject( userCookie ) ){
      isLoggedIn = false;
  } */ const eventLoginCheck = new Event('loginCheck');
    window.dispatchEvent(eventLoginCheck);
    return isLoggedIn;
}
window.awIsUserLoggedIn = $ca25f02f047c9e4f$var$awIsUserLoggedIn;
function $ca25f02f047c9e4f$var$awIsCMSLoggedIn() {
    return jQuery('body').hasClass('logged-in');
}
window.awIsCMSLoggedIn = $ca25f02f047c9e4f$var$awIsCMSLoggedIn;
function $ca25f02f047c9e4f$var$awIsMobile() {
    var isMobile = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) isMobile = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return isMobile;
}
window.awIsMobile = $ca25f02f047c9e4f$var$awIsMobile;
window.awIsTablet = function() {
    let isTablet = false;
    if (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) isTablet = true;
    else {
        const userAgent = navigator.userAgent.toLowerCase();
        isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    }
    return isTablet;
};
function $ca25f02f047c9e4f$var$awGetRdt() {
    return window.getParameterByName('rdt') || Cookies.get('aw_rdt_url') || window.location.protocol + '//' + window.location.hostname || 'https://adweek.com';
}
window.awGetRdt = $ca25f02f047c9e4f$var$awGetRdt;
function $ca25f02f047c9e4f$var$awCopyToClipboard(str) {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
}
window.awCopyToClipboard = $ca25f02f047c9e4f$var$awCopyToClipboard;
function $ca25f02f047c9e4f$var$awAppendQuestionmarkOrAmpersand(str) {
    return str + (str.indexOf('?') === -1 ? '?' : '&');
}
window.awAppendQuestionmarkOrAmpersand = $ca25f02f047c9e4f$var$awAppendQuestionmarkOrAmpersand;
function $ca25f02f047c9e4f$var$awReplaceAccents(str) {
    // verifies if the String has accents and replace them
    if (str.search(/[\xC0-\xFF]/g) > -1) str = str.replace(/[\xC0-\xC5]/g, 'A').replace(/[\xC6]/g, 'AE').replace(/[\xC7]/g, 'C').replace(/[\xC8-\xCB]/g, 'E').replace(/[\xCC-\xCF]/g, 'I').replace(/[\xD0]/g, 'D').replace(/[\xD1]/g, 'N').replace(/[\xD2-\xD6\xD8]/g, 'O').replace(/[\xD9-\xDC]/g, 'U').replace(/[\xDD]/g, 'Y').replace(/[\xDE]/g, 'P').replace(/[\xE0-\xE5]/g, 'a').replace(/[\xE6]/g, 'ae').replace(/[\xE7]/g, 'c').replace(/[\xE8-\xEB]/g, 'e').replace(/[\xEC-\xEF]/g, 'i').replace(/[\xF1]/g, 'n').replace(/[\xF2-\xF6\xF8]/g, 'o').replace(/[\xF9-\xFC]/g, 'u').replace(/[\xFE]/g, 'p').replace(/[\xFD\xFF]/g, 'y');
    return str;
}
window.awReplaceAccents = $ca25f02f047c9e4f$var$awReplaceAccents;
function $ca25f02f047c9e4f$var$awRemoveNonWord(str) {
    return str.replace(/[^0-9a-zA-Z\xC0-\xFF \-]/g, '');
}
window.awRemoveNonWord = $ca25f02f047c9e4f$var$awRemoveNonWord;
function $ca25f02f047c9e4f$var$awSlugify(str, delimeter) {
    if (!delimeter) delimeter = '-';
    str = $ca25f02f047c9e4f$var$awReplaceAccents(str);
    str = $ca25f02f047c9e4f$var$awRemoveNonWord(str);
    str = str.trim().replace(/ +/g, delimeter).toLowerCase();
    return str;
}
window.awSlugify = $ca25f02f047c9e4f$var$awSlugify;
function $ca25f02f047c9e4f$var$awToLowercaseAndDashes(str) {
    return str.replace(/\s+/g, '-').toLowerCase();
}
window.awToLowercaseAndDashes = $ca25f02f047c9e4f$var$awToLowercaseAndDashes;
(function($1) {
    $1.holdReady(false);
})(jQuery);
if (window.aw) window.awLoggedIn = Cookies.get(aw.user_cookie_name) ? true : false;
function $ca25f02f047c9e4f$var$awGetUserType() {
    if ($ca25f02f047c9e4f$var$awGetUserData()) return $ca25f02f047c9e4f$var$awGetUserData().sub_type;
}
window.awGetUserType = $ca25f02f047c9e4f$var$awGetUserType;
function $ca25f02f047c9e4f$var$awGetCountryInfo(countryNameOrCode) {
    let userCountry = {};
    for(let i = 0; i < aw.countries.length; i++)if (countryNameOrCode === aw.countries[i].code_alpha_2 || countryNameOrCode === aw.countries[i].code_cw || aw.countries[i].names.indexOf(countryNameOrCode) !== -1) {
        userCountry = aw.countries[i];
        break;
    }
    return userCountry;
}
window.awGetCountryInfo = $ca25f02f047c9e4f$var$awGetCountryInfo;
function $ca25f02f047c9e4f$var$awGetUserCurrentTypePaid() {
    if ($ca25f02f047c9e4f$var$awGetUserData()) {
        if ($ca25f02f047c9e4f$var$awGetUserData().curr_type !== 'QN') return true;
        else return false;
    }
}
window.awGetUserCurrentTypePaid = $ca25f02f047c9e4f$var$awGetUserCurrentTypePaid;
function $ca25f02f047c9e4f$var$awGetFileNameFromUrl(url) {
    return url.split('/').pop();
}
window.awGetFileNameFromUrl = $ca25f02f047c9e4f$var$awGetFileNameFromUrl;
function $ca25f02f047c9e4f$var$awValidateForm(form, cb) {
    if (!form || !cb) return false;
    let $form = jQuery(form);
    let $formFields = $form.find(':input');
    let errorMsg = null;
    $formFields.each(function() {
        let $field = jQuery(this), isRequired = !!$field.attr('required'), fieldValue = $field.val() ? $field.val().trim() : '', fieldType = $field.attr('type');
        fieidId = $field.attr('id');
        if (isRequired && fieldValue.length === 0) {
            errorMsg = 'missing_required_value';
            cb(errorMsg);
            return false;
        }
        if (fieldValue && fieidId === 'aw_reg_email') {
            if (!window.isEmail($field.val()) || $field.val().length > 50) {
                errorMsg = 'email_format';
                cb(errorMsg);
                return false;
            }
        }
        if (fieldType === 'tel' && fieldValue) {
            const phoneNumberPattern = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
            if (!phoneNumberPattern.test(fieldValue)) {
                errorMsg = 'phone_number_format';
                cb(errorMsg);
                return false;
            }
        }
    });
    if ($form.find('#aw_reg_job_industry').val() && $form.find('#aw_reg_job_industry').val() === '54' && $form.find('#aw_reg_job_industry_other').val().length === 0 || $form.find('#aw_reg_job_department').val() && $form.find('#aw_reg_job_department').val() === '26' && $form.find('#aw_reg_job_department_other').val().length === 0 || $form.find('#aw_reg_job_level').val() && $form.find('#aw_reg_job_level').val() === '23' && $form.find('#aw_reg_job_level_other').val().length === 0) {
        errorMsg = 'missing_required_value';
        cb(errorMsg);
        return false;
    }
    if (!errorMsg) cb(null);
}
window.awClearForm = function($form) {
    if ($form && $form.length && $form.trigger) $form.trigger('reset');
};
window.awConvertUserData = function(userData) {
    /* Convert user data from forms that uses non-C&W values */ try {
        if (userData['bcode'] && userData['bcode'].length && userData['bcode'].length > 3) window.aw.businessTypes.forEach(function(businessType) {
            if (userData['bcode'].toLowerCase() === businessType.title.toLowerCase()) userData['bcode'] = businessType.code;
        });
        if (userData['btitle'] && userData['btitle'].length && userData['btitle'].length > 3) window.aw.jobLevels.forEach(function(jobLevel) {
            if (userData['btitle'].toLowerCase() === jobLevel.title.toLowerCase()) userData['btitle'] = jobLevel.code;
        });
        if (userData['job_function'] && userData['job_function'].length && userData['job_function'].length > 3) window.aw.jobDepartments.forEach(function(jobDepartment) {
            if (userData['job_function'].toLowerCase() === jobDepartment.title.toLowerCase()) userData['job_function'] = jobDepartment.code;
        });
        window.aw.jobDepartments.forEach(function(jobDepartment) {
            if (userData['job_function'].toLowerCase() === jobDepartment.title.toLowerCase()) userData['job_function'] = jobDepartment.code;
        });
        let awUserCountry = window.awGetCountryInfo(userData['country']);
        userData['country'] = awUserCountry.code_alpha_2;
        userData['country_code'] = awUserCountry.code_cw;
    } catch (err) {
    /* noop */ }
    return userData;
};
window.awValidateForm = $ca25f02f047c9e4f$var$awValidateForm;
function $ca25f02f047c9e4f$var$awChangeTimeZone(date, timeZone) {
    if (typeof date === 'string') return new Date(new Date(date).toLocaleString('en-US', {
        timeZone: timeZone
    }));
    return new Date(date.toLocaleString('en-US', {
        timeZone: timeZone
    }));
}
window.awChangeTimeZone = $ca25f02f047c9e4f$var$awChangeTimeZone;
function $ca25f02f047c9e4f$var$awCalculateArticleTime(postPublishUnixTimestamp) {
    var postDate = new Date(postPublishUnixTimestamp * 1000);
    var currDate = new Date();
    var currDateEst = $ca25f02f047c9e4f$var$awChangeTimeZone(currDate, 'America/New_York');
    var postDateEst = $ca25f02f047c9e4f$var$awChangeTimeZone(postDate, 'America/New_York');
    var currDateEst = new Date(currDateEst);
    var postDateEst = new Date(postDateEst);
    var seconds = (currDateEst.getTime() - postDateEst.getTime()) / 1000;
    seconds = Math.round(seconds);
    var minutes = seconds / 60;
    minutes = Math.round(minutes);
    var hours = minutes / 60;
    hours = Math.round(hours);
    var months = new Array(12);
    months[0] = "January";
    months[1] = "February";
    months[2] = "March";
    months[3] = "April";
    months[4] = "May";
    months[5] = "June";
    months[6] = "July";
    months[7] = "August";
    months[8] = "September";
    months[9] = "October";
    months[10] = "November";
    months[11] = "December";
    var monthValue = postDateEst.getMonth();
    var dayValue = postDateEst.getDate();
    var yearValue = postDateEst.getFullYear();
    postDateEst = months[monthValue] + " " + dayValue + ", " + yearValue;
    var postDateOutput = postDateEst;
    if (seconds < 0) postDateOutput = "Few seconds ago";
    else if (seconds < 60) {
        seconds = String(seconds).substring(0, 2);
        postDateOutput = seconds + " seconds ago";
    } else if (minutes < 60) {
        minutes = String(minutes).substring(0, 2);
        postDateOutput = minutes + " mins ago";
    } else if (hours < 24) postDateOutput = hours + " hours ago";
    else postDateOutput = postDateEst;
    return postDateOutput;
}
window.awCalculateArticleTime = $ca25f02f047c9e4f$var$awCalculateArticleTime;
function $ca25f02f047c9e4f$var$awUpdateArticleTimeOnCategoryPage() {
    const category = document.getElementsByClassName("category");
    if (category.length) {
        const publishTime = document.getElementsByClassName('custom-publish-time');
        if (publishTime) for(let i = 0; i < publishTime.length; i++){
            let postPublishUnixTimestamp = publishTime[i].getAttribute("data-published-time");
            let postTimeOutput = $ca25f02f047c9e4f$var$awCalculateArticleTime(postPublishUnixTimestamp);
            publishTime[i].innerHTML = postTimeOutput;
        }
    }
}
window.awUpdateArticleTimeOnCategoryPage = $ca25f02f047c9e4f$var$awUpdateArticleTimeOnCategoryPage;


"use strict";
(function($) {
    'use strict';
    // $(document).ready(function(){
    $(window).on('load', function() {
        let course_Id;
        let $body = $('body'), $mainContentEl = $('article.main-content');
        if (window.location.hash) {
            if (window.location.hash.indexOf('?') == -1) course_Id = window.location.hash;
            else course_Id = window.location.hash.split('?')[0];
            const courseId = course_Id;
            //const courseId = window.location.hash;
            let $courseModalWrapper = $(courseId);
            if ($courseModalWrapper && $courseModalWrapper.length && $courseModalWrapper.hasClass('aw-modal-wrapper')) awShowModal($courseModalWrapper);
            else {
                let $course = $(`[data-target="${courseId}--modal"]`);
                if ($course && $course.length) {
                    $([
                        document.documentElement,
                        document.body
                    ]).animate({
                        scrollTop: $course.offset().top
                    }, 600);
                    $course.click();
                }
            }
        }
        window.awShowModal = function($modalWrapper) {
            let $overlay = $('.aw-modal-overlay');
            let $article = $('article');
            if (!$overlay || !$overlay.length) {
                $body.append('<div class="aw-modal-overlay hide"></div>');
                $overlay = $('.aw-modal-overlay');
            }
            $body.addClass('aw-modal-visible');
            $mainContentEl.removeClass('main-content');
            $overlay.removeClass('hide');
            $modalWrapper.addClass('aw-modal-visible');
            awUpdateUrlHash($modalWrapper);
        };
        window.awHideModal = function() {
            let $overlay = $('.aw-modal-overlay');
            $overlay.addClass('hide');
            $body.removeClass('aw-modal-visible');
            $mainContentEl.addClass('main-content');
            $('.aw-modal-wrapper').removeClass('aw-modal-visible');
            awUpdateUrlHash();
        };
        window.awUpdateUrlHash = function($modalWrapper) {
            let hash = null;
            if (window.history.replaceState) {
                if ($modalWrapper && $modalWrapper.is(':visible')) {
                    const idAttr = $modalWrapper.attr('id');
                    if (idAttr) hash = `#${idAttr}`;
                } else hash = window.location.pathname + window.location.search;
                window.history.replaceState(null, null, hash);
            }
        };
        $(document).on('click', '.aw-modal-trigger', function(ev) {
            ev.preventDefault();
            let $modalTrigger = $(this);
            let $modalWrapper = $modalTrigger.next('.aw-modal-wrapper');
            awShowModal($modalWrapper);
            return false;
        });
        $(document).on('click', '.aw-modal-overlay', function() {
            awHideModal();
        });
        $(document).keyup(function(e) {
            if (e.key === 'Escape') awHideModal();
        });
        $('.aw-modal-header span').on('click', function() {
            awHideModal();
        });
        $('.aw-modal-close').on('click', function(ev) {
            ev.preventDefault();
            awHideModal();
        });
        $('.ibm-img-alt-trigger').on('click', function() {
            let $modalWrapper = $(this).parent().find('.aw-modal-wrapper');
            awShowModal($modalWrapper);
        });
        if ($('body').hasClass('single-aw_learning')) $('body').append($('.modal'));
        if ($('body').hasClass('user-profile-settings-page')) $('body').append($('.aw-modal-wrapper'));
    });
})(jQuery);


"use strict";
(function($) {
    $(window).on('load', function() {
        'use strict';
        // -------------------------------------------------------
        // LYTICS GETTER / SENDER
        // -------------------------------------------------------
        window.lytics = window.lytics || {};
        window.lytics.fields = window.lytics.fields || {};
        lytics.gatherData = function(form) {
            let $formFields = $(form).find(':input'), formFields = [];
            $formFields.each(function() {
                let $formField = $(this), captureField = true;
                if ($formField && $formField.val()) {
                    let formFieldTagName = $formField.prop('tagName') ? $formField.prop('tagName').toLowerCase() : 'input', formFieldType = $formField.prop('type') ? $formField.prop('type').toLowerCase() : 'text', fieldName = $formField.prop('name');
                    if (fieldName.substring(0, 1) === '_') // System variables for CF7 start with _ so ignore those.
                    captureField = false;
                    if (formFieldType === 'password') // Don't capture password fields.
                    captureField = false;
                    if (captureField) {
                        if (formFieldTagName === 'select') lytics.fields[fieldName] = $formField.find('option:selected').text();
                        else if (formFieldType === 'checkbox') {
                            if ($formField.is(':checked')) lytics.fields[fieldName] = $formField.val();
                        } else if (fieldName === 'company') lytics.fields['company_name'] = $formField.val();
                        else if (fieldName === 'aw_login_email') lytics.fields['email'] = $formField.val();
                        else lytics.fields[fieldName] = $formField.val();
                    }
                }
            });
        };
        lytics.sendData = function(data) {
            if (typeof jstag !== 'undefined') {
                if (data) {
                    if (data.hasOwnProperty('Ip')) lytics.fields.IP = data.Ip;
                    if (data.hasOwnProperty('Domain')) lytics.fields.domain = data.Domain;
                    if (data.hasOwnProperty('Name')) lytics.fields.company_by_ip = data.Name;
                    if (data.hasOwnProperty('Industry')) lytics.fields.industry = data.Industry.join(',');
                    if (data.hasOwnProperty('Size')) lytics.fields.company_size = data.Size.join(',');
                    if (data.hasOwnProperty('IsIsp')) lytics.fields.IsISP = data.IsIsp.toString();
                    if (data.hasOwnProperty('WebsiteUrl')) lytics.fields.website = data.WebsiteUrl;
                    if (data.hasOwnProperty('Phone')) lytics.fields.company_phone = data.Phone;
                    if (data.hasOwnProperty('HQAddress1')) lytics.fields.HQAddress = data.HQAddress1;
                    if (data.hasOwnProperty('HQCity')) lytics.fields.HQCity = data.HQCity;
                    if (data.hasOwnProperty('HQZip')) lytics.fields.HQZip = data.HQZip;
                    if (data.hasOwnProperty('HQState')) lytics.fields.HQState = data.HQState;
                    if (data.hasOwnProperty('HQCountry')) lytics.fields.HQCountry = data.HQCountry;
                    if (data.hasOwnProperty('GeoCity')) lytics.fields.GeoCity = data.GeoCity;
                    if (data.hasOwnProperty('GeoState')) lytics.fields.GeoState = data.GeoState;
                    if (data.hasOwnProperty('GeoCountry')) lytics.fields.GeoCountry = data.GeoCountry;
                    if (data.hasOwnProperty('ParentCompany')) lytics.fields.ParentCompany = data.ParentCompany;
                    if (data.hasOwnProperty('ParentAddress')) lytics.fields.ParentAddress = data.ParentAddress;
                    if (data.hasOwnProperty('ParentCity')) lytics.fields.ParentCity = data.ParentCity;
                    if (data.hasOwnProperty('ParentState')) lytics.fields.ParentState = data.ParentState;
                    if (data.hasOwnProperty('ParentZip')) lytics.fields.ParentZip = data.ParentZip;
                    if (data.hasOwnProperty('ParentCountry')) lytics.fields.ParentCountry = data.ParentCountry;
                    if (data.hasOwnProperty('TickerSymbol')) lytics.fields.TickerSymbol = data.TickerSymbol;
                    if (data.hasOwnProperty('StockExchange')) lytics.fields.StockExchange = data.StockExchange;
                    if (data.hasOwnProperty('Revenue')) lytics.fields.company_revenue = data.Revenue;
                }
                jstag.send(lytics.fields, function(data) {
                    $.each(lytics.fields, function(field) {
                        delete lytics.fields[field];
                    });
                });
            }
        };
        function checkForLyticsModal() {
            if ($('.pf-widget.adweek').length) {
                $('.pf-widget.adweek').find('.pf-widget-cancel').html('No Thanks');
                var popupID = $('.pf-widget-modal.lead-gen:visible').attr('id');
                $('#' + popupID).find('.pf-widget-headline').detach().prependTo($('#' + popupID).find('.pf-widget-body'));
            } else setTimeout(checkForLyticsModal, 400);
        }
        var lyticsTopics = $('meta[name="lytics:topics"]').attr('content');
        lytics.fields.AW_Page_Topic = lyticsTopics;
        let aw_ip_info_data = Cookies.get('aw_ip_info_data');
        if (aw_ip_info_data) try {
            var dataJSON = JSON.parse(aw_ip_info_data);
            if (dataJSON) lytics.sendData(dataJSON);
        } catch (err) {}
        else if (window.aw_ip_info_endpoint) $.ajax({
            type: 'GET',
            url: aw.ip_address_api_url
        }).done(function(data) {
            if (data && data.ip) $.ajax({
                type: 'GET',
                url: '/aw-ip-info',
                data: {
                    ip: data.ip
                }
            }).done(function(data) {
                try {
                    var dataJSON = JSON.parse(data);
                    if (dataJSON) {
                        Cookies.set('aw_ip_info_data', data, {
                            expires: 365
                        });
                        lytics.sendData(dataJSON);
                    }
                } catch (err) {}
            });
        });
        checkForLyticsModal();
        // -------------------------------------------------------
        // LYTICS LEAD GEN FORM FIX / IP ADDRESS
        // -------------------------------------------------------
        $(document).on('mouseover', '.pf-widget-modal.lead-gen', function() {
            $(this).find('.pf-widget-headline').detach().prependTo($(this).find('.pf-widget-body'));
        });
        // -------------------------------------------------------
        // LYTICS TRACKING
        // -------------------------------------------------------
        $('form').on('submit', function() {
            if ($(this).data('ly-track') == undefined || $(this).data('ly-track').toString() !== 'false') {
                if ($(this).hasClass('wpcf7-form')) lytics.gatherData($(this));
                else {
                    lytics.gatherData($(this));
                    lytics.sendData();
                }
            }
        });
        // Send CF7 data to lytics if the mail sent successfully
        $('.wpcf7').on('wpcf7mailsent', function() {
            lytics.sendData();
        });
    });
})(jQuery);


'use strict';
const $d89d3fb1d2fb2b74$var$EXCLUDED_RDT_COOKIE_PATH_KEYWORDS = [
    'subscription',
    'sign-in',
    'signin',
    'login'
];
function $d89d3fb1d2fb2b74$var$getFirstPathSegment(pathname) {
    return pathname.split('/').filter(Boolean)[0] || '';
}
function $d89d3fb1d2fb2b74$var$isExcludedRdtCookiePath(pathname) {
    const firstPathSegment = $d89d3fb1d2fb2b74$var$getFirstPathSegment(pathname);
    return $d89d3fb1d2fb2b74$var$EXCLUDED_RDT_COOKIE_PATH_KEYWORDS.some(function(keyword) {
        return firstPathSegment.indexOf(keyword) !== -1;
    });
}
function $d89d3fb1d2fb2b74$var$shouldSetRdtCookie(body) {
    return !body.classList.contains('ignore-rdt') && !body.classList.contains('login-page') && !body.classList.contains('registration-page') && !$d89d3fb1d2fb2b74$var$isExcludedRdtCookiePath(window.location.pathname);
}
function $d89d3fb1d2fb2b74$var$getPathname(url) {
    try {
        return new URL(url, window.location.origin).pathname;
    } catch (e) {
        return null;
    }
}
function $d89d3fb1d2fb2b74$var$resolveRdtUrl() {
    const rdtQueryString = getParameterByName('rdt');
    let rdtUrl;
    if (rdtQueryString && rdtQueryString.indexOf('learning:') !== -1) rdtUrl = rdtQueryString + '&source=' + getParameterByName('source');
    else rdtUrl = Cookies.get('aw_rdt_url') || 'https://www.adweek.com/';
    rdtUrl = rdtUrl.split('?')[0];
    if (rdtUrl.indexOf('#') > 0) rdtUrl = rdtUrl.split('#')[0];
    return rdtUrl;
}
function $d89d3fb1d2fb2b74$var$updateLoginRegisterLinks(rdtUrl) {
    const loginRegisterLinks = [
        document.getElementById('subscriber-login'),
        document.getElementById('header-subscribe-link'),
        document.querySelector('#aw_create_account > a')
    ].filter(Boolean);
    loginRegisterLinks.forEach(function(link) {
        const oldLinkURL = link.getAttribute('href');
        const newLinkURL = oldLinkURL + (oldLinkURL.indexOf('?') === -1 ? '?' : '&') + 'rdt=' + encodeURI(rdtUrl);
        link.setAttribute('href', newLinkURL + '?ntfData=login');
    });
}
function $d89d3fb1d2fb2b74$var$isCurrentLoginPage() {
    if (typeof window.adw === 'undefined' || typeof window.adw.account_login_url === 'undefined') return false;
    const loginUrlPath = $d89d3fb1d2fb2b74$var$getPathname(window.adw.account_login_url);
    return loginUrlPath !== null && loginUrlPath === window.location.pathname;
}
function $d89d3fb1d2fb2b74$var$redirectToRdtUrlIfNeeded() {
    if (typeof window.awZephrUserData === 'undefined' || window.awZephrUserData.firstName === undefined) return;
    if (!$d89d3fb1d2fb2b74$var$isCurrentLoginPage()) return;
    const rdtUrl = getParameterByName('rdt') || Cookies.get('aw_rdt_url');
    if (!rdtUrl) return;
    const rdtUrlPath = $d89d3fb1d2fb2b74$var$getPathname(rdtUrl);
    if (rdtUrlPath !== null && rdtUrlPath !== window.location.pathname) window.location.href = rdtUrl;
}
window.addEventListener('load', function() {
    const body = document.body;
    if ($d89d3fb1d2fb2b74$var$shouldSetRdtCookie(body)) Cookies.set('aw_rdt_url', window.location.href, {
        expires: 365
    });
    const rdtUrl = $d89d3fb1d2fb2b74$var$resolveRdtUrl();
    $d89d3fb1d2fb2b74$var$updateLoginRegisterLinks(rdtUrl);
});
document.addEventListener('DOMContentLoaded', $d89d3fb1d2fb2b74$var$redirectToRdtUrlIfNeeded);


"use strict";
async function $3a0a61e65a4b48e1$var$getSidebarMarkup({ name: name = '' } = {}) {
    if (name) {
        const url = `${adw.siteurl}/wp-json/wp/v2/widgets/?sidebar=${name}`;
        const widgets = await fetch(url).then((res)=>res?.json?.());
        const markup = widgets?.map((widget)=>widget.rendered).reduce((prev, curr)=>prev + curr, '');
        return markup;
    }
}
function $3a0a61e65a4b48e1$var$getDeferredSidebarsFromMarkup() {
    const sidebarEls = document.querySelectorAll('[data-deferred-sidebar]');
    const sidebars = [
        ...sidebarEls
    ]?.map?.((sidebarEl)=>sidebarEl.dataset.deferredSidebar);
    return {
        sidebars: sidebars,
        sidebarEls: sidebarEls
    };
}
function $3a0a61e65a4b48e1$var$loadDeferredSidebarContents() {
    const { sidebars: sidebars, sidebarEls: sidebarEls } = $3a0a61e65a4b48e1$var$getDeferredSidebarsFromMarkup();
    sidebars.forEach(async (sidebarName, i)=>{
        const sidebarEl = sidebarEls[i];
        const handleIntersect = (entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const loadContent = async ()=>{
                        if (sidebarEl?.dataset?.loaded !== 'true') {
                            sidebarEl.dataset.loaded = 'true';
                            // Load sidebar content when scrolled into view
                            const markup = await $3a0a61e65a4b48e1$var$getSidebarMarkup({
                                name: sidebarName
                            });
                            sidebarEl.innerHTML = markup;
                            const eventSidebarLoaded = new CustomEvent(`sidebarLoaded`, {
                                detail: {
                                    sidebarName: sidebarName
                                }
                            });
                            window.dispatchEvent(eventSidebarLoaded);
                        }
                    };
                    loadContent();
                }
            });
        };
        let observer;
        let options = {
            root: null,
            rootMargin: "300px",
            threshold: [
                0
            ]
        };
        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(sidebarEl);
    });
}
$3a0a61e65a4b48e1$var$loadDeferredSidebarContents();


"use strict";
(function($) {
    $(window).on('load', function() {
        'use strict';
        const oneTrustDoNotSell = document.getElementsByClassName('aw-ot-show-settings')[0];
        if (oneTrustDoNotSell !== undefined) {
            oneTrustDoNotSell.innerHTML = '<!-- OneTrust Cookies Settings button start --> <button id="aw-ot-show-settings" class="ot-sdk-show-settings optanon-show-settings menu-item">Do Not Sell My Personal Information</button> <!-- OneTrust Cookies Settings button end -->';
            const awOneTrustButton = document.getElementById('aw-ot-show-settings');
            const awOneTrustButtonStyles = 'background: none; outline:none; color: #fff; text-transform: none; font-weight: 500; font-family: "Flama-Book","Helvetica Neue",Helvetica,Roboto,Arial,sans-serif; font-size: 16px; line-height: 22px; position: relative; bottom: 10px;';
            awOneTrustButton !== undefined && (awOneTrustButton.style.cssText = awOneTrustButtonStyles);
        }
    });
})(jQuery);


"use strict";
(function($) {
    $(window).on('load', function() {
        'use strict';
        $('.credsparkQuiz').attr('data-uuid', 'user-' + Date.now());
        window.addEventListener('message', function(event) {
            var lyticsProperty;
            if (event.origin === 'https://www.credspark.com') {
                if (typeof event.data.embeddedRegistration !== 'undefined') {
                    for(var propertyName in event.data.embeddedRegistration.formData){
                        // Reset lyticsProperty variable so it doesn't overwrite the previous one
                        lyticsProperty = '';
                        // if substring (3333) = data field -> add to lytics fields to send
                        if (typeof $('.credsparkQuiz').data(propertyName.substring(25, 29)) !== 'undefined') lyticsProperty = $('.credsparkQuiz').data(propertyName.substring(25, 29));
                        else if (propertyName.indexOf('user') === 0) lyticsProperty = propertyName.replace('user[', '').replace(']', '');
                        lytics.fields[lyticsProperty] = event.data.embeddedRegistration.formData[propertyName];
                    }
                    // Send credspark form data to lytics
                    lytics.sendData();
                }
            }
        });
    });
})(jQuery);


"use strict";
(function() {
    function processDeferredInlineScripts() {
        document.querySelectorAll('script[type="text/javascript/deferred"]').forEach(function(deferred) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.textContent = deferred.innerHTML;
            document.head.appendChild(script);
        });
        document.dispatchEvent(new CustomEvent('aw-inline-scripts-proccessed', {
            bubbles: true
        }));
    }
    // Run via setTimeout, not right away, so the rest of the bundle finishes first.
    // The deferred scripts set window.adw.posts.* (e.g. the "load more" init), which
    // isn't defined yet when this file runs. Waiting a tick lets it exist first.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(processDeferredInlineScripts, 0);
        });
        return;
    }
    setTimeout(processDeferredInlineScripts, 0);
})();


"use strict";
(function($) {
    'use strict';
    if (typeof Awesomplete !== 'undefined') {
        let companyNameInputFields = document.getElementsByName('company'), awesompleteInputs = [];
        if (companyNameInputFields && companyNameInputFields.length > 0) for(var i = 0, j = companyNameInputFields.length; i < j; i++)(function(i) {
            awesompleteInputs[i] = new Awesomplete(companyNameInputFields[i], {
                minChars: 2,
                filter: Awesomplete.FILTER_STARTSWITH,
                maxItems: screen && screen.width <= 768 ? 5 : 10,
                list: []
            });
            companyNameInputFields[i].addEventListener('input', function(ev) {
                if (this.value && this.value.length > 1) {
                    let currAwesompleteInput = awesompleteInputs[i];
                    $.getJSON(`/wp-json/company-list/v1/companies?search=${this.value}`, function(companies) {
                        currAwesompleteInput.list = companies;
                        currAwesompleteInput.evaluate();
                    });
                }
            });
        })(i);
        let billingCompanyNameInputFields = document.getElementsByName('billing-company'), awesompletebillingCompanyInputs = [];
        if (billingCompanyNameInputFields && billingCompanyNameInputFields.length > 0) for(var i = 0, j = billingCompanyNameInputFields.length; i < j; i++)(function(i) {
            awesompletebillingCompanyInputs[i] = new Awesomplete(billingCompanyNameInputFields[i], {
                minChars: 2,
                filter: Awesomplete.FILTER_STARTSWITH,
                maxItems: screen && screen.width <= 768 ? 5 : 10,
                list: []
            });
            billingCompanyNameInputFields[i].addEventListener('input', function(ev) {
                if (this.value && this.value.length > 1) {
                    let currbillingCompanyAwesompleteInput = awesompletebillingCompanyInputs[i];
                    $.getJSON(`/wp-json/company-list/v1/companies?search=${this.value}`, function(companies) {
                        currbillingCompanyAwesompleteInput.list = companies;
                        currbillingCompanyAwesompleteInput.evaluate();
                    });
                }
            });
        })(i);
    }
})(jQuery);


"use strict";
(function($) {
    'use strict';
    $(document).ready(function() {
        let userData = window.awGetUserData(), userCookie = window.awGetUserCookie();
        if (userData && userData.e_mail && userCookie && userCookie.api_guid && userCookie.acc_check && userCookie.acc_check_cw) {
            if ($('.secondary-navigation a[href*="f=custcare"]').length > 0) {
                if (!userCookie.sub_type || userCookie.sub_type == "R") $('.secondary-navigation a[href*="f=custcare"]').remove();
                if ($('.secondary-navigation a[href*="f=custcare"]').length > 0) $('.secondary-navigation a[href*="f=custcare"]').each(function() {
                    let subscriptionURL = $(this).attr('href');
                    if (subscriptionURL && subscriptionURL.indexOf('?') === -1) subscriptionURL += '?';
                    else subscriptionURL += '&';
                    // cwRedirectURL += 'cg=' + userCookie.acc_check_cw + encodeURI( '|' ) + userCookie.api_guid.replace(/-/g,'' );
                    subscriptionURL += 'cg=' + userCookie.acc_check_cw + '|' + userCookie.api_guid.replace(/-/g, '');
                    $(this).attr('href', subscriptionURL);
                });
            }
        }
    });
})(jQuery);


"use strict";
(function($) {
    'use strict';
    $(window).on("load", function() {
        let userReg = localStorage.getItem("user_reg");
        if (typeof userReg !== "undefined" && userReg == "complete_reg" && typeof kwa !== "undefined") {
            localStorage.removeItem("user_reg");
            kwa('sendFBEvent', 'CompleteRegistration');
        }
    });
})(jQuery);


"use strict";
jQuery(document).ready(function() {
    if (jQuery("#aw_login_pwd").length) jQuery('#aw_login_pwd').keypress(function(event) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode == '13') jQuery('#aw_login_button').click();
    });
    if (jQuery("#aw_login_email").length) jQuery('#aw_login_email').keypress(function(event) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode == '13') setTimeout(function() {
            jQuery('#aw_login_pwd').click();
            jQuery("#aw_login_pwd").focus();
            jQuery("#aw_login_pwd").select();
        }, 500);
    });
});


"use strict";
(function($) {
    'use strict';
    $(window).on('load', function() {
        let user = awGetUserCookie();
        if (user.sub_type === 'S') $('.issue-section-wrap .aw-issue-message a').css('display', 'none');
    });
})(jQuery);


"use strict";
jQuery(function() {
    if ($('.sustainability-overview').length > 0) $('body').addClass('cmo-sustainability-page');
    if ($('.cmo-sustainability-page #front-hero').length > 0) $('.cmo-sustainability-page #front-hero').siblings('p').hide();
});


"use strict";
document.addEventListener('userLoggedIn', function(event) {
    var dynamicPath = downloadReceipt.download_receipt_script_path;
    var script = document.createElement('script');
    script.src = dynamicPath;
    document.head.appendChild(script);
});
awUserLoggedInEvent();


"use strict";
/**
 * Contextual Greeting JavaScript
 * Handles client-side processing of greeting placeholders
 */ (function($) {
    'use strict';
    /**
   * Get time-based greeting
   * @param {number} hour Optional hour (0-23), defaults to current hour
   * @return {string} Greeting based on time of day
   */ function getTimeBasedGreeting(hour = null) {
        if (hour === null) hour = new Date().getHours();
        if (hour >= 5 && hour < 12) return 'Good morning';
        else if (hour >= 12 && hour < 17) return 'Good afternoon';
        else if (hour >= 17 && hour < 22) return 'Good evening';
        else return 'Good evening'; // Late night
    }
    /**
   * Get user name from localStorage and convert to camelCase
   * @return {string} User name in camelCase or empty string if not logged in
   */ function getUserName() {
        let user_name = '';
        // Try to get user data from localStorage (same as navigation)
        if (typeof window.awGetUserData === 'function') {
            const user_data = window.awGetUserData();
            console.log('Contextual Greeting Debug - User data:', user_data);
            if (user_data && user_data.f_name && user_data.f_name.trim() !== '') {
                user_name = user_data.f_name;
                console.log('Contextual Greeting Debug - Found user name:', user_name);
            } else console.log('Contextual Greeting Debug - No user name found in user_data');
        } else console.log('Contextual Greeting Debug - awGetUserData function not available');
        // Convert to camelCase if we have a name
        if (user_name) {
            user_name = user_name.charAt(0).toUpperCase() + user_name.slice(1).toLowerCase();
            console.log('Contextual Greeting Debug - Formatted user name:', user_name);
        }
        return user_name;
    }
    /**
   * Process greeting placeholders in content
   * @param {string} content The content to process
   * @return {string} Processed content
   */ function processGreetingPlaceholders(content) {
        if (!content) return content;
        const greeting = getTimeBasedGreeting();
        const user_name = getUserName();
        console.log('Contextual Greeting Debug - Processing content with greeting:', greeting, 'and user_name:', user_name);
        // Replace {{{contextualGreeting}}} with greeting + name if logged in, or just greeting if not
        let contextual_greeting = '';
        if (user_name) {
            // Create a styled link for the user name with exclamation point
            const nameLink = `<a href="/user-profile-settings/" style="color: var(--bs-body-color); font-family: Geist; font-weight: 700; font-size: inherit; line-height: inherit; letter-spacing: 0; text-decoration: none; display: inline; padding-bottom: 1px; border-bottom: 2px solid #F53C60; background: none; text-transform: none; transition: color 0.2s;">${user_name}!</a>`;
            contextual_greeting = `${greeting}, ${nameLink}`;
        } else contextual_greeting = greeting + '!';
        console.log('Contextual Greeting Debug - Final contextual greeting:', contextual_greeting);
        content = content.replace(/\{\{\{contextualGreeting\}\}\}/g, contextual_greeting);
        // Replace {{{greeting}}} with time-based greeting
        content = content.replace(/\{\{\{greeting\}\}\}/g, greeting);
        // Replace {{{greetingWithName}}} with full greeting including name
        let full_greeting = '';
        if (user_name) {
            // Create a styled link for the user name with exclamation point
            const nameLink = `<a href="/user-profile-settings/" style="color: var(--bs-body-color); font-family: Geist; font-weight: 700; font-size: inherit; line-height: inherit; letter-spacing: 0; text-decoration: none; display: inline; padding-bottom: 1px; border-bottom: 2px solid #F53C60; background: none; text-transform: none; transition: color 0.2s;">${user_name}!</a>`;
            full_greeting = `${greeting}, ${nameLink}`;
        } else full_greeting = greeting + '!';
        content = content.replace(/\{\{\{greetingWithName\}\}\}/g, full_greeting);
        // Replace {{{userName}}} with user name (only if user is logged in)
        if (user_name) {
            // Create a styled link for the user name with exclamation point
            const nameLink = `<a href="/user-profile-settings/" style="color: var(--bs-body-color); font-family: Geist; font-weight: 700; font-size: inherit; line-height: inherit; letter-spacing: 0; text-decoration: none; display: inline; padding-bottom: 1px; border-bottom: 2px solid #F53C60; background: none; text-transform: none; transition: color 0.2s;">${user_name}!</a>`;
            content = content.replace(/\{\{\{userName\}\}\}/g, nameLink);
        } else // Remove the placeholder if no user name
        content = content.replace(/\{\{\{userName\}\}\}/g, '');
        // Replace {{{greetingOnly}}} with greeting without name
        content = content.replace(/\{\{\{greetingOnly\}\}\}/g, greeting + '!');
        return content;
    }
    /**
   * Split text into words and wrap them for streaming animation
   * @param {string} text The text to split
   * @return {string} HTML with wrapped words
   */ function wrapWordsForStreaming(text) {
        // Create a temporary div to parse HTML properly
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;
        // Get all text nodes and wrap words
        function wrapWordsInNode(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                const words = node.textContent.split(/(\s+)/);
                const fragment = document.createDocumentFragment();
                words.forEach((word)=>{
                    if (word.trim() === '') // Preserve whitespace
                    fragment.appendChild(document.createTextNode(word));
                    else {
                        // Wrap word in span
                        const span = document.createElement('span');
                        span.className = 'streaming-word';
                        span.textContent = word;
                        fragment.appendChild(span);
                    }
                });
                node.parentNode.replaceChild(fragment, node);
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                // Recursively process child nodes
                const childNodes = Array.from(node.childNodes);
                childNodes.forEach((childNode)=>{
                    wrapWordsInNode(childNode);
                });
            }
        }
        // Process all child nodes
        const childNodes = Array.from(tempDiv.childNodes);
        childNodes.forEach((childNode)=>{
            wrapWordsInNode(childNode);
        });
        return tempDiv.innerHTML;
    }
    /**
   * Process all greeting placeholders on the page
   */ function processAllGreetingPlaceholders() {
        $('.contextual-greeting-wrapper').each(function() {
            const $wrapper = $(this);
            // Only process if not already processed
            if ($wrapper.data('greeting-processed') === true) return;
            // Get the content and process it
            let content = $wrapper.html();
            content = processGreetingPlaceholders(content);
            // Wrap words for streaming animation
            const $tempDiv = $('<div>').html(content);
            const $paragraph = $tempDiv.find('p');
            if ($paragraph.length > 0) {
                $paragraph.html(wrapWordsForStreaming($paragraph.html()));
                content = $tempDiv.html();
            }
            // Update the content but DON'T mark as processed yet
            $wrapper.html(content);
            console.log('Contextual Greeting Debug - Content processed and wrapped for streaming');
        });
    }
    /**
   * Initialize Intersection Observer for streaming animation
   */ function initStreamingAnimation() {
        console.log('Contextual Greeting Debug - Initializing streaming animation');
        if (!('IntersectionObserver' in window)) {
            console.log('Contextual Greeting Debug - IntersectionObserver not supported, using fallback');
            // Fallback for browsers without Intersection Observer
            $('.contextual-greeting-wrapper[data-greeting-processed="false"]').each(function() {
                const $wrapper = $(this);
                console.log('Contextual Greeting Debug - Starting fallback animation for wrapper');
                animateStreamingText($wrapper);
            });
            return;
        }
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const $wrapper = $(entry.target);
                    console.log('Contextual Greeting Debug - Greeting wrapper came into view, starting animation');
                    // Only animate if not already processed
                    if ($wrapper.data('greeting-processed') !== true) animateStreamingText($wrapper);
                    // Stop observing once triggered
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.05,
            rootMargin: '100px'
        });
        // Observe all unprocessed greeting wrappers
        const unprocessedWrappers = $('.contextual-greeting-wrapper[data-greeting-processed="false"]');
        console.log('Contextual Greeting Debug - Found', unprocessedWrappers.length, 'unprocessed greeting wrappers');
        unprocessedWrappers.each(function() {
            observer.observe(this);
        });
    }
    /**
   * Animate text streaming word by word
   * @param {jQuery} $wrapper The wrapper element
   */ function animateStreamingText($wrapper) {
        console.log('Contextual Greeting Debug - Starting streaming animation');
        const $paragraph = $wrapper.find('p');
        const words = $paragraph.find('.streaming-word');
        console.log('Contextual Greeting Debug - Found', words.length, 'words to animate');
        let currentWordIndex = 0;
        // Add streaming class to start animation
        $wrapper.addClass('streaming');
        function revealNextWord() {
            if (currentWordIndex < words.length) {
                const $word = $(words[currentWordIndex]);
                $word.addClass('visible');
                currentWordIndex++;
                // Much faster delays: 5ms to 15ms for instant feel
                const delay = Math.random() * 10 + 5;
                setTimeout(revealNextWord, delay);
            } else {
                // Animation complete, mark as processed but keep text visible
                console.log('Contextual Greeting Debug - Animation complete, marking as processed');
                $wrapper.data('greeting-processed', true);
            // Don't remove streaming class - keep text visible
            }
        }
        // Start the animation immediately
        setTimeout(revealNextWord, 10); // Reduced from 50ms to 10ms
    }
    /**
   * Initialize the contextual greeting system
   */ function initContextualGreeting() {
        // Process placeholders when DOM is ready
        $(document).ready(function() {
            console.log('Contextual Greeting Debug - DOM ready, starting initialization');
            // Only process on homepage
            if (!document.body.classList.contains('home') && !document.body.classList.contains('page-template-home')) {
                console.log('Contextual Greeting Debug - Not on homepage, skipping initialization');
                return;
            }
            // Initial processing
            processAllGreetingPlaceholders();
            // Process again after a short delay to ensure user data is loaded
            setTimeout(function() {
                processAllGreetingPlaceholders();
            }, 200);
            // Process again after 500ms to catch any late-loaded content
            setTimeout(function() {
                processAllGreetingPlaceholders();
            }, 500);
            // Initialize streaming animation
            setTimeout(function() {
                initStreamingAnimation();
                // Fallback: if no wrappers are being observed, start animation immediately
                setTimeout(function() {
                    const unprocessedWrappers = $('.contextual-greeting-wrapper[data-greeting-processed="false"]');
                    console.log('Contextual Greeting Debug - Fallback check: found', unprocessedWrappers.length, 'unprocessed wrappers');
                    if (unprocessedWrappers.length > 0) {
                        console.log('Contextual Greeting Debug - Starting fallback animation for all unprocessed wrappers');
                        unprocessedWrappers.each(function() {
                            const $wrapper = $(this);
                            if ($wrapper.data('greeting-processed') !== true) animateStreamingText($wrapper);
                        });
                    }
                }, 800);
            }, 300);
        });
        // Listen for user login/logout events
        $(document).on('userLoggedIn userLoggedOut', function() {
            // Only process on homepage
            if (!document.body.classList.contains('home') && !document.body.classList.contains('page-template-home')) return;
            // Reset processed state and reprocess
            $('.contextual-greeting-wrapper').data('greeting-processed', false);
            setTimeout(function() {
                processAllGreetingPlaceholders();
                initStreamingAnimation();
            }, 100);
        });
    }
    // Initialize when the script loads
    initContextualGreeting();
})(jQuery);



var $658a109eb070f880$var$_getTaxPostMarkupByTermId = $658a109eb070f880$var$_interopRequireDefault((parcelRequire("17fZ7")));

var $658a109eb070f880$var$_getCustomPostTypePosts = $658a109eb070f880$var$_interopRequireDefault((parcelRequire("8z4U5")));

var $658a109eb070f880$var$_getLatestNewsPostTypePosts = $658a109eb070f880$var$_interopRequireDefault((parcelRequire("bIPzs")));

var $658a109eb070f880$var$_initTabListeners = $658a109eb070f880$var$_interopRequireDefault((parcelRequire("FcAzH")));

var $658a109eb070f880$var$_replaceUrls = $658a109eb070f880$var$_interopRequireDefault((parcelRequire("4ALvx")));
"use strict";

var $ac45f7485926fdb3$var$_getPopularPosts = $ac45f7485926fdb3$var$_interopRequireWildcard((parcelRequire("sP5AJ")));

var $ac45f7485926fdb3$var$_getPopularCategoryPosts = $ac45f7485926fdb3$var$_interopRequireDefault((parcelRequire("fanpF")));

var $ac45f7485926fdb3$var$_getTaxPostsByTermID = $ac45f7485926fdb3$var$_interopRequireDefault((parcelRequire("hk6fp")));

var $ac45f7485926fdb3$var$_initializeRecentPostsTrigger = $ac45f7485926fdb3$var$_interopRequireDefault((parcelRequire("lQefa")));

var $ac45f7485926fdb3$var$_indexItemMarkup = $ac45f7485926fdb3$var$_interopRequireDefault((parcelRequire("9uhuM")));

var $ac45f7485926fdb3$var$_loadMorePopularPosts = $ac45f7485926fdb3$var$_interopRequireDefault((parcelRequire("7PxgL")));
"use strict";

var $f0f9aaf9f127bff4$var$_getPopularPosts = $f0f9aaf9f127bff4$var$_interopRequireDefault((parcelRequire("sP5AJ")));
function $f0f9aaf9f127bff4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/** Populate Popular Now Block with Parsley Data*/ (0, $f0f9aaf9f127bff4$var$_getPopularPosts.default)().then((response)=>{
    if (!response) return;
    const popularPosts = response.data;
    document.querySelectorAll('.callout-list.js-parsely').forEach(function(element) {
        element.querySelectorAll('li').forEach(function(el, index) {
            el.innerHTML = `<a href="${popularPosts[index].url}">${popularPosts[index].title}</a>`;
        });
    });
});


function $ac45f7485926fdb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $ac45f7485926fdb3$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($ac45f7485926fdb3$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
/**
 * Setup a global Parsely helper. 
 */ adw.parsely = {
    fetchPosts: $ac45f7485926fdb3$var$_getPopularPosts.fetchPosts,
    getPopularPosts: $ac45f7485926fdb3$var$_getPopularPosts.default,
    getPopularCategoryPosts: $ac45f7485926fdb3$var$_getPopularCategoryPosts.default,
    getTaxPostsByTermID: $ac45f7485926fdb3$var$_getTaxPostsByTermID.default,
    initializeRecentPostsTrigger: $ac45f7485926fdb3$var$_initializeRecentPostsTrigger.default,
    indexItemMarkup: $ac45f7485926fdb3$var$_indexItemMarkup.default,
    loadMorePopularPosts: $ac45f7485926fdb3$var$_loadMorePopularPosts.default
};


var $4961ba9bbf5d92e4$exports = {};
"use strict";
Object.defineProperty($4961ba9bbf5d92e4$exports, "__esModule", {
    value: true
});
$4961ba9bbf5d92e4$exports.getVerticalTermIndexItemMarkup = $4961ba9bbf5d92e4$var$getVerticalTermIndexItemMarkup;

var $9YTZb = parcelRequire("9YTZb");
async function $4961ba9bbf5d92e4$var$getVerticalTermIndexItemMarkup(termId, offset, numPosts) {
    const queryObj = {
        "orderby": "date",
        "order": "DESC",
        "post_type": [
            "post",
            "sponsored_post"
        ],
        "offset": offset,
        "posts_per_page": numPosts,
        "tax_query": [
            {
                "taxonomy": "vertical",
                "field": "term_id",
                "terms": termId
            }
        ]
    };
    const queryParam = encodeURIComponent(JSON.stringify(queryObj));
    try {
        const res = await (0, $9YTZb.getQueryMarkup)(queryParam, 'index_item');
        const body = await res.json();
        return body.markup;
    } catch (e) {
        console.error('Developer message: Error in fetching vertical term data with index item markup: ' + e);
        throw e;
    }
}



var $658a109eb070f880$var$_replaceWithMarkup = $658a109eb070f880$var$_interopRequireDefault((parcelRequire("l4PXi")));
var $ec308880fa023191$exports = {};
"use strict";
Object.defineProperty($ec308880fa023191$exports, "__esModule", {
    value: true
});
$ec308880fa023191$exports.getAllTerms = $ec308880fa023191$var$getAllTerms;
async function $ec308880fa023191$var$getAllTerms(taxonomy) {
    const url = `${window.location.origin}/wp-json/adw/v1/terms/${taxonomy}`;
    try {
        const res = await fetch(url);
        return await res;
    } catch (e) {
        console.error(`Developer message: Error in fetching all the terms for ${taxonomy} taxonomy: ` + e);
        throw e;
    }
}



var $kNwsr = parcelRequire("kNwsr");

var $658a109eb070f880$var$_isProbablyGooglebot = $658a109eb070f880$var$_interopRequireDefault((parcelRequire("datGA")));
"use strict";
const $9fcfb4c811e58ffa$var$React = window.React;
const $9fcfb4c811e58ffa$var$ReactDOM = window.ReactDOM;
const $9fcfb4c811e58ffa$var$createRoot = $9fcfb4c811e58ffa$var$ReactDOM?.client?.createRoot;
if (!$9fcfb4c811e58ffa$var$createRoot) console.warn('Failed to load sidebar script');
const $9fcfb4c811e58ffa$var$HIDDEN_WIDGET_CLASS = 'adw-sidebar-widget-hidden';
const $9fcfb4c811e58ffa$var$COLLAPSE_ENABLED_PROPERTY = '--adw-article-sidebar-collapse-enabled';
const $9fcfb4c811e58ffa$var$RESIZE_DEBOUNCE_MS = 100;
function $9fcfb4c811e58ffa$var$initializeSidebarHeightAdjuster() {
    function SidebarShowMore({ onExpand: onExpand }) {
        return /*#__PURE__*/ $9fcfb4c811e58ffa$var$React.createElement("div", {
            className: "position-absolute bottom-0 w-100 d-flex justify-content-center align-items-end align-content-end flex-wrap",
            style: {
                background: 'linear-gradient(to top, var(--bs-body-bg), var(--bs-body-bg) 10%, transparent 100%)',
                height: '200px'
            }
        }, /*#__PURE__*/ $9fcfb4c811e58ffa$var$React.createElement("button", {
            type: "button",
            onClick: onExpand,
            className: "btn-sidebar-show-more btn rounded-pill btn-outline-primary align-self-center"
        }, "Show More"));
    }
    function getSidebarWidgets(elSidebar) {
        return Array.from(elSidebar.children).filter((elChild)=>elChild.classList.contains('widget-wrapper'));
    }
    function getStickyAdWidget(widgets) {
        const lastWidget = widgets[widgets.length - 1];
        return lastWidget && (lastWidget.classList.contains('adw-sticky-widget') || lastWidget.classList.contains('widget-adweek-sticky-next')) ? lastWidget : null;
    }
    const isSinglePost = document.querySelector('body.single-post');
    if (!isSinglePost || !$9fcfb4c811e58ffa$var$createRoot) return;
    const articleBody = document.querySelector('#article .layout-left-col');
    if (!articleBody) return;
    const articleSidebar = document.querySelector('#article .sidebar');
    if (!articleSidebar) return;
    const widgets = getSidebarWidgets(articleSidebar);
    if (!widgets.length) return;
    const stickyAdWidget = getStickyAdWidget(widgets);
    const widgetHeights = new WeakMap();
    let isExpanded = false;
    articleSidebar.classList.add('position-relative');
    const showMoreHost = document.createElement('div');
    showMoreHost.classList.add('adw-sidebar-show-more', 'position-relative', 'w-100', 'z-1', 'd-none');
    if (stickyAdWidget) stickyAdWidget.insertAdjacentElement('beforebegin', showMoreHost);
    else articleSidebar.insertAdjacentElement('beforeend', showMoreHost);
    const showMoreRoot = $9fcfb4c811e58ffa$var$createRoot(showMoreHost);
    function cacheVisibleWidgetHeights() {
        widgets.forEach((elWidget)=>{
            if (!elWidget.classList.contains($9fcfb4c811e58ffa$var$HIDDEN_WIDGET_CLASS)) widgetHeights.set(elWidget, elWidget.offsetHeight);
        });
    }
    function getRowGap() {
        const rowGap = window.getComputedStyle(articleSidebar).rowGap;
        const parsedRowGap = Number.parseFloat(rowGap);
        return Number.isNaN(parsedRowGap) ? 0 : parsedRowGap;
    }
    function getHiddenWidgets(articleBodyHeight) {
        const rowGap = getRowGap();
        const nonStickyWidgets = widgets.filter((widget)=>widget !== stickyAdWidget);
        const visibleWidgets = new Set(widgets);
        let visibleWidgetsHeight = widgets.reduce((totalHeight, widget)=>totalHeight + (widgetHeights.get(widget) || 0), 0);
        const expandedSidebarHeight = visibleWidgetsHeight + rowGap * Math.max(widgets.length - 1, 0);
        if (expandedSidebarHeight <= articleBodyHeight) return [];
        const hideableWidgets = nonStickyWidgets.slice(1).reverse();
        for (const widget of hideableWidgets){
            const collapsedSidebarHeight = visibleWidgetsHeight + rowGap * visibleWidgets.size;
            if (collapsedSidebarHeight <= articleBodyHeight) break;
            visibleWidgets.delete(widget);
            visibleWidgetsHeight -= widgetHeights.get(widget) || 0;
        }
        return widgets.filter((widget)=>!visibleWidgets.has(widget));
    }
    function applyHiddenWidgets(hiddenWidgets) {
        const hiddenWidgetSet = new Set(hiddenWidgets);
        widgets.forEach((widget)=>{
            widget.classList.toggle($9fcfb4c811e58ffa$var$HIDDEN_WIDGET_CLASS, hiddenWidgetSet.has(widget));
        });
    }
    function renderShowMore(shouldRender) {
        showMoreHost.classList.toggle('d-none', !shouldRender);
        showMoreRoot.render(shouldRender ? /*#__PURE__*/ $9fcfb4c811e58ffa$var$React.createElement(SidebarShowMore, {
            onExpand: expandArticleSidebar
        }) : null);
    }
    function resetArticleSidebar() {
        applyHiddenWidgets([]);
        renderShowMore(false);
    }
    function expandArticleSidebar() {
        isExpanded = true;
        resetArticleSidebar();
    }
    function isCollapseEnabled() {
        return window.getComputedStyle(articleSidebar).getPropertyValue($9fcfb4c811e58ffa$var$COLLAPSE_ENABLED_PROPERTY).trim() === '1';
    }
    function syncArticleSidebar() {
        cacheVisibleWidgetHeights();
        if (!isCollapseEnabled() || isExpanded) {
            resetArticleSidebar();
            return;
        }
        const hiddenWidgets = getHiddenWidgets(articleBody.offsetHeight);
        applyHiddenWidgets(hiddenWidgets);
        renderShowMore(hiddenWidgets.length > 0);
    }
    const scheduleArticleSidebarSync = window.debounce(syncArticleSidebar, $9fcfb4c811e58ffa$var$RESIZE_DEBOUNCE_MS);
    const resizeObserver = new ResizeObserver(scheduleArticleSidebarSync);
    resizeObserver.observe(articleSidebar);
    resizeObserver.observe(articleBody);
    syncArticleSidebar();
}
window.addEventListener('load', $9fcfb4c811e58ffa$var$initializeSidebarHeightAdjuster, {
    once: true
});


function $658a109eb070f880$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Internal and External Imports
 *
 * Add your third party vendor imports near the top of the file,
 * and adweek assets underneath.
 */ // import adw from 'adw';
//import './custom/file-script-load'
// Init BS modals
function $658a109eb070f880$var$initBSModals() {
    const bsModal = document.querySelectorAll('.modal');
    if (bsModal.length) bsModal.forEach((modal)=>{
        const bs = new $658a109eb070f880$var$_modal.default(modal, {
            backdrop: 'static',
            keyboard: false
        });
    });
}
window.addEventListener('DOMContentLoaded', function() {
    $658a109eb070f880$var$initBSModals();
});
window.adw.is_probably_googlebot = (0, $658a109eb070f880$var$_isProbablyGooglebot.default)();
// Dev helper for force reloading the cache
window.refresh = (_)=>location.reload(true);
// Setup global helpers
window.adw.posts = {
    getVerticalTermIndexItemMarkup: $4961ba9bbf5d92e4$exports.getVerticalTermIndexItemMarkup,
    getTaxPostMarkupByTermId: $658a109eb070f880$var$_getTaxPostMarkupByTermId.default,
    getCustomPostTypePosts: $658a109eb070f880$var$_getCustomPostTypePosts.default,
    getLatestNewsPostTypePosts: $658a109eb070f880$var$_getLatestNewsPostTypePosts.default,
    getPostsMarkupByIDs: $kNwsr.getPostsMarkupByIDs
};
window.adw.terms = {
    getAllTerms: $ec308880fa023191$exports.getAllTerms
};
window.adw.utils = {
    initTabListeners: $658a109eb070f880$var$_initTabListeners.default,
    replaceUrls: $658a109eb070f880$var$_replaceUrls.default,
    replaceWithMarkup: $658a109eb070f880$var$_replaceWithMarkup.default
};
console.log("%cLoading top.js", "color: yellow; font-style: italic; background-color: blue;padding: 2px");

})();
//# sourceMappingURL=index.js.map
